(function(){

    /** setup route provider **/
    SUGApp.config(['$routeProvider', function ($routeProvider) {
        return $routeProvider
            .when('/', {
                controller : 'signupController',
                templateUrl : '/view/templates/signups/signuppage.html',
                resolve : {
                    /* get the urlkey from the path, since it is before the angular route, we need to parse window.location.pathname to get it
                     * url is expected to be in the form: [protocol]://[hostname]/org/urlkey
                     */
                    urlparts: ['signupPageService',function(svc){
                        //Make an array of the URL pieces for use by the other resolve functions.
                        //Note: setUrlParts strips out an empty first value IF there is one.
                        var urlparts = window.location.pathname.split('/');
                        svc.setUrlParts(urlparts);
                        return urlparts;
                    }],
                    urlkey: ['signupPageService',function(svc){
                        var urlparts = svc.getUrlParts();
                        var urlkey = '';

                        //Old URL Format: Last element in url parts array is index.cfm...
                        if( urlparts[urlparts.length-1] == 'index.cfm'){
                            var params = utility.getAllUrlParams();

                            //For an old style URL, convert the params to a URLparts array so other elements get set correctly
                            svc.convertParamsToUrlParts(params);
                            urlparts = svc.getUrlParts();

                            if( typeof params.urlid !== 'undefined' ){
                                urlkey = params.urlid;
                                svc.setUrlKey(urlkey);
                                return urlkey;
                            }
                        } else {
                            //New Url Format: 2nd element in the Array should be the urlId for either /go/ or /tabs/
                            for( var p=0, end=urlparts.length; p<end; p++){
                                var part = urlparts[p].toString().toLowerCase();
                                if(part == 'go'){
                                    urlkey = urlparts[p+1].toString();
                                    svc.setUrlKey(urlkey);
                                    return urlkey;

                                } else if(part == 'tabs'){
                                    // if viewing a tab group, cache tab group urlid, but DO NOT return it.
                                    // Urlkey needs to be the sign up's urlid. We will retrieve that later for the signup.
                                    var tgUrlkey = urlparts[p+1].toString();
                                    svc.setTabGroupUrlKey(tgUrlkey);
                                    break;
                                }
                            }
                        }
                    }],
                    previewMode: function(){ return false; },
                    portalid: ['signupPageService',function(svc){
                        //if we come from an embedded Portal, store its urlKey
                        var urlparts = svc.getUrlParts();
                        var pid = null;
                        //find the urlkey value (PortalUrlKey) and return it
                        for( var p=0, end=urlparts.length; p<end; p++){
                            if(urlparts[p].toString().toLowerCase() == 'pid'){
                                pid = urlparts[p+1];
                                svc.setPortalId( pid );
                                break;
                            }
                        }
                        return pid;
                    }],
                    tabgroup : ['signupPageService',function(svc){
                        var tabgroupkey = svc.getTabGroupUrlKey();
                        if( tabgroupkey ){
                            var urlparams = {urlid:tabgroupkey};
                            return svc.gettabgroup(urlparams);
                        }else{
                            return {};
                        }
                    }],
                    memberinfo : ['signupPageService','memberInfoService',function(svc,misvc){
                        var urlkey = svc.getUrlKey();
                        // If we are viewing the /tabs/urlid path, the urlkey will be blank so we want to just return an empty object. We will run the s.getSignupInfo call after the tabGroup data resolve has completed and we have parse the information for the correct signup out of it
                        if (urlkey.length) {
                            var memInfo = svc.getMemberInfo();
                            if (angular.equals(memInfo,{})) {
                                urlkey = svc.getUrlKey();
                                return misvc.getMemberInfo(true, false, 0, urlkey);
                            } else {
                                return memInfo;
                            }
                        } else {
                            return {};
                        }
                    }],
                    signup : ['signupPageService',function(svc){
                        var urlkey = svc.getUrlKey();
                        var portalid = svc.getPortalId();
                        // If we are viewing the /tabs/urlid path, the urlkey will be blank so we want to just return an empty object. We will run the s.getSignupInfo call after the tabGroup data resolve has completed and we have parse the information for the correct signup out of it
                        if (urlkey.length) {
                            var urlparams = {forSignUpView:true, urlid:urlkey , portalid: portalid };
                            return svc.getsignup(urlparams);
                        } else {
                            return {};
                        }
                    }],
                    theme : ['signupPageService',function(svc){
                        var urlkey = svc.getUrlKey();

                        // if we have a themeoverride query param, use that theme instead of the one on the signup
                        var qryParams = new URLSearchParams(window.location.search);
                        if( qryParams.has('themeoverride') ){      
                            svc.setCustomThemeId( qryParams.get('themeoverride') );
                            return svc.getSignupTheme({
                                urlID:urlkey, 
                                themeID:qryParams.get('themeoverride'), 
                            });                        
                        }else{
                            // If we are viewing the /tabs/urlid path, the urlkey will be blank so we want to just return an empty object. We will run the s.getSignUpThemeByUrlId call after the tabGroup data resolve has completed and we have parse the information for the correct signup out of it
                            if (urlkey.length) {
                                return svc.gettheme({urlid:urlkey});
                            } else {
                                return {};
                            }
                        }
                    }],
                    p: ['$route',function($route){
                        return $route.current.params;
                    }]
                }
            })
            .when('/form/:type*', {
                //controller: 'signUpFormController',  
                templateUrl: function( signuptype ){
                    if( signuptype.type === 'rsvp' ){
                        return '/view/templates/signups/form/signupformrsvp.html';
                    }
                    return '/view/signups/dspSignupFormR4.html';
                },
                resolve : {
                    /* get the urlkey from the path, since it is before the angular route, we need to parse window.location.pathname to get it
                     * url is expected to be in the form: [protocol]://[hostname]/org/urlkey
                     */
                    urlkey: ['signupPageService',function(svc){
                        var urlkey = svc.getUrlKey();
                        if (!urlkey) {
                            urlkey = window.location.pathname.split('/').pop();
                            svc.setUrlKey(urlkey);
                        }
                        return urlkey;
                    }]
                }
            })
            .when('/preview/:signupid/:previewDate?', {
                controller : 'signupController',
                templateUrl : '/view/templates/signups/signuppage.html',
                resolve : {
                    previewMode: function(){
                        /**
                         * In preview mode:
                         * 1. Disable all links in the header & footer
                         * 2. Hide the admin toolbar and some marketing elements
                         */
                        var previewModeStyles = angular.element(`
                            <style type='text/css'>
                                div.supHeader a, div.sub-footer a { pointer-events: none; cursor: default; }
                                div.admintoolbar, section.mktg-area { display: none !important; }
                            </style>
                        `);
                        angular.element(document).find('head').append(previewModeStyles);
                        return true;
                    },
                    portalid: ['signupPageService',function(svc){
                        //if we come from an embedded Portal, store its urlKey
                        var urlparts = svc.getUrlParts();
                        var pid = null;
                        //find the urlkey value (PortalUrlKey) and return it
                        for( var p=0, end=urlparts.length; p<end; p++){
                            if(urlparts[p].toString().toLowerCase() == 'pid'){
                                pid = urlparts[p+1];
                                svc.setPortalId( pid );
                                break;
                            }
                        }
                        return pid;
                    }],
                    tabgroup : ['signupPageService',function(svc){
                        var tabgroupkey = svc.getTabGroupUrlKey();
                        var urlparams = {urlid:tabgroupkey};
                        return svc.gettabgroup(urlparams);
                    }],
                    memberinfo : ['$route','signupPageService','memberInfoService',function($route,svc,misvc){
                        var signupid = $route.current.params.signupid;
                        if (signupid.length) {
                            var memInfo = svc.getMemberInfo();
                            if (angular.equals(memInfo,{})) {
                                return misvc.getMemberInfo(true, false, signupid);
                            } else {
                                return memInfo;
                            }
                        } else {
                            return {};
                        }
                    }],
                    signup : ['$route','signupPageService',function($route,signupPageService){
                        var signupid = $route.current.params.signupid;
                        var previewDate = $route.current.params.previewDate;

                        if (signupid.length) {
                            var urlparams = {forSignUpView:true, listid:signupid, };
                            // if we have a preview date, include it
                            if( previewDate )
                                urlparams.viewDate = previewDate;

                            return signupPageService.getsignup(urlparams);
                        } else {
                            return {};
                        }
                    }],
                    theme : ['$route', 'signupPageService', function($route,signupPageService){
                        var signupid = $route.current.params.signupid;
                        // If we are viewing the /tabs/urlid path, the urlkey will be blank so we want to just return an empty object. We will run the s.getSignUpThemeByUrlId call after the tabGroup data resolve has completed and we have parse the information for the correct signup out of it
                        if (signupid.length) {
                            return signupPageService.getSignupTheme({listid:signupid});
                        } else {
                            return {};
                        }
                    }],
                    p: ['$route',function($route){
                        return $route.current.params;
                    }]
                }
            })
            .otherwise({
                redirectTo: '/'
            });
    }]);

    SUGApp.controller('signupController',
        ['$scope','$rootScope','SUGUtilities','signupPageService','adService','$filter','errorService','$sce','$timeout','$window','$modal','$location','$q','memberinfo','signup','theme','p','tabgroup','$route','memberInfoService','portalid','previewMode','$anchorScroll','$location','loginfactory',
        function( $scope,$rootScope,util,svc,adSvc,$filter,errorService,sce,$timeout,$window,$modal,$location,$q,memberinfo,signup,theme,p,tabgroup,$route,misvc,portalid,previewMode,$anchorScroll,$location, loginfactory ) {
            tabgroup = util.lowerCaseKeys(tabgroup);
            signup = util.lowerCaseKeys(signup);
            theme = util.lowerCaseKeys(theme);
            $scope.tabgroup = {};
            $scope.urlkey = svc.getUrlKey();
            $scope.isTabGroup = svc.getTabGroupUrlKey().length ? true : false;
            $scope.isTabbedSignup = false;
            $scope.params = p;
            $scope.previewMode = previewMode;
            $scope.signupInfo = {};
            $scope.theme = {};
            $scope.errorMessage = '';
            $scope.memberId = 0;    // member id of logged in user
            $scope.isUserLoggedIn = false;
            $scope.isUserSignUpAdmin = false;
            $scope.isUserSignUpOwner = false;
            $scope.portalid = svc.getPortalId();
            $scope.showBackToPortal = false;
            $scope.pidParam = {
                newformat: '',
                oldformat: ''
            };
            $scope.fullsecureurl = ( typeof window.globalcfg.secureURL != 'undefined' ) ? window.globalcfg.secureURL : 'https://www.signupgenius.com';

            // not sure if some of these are useful for all sign up types yet - if rsvp only, can remove and append within rsvp controller
            $scope.userSignUp = {
                items: [],                  // array of items signed up for
                participantRecs: [],        // array of participant records for user
                totalQty: 0                 // count of the total quantity already signed up for
            };
            $scope.showAlreadySignedUp = false;
            $scope.showEditMySignUp = false;
            $scope.hasParticipants = false;
            $scope.url = {
                signup: '',
                editSignUp: '',
            };
            $scope.template = '';
            $scope.showsegments = false;

            //New Ad config starts here
            $scope.objConfig = {};
            $scope.objConfig['adconfigleft'] = {
                'platform'    : 'desktop',
                'category'    : 'signups',
                'section'     : 'sheet',
                'network'     : '',
                'type'        : '',
                'position'    : 'left',
                'themeId'     : 0,
                'responsive'  : false
            };
            $scope.objConfig['adconfigright'] = {
                'platform'    : 'desktop',
                'category'    : 'signups',
                'section'     : 'sheet',
                'network'     : '',
                'type'        : '',
                'position'    : 'right',
                'themeId'     : 0,
                'responsive'  : false
            };
            $scope.objConfig['previewonly'] = $scope.previewMode;

            //defaults -- will be defined later
            $scope.objConfig['isRSVP'] = false;
            $scope.objConfig['themeid'] = 0;
            $scope.objConfig['showadminbar'] = 0;

            var adnetworks = typeof $rootScope.adnetworkdatafile !== 'undefined' && typeof $rootScope.adnetworkdatafile.networks !== 'undefined' ? $rootScope.adnetworkdatafile.networks : {};
            $scope.objConfig.adconfigleft.network = adSvc.getAdNetwork($scope.objConfig.adconfigleft,adnetworks);
            $scope.objConfig.adconfigright.network = adSvc.getAdNetwork($scope.objConfig.adconfigright,adnetworks);
            //New Ad config ends here

            $scope.adconfig = {
    			network  : '',
    			platform : 'desktop',
    			category : 'signups',
    			section  : 'sheet',
    			type	 : '',
    			position : '',
    			theme    : '',
    			themeid  : 0
    		};
            $scope.hSegmentWidth = 0;
            $scope.containerWidth = $window.innerWidth;
            $scope.vSegmentSide = '';            // the side to show vertical ad on: 'right' | 'left' | '' (default / no ad)
            $scope.contentSide = 'left';    // the side to show content on: 'right' | 'left' (default / no ad)
            $scope.showCalendarIcon = false;    // whether to show calendar icon for selection (hide if single date)
            $scope.showCalendarView = false;    // whether to show calendar view (true when icon clicked)
            $scope.showTimeColumn = false;      // whether to show time as its own column
            $scope.showParticipantNote = false; // whether to show sign up admin note about displaying participants even though they are hidden
            $scope.showFundly = false;

            // array contains slotitemids that have been selected
            $scope.selectedSlotItems = [];
            // this tells us if the slotitems sign up buttons have been interacted with
            $scope.selectedSlotItemsDirty = false;

            // popover
            $scope.popTrig = 'mouseenter';
            $scope.popPlacement = 'top';
            $scope.popDelay = 300;
            $scope.popText = "";

            var baseURL = angular.isDefined( $window.location.origin ) ? $window.location.origin : $window.location.protocol + '//' + $window.location.host;
            // string labels
            $scope.strings = {
                feeMessage: '',
                lbls : { // shared strings
                    availableSlot:  'Available Slot',
                    date : 'Date',
                    time : 'Time',
                    created : 'Created by',
                    loc : 'Location',
                    cal : 'Subscribe',
                    files : 'Related Files',
                    contact : 'Contact',
                    calendarsync : 'Sync to calendar',
                    alreadysignedup : 'Already signed up?',
                    changesignup : 'Change my sign up',
                    donation: '($ Donation)',
                    dateformat: 'Dates shown as ',
                    copyrightYear: '',
                    participantNote: '',
                    calendarView: 'Calendar View',
                    listView: 'List View',
                    socialshare: 'Share'
                },
                icons : { // shared icons
                    calendarsync : 'sugicon-calendar-dates',
                    calendarview : 'sugicon-calendar-full',
                    contact :      'sugicon-envelope',
                    date :         'sugicon-calendar-full',
                    download :     'sugicon-file-download small',
                    files :        'sugicon-paperclip',
                    listview :     'sugicon-list',
                    loc :          'sugicon-map-marker',
                    socialshare :  'sugicon-bullhorn',
                    time :         'sugicon-time',
                },
                rsvp: {
                    admin: {
                        participant:    'NOTE: The names are only viewable because<br>you are logged in as a sign up administrator.',
                        response:       'NOTE: These RSVP responses are only viewable because<br>you are logged in as a sign up administrator.',
                    },
                    attending:      'Will you be attending the event?',
                    btnSubmit:      'RSVP NOW',
                    countOnYes:     'YES - Count on me for ',
                    countOnMaybe:   'MAYBE - Possible guests include ',
                    editRSVP:       'Edit',
                    myrsvp:         'My RSVP',
                    noresponse:     'No Response',
                    notMe:          'This is not me',
                    response: {
                        adult:          'Adult Guests:',
                        child:          'Child Guests:',
                        confirmed:      'Confirmed:',
                        guest:          'Guest Count:',
                        head:           'RSVP Responses',
                        maybe:          'Maybe:',
                        no:             'No:',
                        noresponse:     'No Response:',
                        noresponseHead: 'No Response',
                        responses:      'Responses:',
                        yes:            'Yes:',
                    },
                    rsvpFor:        'RSVP for ',
                    signedUpFor:    'Signed up for:',
                },
                ancillary: {
                    messages: {
                        swapSubmitted: 'Your requests have been sent.  You will be notified by email when someone agrees to swap.',
                        swapComplete: "Your swap has been completed and the other person has been notified of the change.",
                        emailSent:  'An email has been sent to !email! that contains a link to edit your sign up. If you do not receive it promptly, check your JUNK folder to make sure it was not accidentally flagged as spam. If you continue to have problems receiving the email, you can register at SignUpGenius in order to edit your item.',
                        emailSentNoBranding: 'An email has been sent to !email! that contains a link to edit your sign up. If you do not receive it promptly, check your JUNK folder to make sure it was not accidentally flagged as spam.'
                    }
                }
            };
            // create an instance of the login service
            $scope.login = loginfactory.getLogin(true);

            /** Takes a starteTemplateId number and builds a redirect to create a sign up from that starter template which is behind a login. If no id is provided it redirects to the build from starter template page with no template preselected
             * 
             * @param {number} starterTemplateId 
             */
            $scope.createFromStarterTemplate = function(starterTemplateId) {
                
                const queryParam = starterTemplateId ? `&startertemplate=${starterTemplateId}` : "";
                
                $scope.login.preplogin(true,`/index.cfm?go=w.createFromStarterTemplate${queryParam}`, true, true);
            }
            $scope.ancillaryMessage = {};

            // includable admin toolbar file
            $scope.adminToolbar = '/view/templates/signups/admintoolbar.html';

            // includable admin toolbar file
            $scope.backToPortal = '/view/templates/signups/backtoportal.html';

            // includable tab menu file
            $scope.tabMenu = '/view/templates/signups/tabmenu.html';

            // instantiate error handler
            $scope.es = errorService.newInstance();
            $scope.errorStrings = {
                errorsTitle: '',
                errorsPleaseCorrect: 'Please correct the issues indicated below.'
            };
            $scope.es.init();
            $scope.virtualLocations = {};
            // Per biz rules, we have to render the header location differently if a location has a dual physical and virtual location.
            // 'physical' | 'virtual' | 'both'
            $scope.locationType = 'physical';
            // local variables
            var view = 'page';
            //var excludeTablet = true; // tablets will render as desktop and not mobile
            //var display = util.isMobile(excludeTablet) ? 'mobile' : 'desktop';
            var display = 'desktop'; // we will only use desktop mode here until the mobile templates are developed
            var format = 'rsvp';

            // set up list of templates
            // view:        view type - page (sign up page), form (sign up form), or thanks (thank you page)
            // display:     display viewport - desktop or mobile
            // format:      sign up format - rsvp, nodate, bydate, byslot
            var templates = [
                { view: 'page', display: 'desktop', format: 'rsvp', url: '/view/templates/signups/page/d_rsvp.html'},
                { view: 'page', display: 'desktop', format: 'standard_d', url: '/view/templates/signups/page/d_datesorted.html'},
                { view: 'page', display: 'desktop', format: 'standard_i', url: '/view/templates/signups/page/d_slotsorted.html'},
                { view: 'page', display: 'desktop', format: 'nodate', url: '/view/templates/signups/page/d_nodate.html'},
                { view: 'page', display: 'desktop', format: 'calendar', url: '/view/templates/signups/page/d_calendar.html'},
                { view: 'page', display: 'desktop', format: 'passcode', url: '/view/templates/signups/page/d_passcode.html'},
                { view: 'page', display: 'desktop', format: 'expired', url: '/view/templates/signups/page/d_expired.html'},
                { view: 'page', display: 'mobile', format: 'rsvp', url: '/view/templates/signups/page/m_rsvp.html'},
                { view: 'page', display: 'mobile', format: 'standard_d', url: '/view/templates/signups/page/m_datesorted.html'},
                { view: 'page', display: 'mobile', format: 'standard_i', url: '/view/templates/signups/page/m_slotsorted.html'},
                { view: 'page', display: 'mobile', format: 'nodate', url: '/view/templates/signups/page/m_nodate.html'},
                { view: 'page', display: 'mobile', format: 'passcode', url: '/view/templates/signups/page/m_passcode.html'},
                { view: 'page', display: 'mobile', format: 'expired', url: '/view/templates/signups/page/m_expired.html'}
            ];

            $scope.frmObj = {
                numPerPage: 50
            };

            $scope.perPageOptions = [
                {label:'Show', count:0, previouscount:0}
              , {label:'10', count:10, previouscount:0}
              , {label:'25', count:25, previouscount:25}
              , {label:'50', count:50, previouscount:25}
          ] ;

            /**
             * Update the NumPerPage var when the user clicks the Items-Per-Page directive value
             * @param {integer} count - number indicating the number of items to show on the page
             
            $scope.setPerPage = function(count){
                if( count > 0 ){
                    $scope.frmObj.numPerPage = parseInt(count);
                    // Update pagination based on new items per page count
                    svc.initializePagination($scope.signupInfo, $scope.frmObj);
                }
            };
            */

            $scope.currentSlots = [];
            // TODO $Watch the page number value, call getPage and set the page via that method and filter the array
            // DEV Note: Not currently used. Will be used via pagination controls implemented in SUG-16260. 
            /** Takes a page number and returns the slots on that page based on properties in the $scope.signupInfo.listPagination object
             *
             * @param {number} pageNumber The page number to calculate the current slots off of
             * @returns
             */
            $scope.getPage = function(pageNumber) {
                if ($scope.signupInfo.allSlotsHidden)
                    return;

                if (pageNumber < 1) {
                    console.warn("on first page")
                    return;
                }
                if (pageNumber > $scope.signupInfo.listPagination.totalPages) {
                    console.warn("on last page")
                    return;
                }

                //util.broadCast("isProcessing", true);

                //console.table($scope.signupInfo.listPagination)
                const requestParams = {
                    offset: ($scope.signupInfo.listPagination.currentPage - 1) * $scope.signupInfo.listPagination.itemsPerPage,
                    perPage: $scope.signupInfo.listPagination.itemsPerPage
                }
                //console.log(requestParams)
                // TODO generate request params here and make request here
                $scope.signupInfo.currentSlots = $scope.signupInfo.slotsArray.slice(pageNumber - 1, pageNumber);
                /*
                $location.hash('signupContainerId');
                $anchorScroll();

                util.broadCast("isProcessing", false);
                util.refreshPageAds();
                */
            }



            /** helper method to create dynamic sign up styles **/
    		$scope.createSignUpStyle = function(){
    			// this is where our dynamic style container will be
                var styleContainer = angular.element( document.querySelector( '#styleContainer' ) );
                // build the objects for the various classes
                // append a couple rgba values for use - ideally we will make getContainerClass a service method in the future
                // done here since it uses utility methods not available within getContainerClass
                $scope.theme['mutedTextColor1'] = util.addOpacity2color( util.color2rgb( $scope.theme.textcolor1 ), 0.15 );
                $scope.theme['mutedButtonColor'] = util.addOpacity2color( util.color2rgb( $scope.theme.buttoncolor ), 0.15 );
                var clsDetail = getContainerClass( $scope.theme );
                // create a style tag containing all the classes
                var dStyles = angular.element( '<style type="text/css">' + clsDetail + '</style>' );
    			// append the style to the container
                styleContainer.html( dStyles );
    		};

            // return appropriate template for include
            var getTemplate = function(){
                for( var i=0; i<templates.length; i++ ){
                    if( templates[i].view === view
                        && templates[i].display === display
                        && templates[i].format === format ){
                            return templates[i].url;
                        }
                }
            };

            // sets header parts in $scope.header object
            var buildHeader = function(){

                var h = $scope.signupInfo.header;
                $scope.signupInfo.header.description = sce.trustAsHtml(h.description);
                // which header template
                $scope.headerTemplate = "/view/templates/themes/" + (display === 'desktop' ? 'd_header' + $scope.theme.themetemplateid.toString() + '.html' : 'm_header' + $scope.theme.themetemplateid.toString() + '.html');

                // if showing header date
                if( $scope.showHeaderDate() ){
                    var date = h.date;
                    $scope.dateString = date.date;
                    $scope.timeString = date.time;
                    $scope.useTime = date.usetime;
                }

                // construct location string
                if( $scope.showHeaderLocation() ){
                    var loc = h.location;
                    var isVirtualLocation = loc.virtuallocationid > 0;
                    var isPhysicalLocation = loc.locationid > 0;
                    $scope.locationString = loc.location;
                    if (isPhysicalLocation && isVirtualLocation) {
                        $scope.locationType = 'both';
                        var locAddress = $scope.locations[loc.locationid];
                        var virtualLocAddress = $scope.virtualLocations[loc.virtuallocationid];
                        $scope.locationString = '<a href="' + virtualLocAddress.virtuallocationlinkurl + '" target="_blank">' + locAddress.name;
                        $scope.locationString += '<span class="inline-spacer"></span><span class="sugicon-video-camera-solid"></span></a>';
                        $scope.locationString += '<br />' + '<a href="'  + locAddress.locationlinkurl + '" target="_blank">' + locAddress.address1 + ' ' + locAddress.address2 + '<br />' + locAddress.city + ', ' + locAddress.state + ' ' + locAddress.zipcode;
                        $scope.locationString += '<span class="inline-spacer"></span><span class="sugicon-map-marker address-icon ng-scope"></span></a>';
                        return;
                    }
                    if( isPhysicalLocation  && loc.locationid in $scope.locations ){
                        $scope.locationType = 'physical';
                        var locAddress = $scope.locations[loc.locationid];
                        $scope.locationString = '<a href="' + locAddress.locationlinkurl + '" target="_blank">' + loc.location;
                        $scope.locationString += '<br />' + locAddress.address1 + ' ' + locAddress.address2 + '<br />' + locAddress.city + ', ' + locAddress.state + ' ' + locAddress.zipcode + '</a>';
                    }
                    // Add in virtual location data to to header location
                    if (isVirtualLocation) {
                        $scope.locationType = 'virtual';
                        var locAddress = $scope.virtualLocations[loc.virtuallocationid];
                        $scope.locationString = '<a href="' + locAddress.virtuallocationlinkurl + '" target="_blank">' + loc.location + '</a>';
                    }


                }

                // attachments
                $scope.showAttachments = typeof $scope.signupInfo.header.attachments !== 'undefined' && $scope.signupInfo.header.attachments.length ? true : false;
                $scope.attachments = $scope.showAttachments ? $scope.signupInfo.header.attachments : [];

                // calendar sync
                $scope.showCalendarSync = typeof $scope.signupInfo.header.calendar !== 'undefined' && 'id' in $scope.signupInfo.header.calendar ? true : false;

                // social share
                $scope.showSocialShare = $scope.signupInfo.socialshare;

                //if embedded sign up is opened via embedded portal, update contact url for proper page flow
                if( fromEmbeddedPortal() ){
                    $scope.signupInfo.header.contacturl += '&pid=' + $scope.portalid;
                }

                // if we are in preview mode, remove the contact url
                if( $scope.previewMode ){
                    $scope.signupInfo.header.contacturl = '';
                }
            };

            // helper - theme initialization
            var initializeTheme = function( objTheme ){
                // we need to make sure the image height and width are properly defined
                if( 'mainimages' in objTheme && Array.isArray(objTheme.mainimages) && objTheme.mainimages.length ){
                    angular.forEach( objTheme.mainimages, function(obj,key){
                        if( obj.imagewidth < 2 || obj.imageheight < 2 ){
                            $timeout( function(){
                                var image = new Image();
                                    image.src = obj.desktopmemberimage;
                                    image.onload = function() {
                                        obj.imagewidth = image.width;
                                        obj.imageheight = image.height;
                                };
                            },50);
                        }
                    });
                }
                $scope.theme = objTheme;
                $scope.createSignUpStyle();
                svc.setThemeInfo( $scope.theme );
            };

            // test if sign up is locked
            $scope.isLocked = function(){
                return typeof $scope.signupInfo.signuplocked !== 'undefined' && $scope.signupInfo.signuplocked ? true : false;
            };

            // test if sign up has availabel slots
            $scope.hasAvailableSlots = function(){
                return typeof $scope.signupInfo.hasavailableslots !== 'undefined' && $scope.signupInfo.hasavailableslots ? true : false;
            };

            // test if has all dates are hidden
            $scope.isAllDatesHidden = function(){
                return typeof $scope.signupInfo.alldateshidden !== 'undefined' && $scope.signupInfo.alldateshidden ? true : false;
            };

            // show date
            $scope.showHeaderDate = function(){
                return !$scope.signupInfo.nodate && typeof $scope.signupInfo.header.date !== 'undefined' && Object.keys($scope.signupInfo.header.date).length !== 0 ? true : false;
            };
            // show time
            $scope.showHeaderTime = function(){
                return !$scope.signupInfo.nodate && util.keyExists($scope.signupInfo.header, 'date.usetime') ? $scope.signupInfo.header.date.usetime : false;
            };

            // show location
            $scope.showHeaderLocation = function(){
                return typeof $scope.signupInfo.header.location !== 'undefined' &&  typeof $scope.signupInfo.header.location.location !== 'undefined' ? true : false;
            };

            // helper method to return file extension
            $scope.getFileExt = function( filename  ){
                if( typeof filename !== 'undefined' && filename.indexOf('.') >= 0 ){
                    var arrFile = filename.split('.');
                    return arrFile[arrFile.length - 1];
                }
                return '';
            };

            // user clicks on sign up button
            $scope.clickSignUp = function( slotitemid ){
// TODO: Build out sign up page button
// Temp message for testers
window.alert('Sign up clicked for slotitemid: ' + slotitemid);
                // $window.location.href = $scope.url.signup;
            };
            // user clicks on edit sign up button
            $scope.clickEditSignUp = function(){
                // if we are in preview mode, don't save
                if( $scope.previewMode ) return;

                if( $scope.showBackToPortal && $scope.portalid > 0 ){
                    $window.location.href = $scope.url.editSignUp + '&pid=' + $scope.portalid;
                } else {
                    $window.location.href = $scope.url.editSignUp;
                }
            };
            // user clicks on sync to calendar link
            $scope.clickCalendarSync = function(){
                $modal.open({
                    templateUrl: '/view/templates/signups/calendarsync.html',
                    controller: 'calendarSyncController',
                    resolve: {
                        calendar: function () {
                            return {
                                'calendar': $scope.signupInfo.header.calendar
                            };
                        }
                    }
                }).result.then(function (result) {
                    // resolved - the modal was successfully processed (e.g. $modalInstance.close())
                    if (result.success) {
                        // all went well and we should have result.data.myArray
                    }
                }, function () {
                    // rejected - the modal was dismissed (e.g. $modalInstance.dismiss())
                });

            };

            $scope.toggleCalendarView = function( switchTo, fromPageLoad = false ){
                if( switchTo === 'cal' && !$scope.showHeaderDate() ){   // only show calendar view if we have more than one date
                    $scope.showCalendarView = true;
                    format = 'calendar';
                    // reset the service cache for the display month since we need to jump to the first month with slots
                    svc.setDisplayMonth({});
                }
                else {
                    // determine format
                    $scope.showCalendarView = false;
                    format = $scope.determineSignupType();
                }
                // select proper template
                $scope.template = getTemplate();

                // recycle ads - ensures bottom ad will (re)show if appropriate
                if (!fromPageLoad && $scope.showsegments)
                    util.refreshPageAds();
            };

            // user clicks on +x more link under participant list
            $scope.openParticipantDetails = function(listid, memberId, slotdata, slotitem){

                $modal.open({
                    templateUrl: '/view/signups/incl_dspParticipantsModal.html',
                    controller: 'participantDetailsModalController',
                    resolve: {
                        //pass data into the modal
                          listid: function () { return listid;}
                        , memberId: function () { return memberId;}
                        , slotdata: function () { return slotdata;}
                        , slotitem: function () { return slotitem;}
                        , theme: function () { return $scope.theme; }
                        , tzshort: function () { return $scope.signupInfo.tzshort; }
                        , showprofilepics: function () { return $scope.signupInfo.showprofilepics; }
                        , shownames: function () { return ( ($scope.isUserSignUpOwner || $scope.isUserSignUpAdmin) || ($scope.signupInfo.shownames && !slotitem.donotshow) ); }
                        , signuptype: function () { return $scope.determineSignupType(); }
                    },
                    // Append the sign up type to the <body> tag, so we can have separate styles for the modals based on the sign up type
                    openedClass: $scope.determineSignupType()
                }, function () {
                    // rejected
                });
            };  // END openParticipantDetails

            /**
             * Create and return an object with information for the delete modal.
             *
             * @item {Object} - a sign up item (slot)
             * @slot {Object} - a sign up slot (date)
             * @slotitemid {Integer} - id of the slotitem associated with the item member to delete
             */
            $scope.getDeleteModalInfo = function(item,slot,slotitemid){
                var tzshort = $scope.signupInfo.tzshort.toUpperCase();

                var modalInfo = {
                    listid: $scope.signupInfo.id,
                    notify: ($scope.signupInfo.notifyme && (!$scope.isUserSignUpOwner || $scope.signupInfo.notificationids.length > 1)),
                    contactName: $scope.signupInfo.header.contactname,
                    signupTitle: $scope.signupInfo.header.title,
                    slotitemid: slotitemid,
                    slotimages:[]
                };

                if(item.images && item.images.images) {
                    modalInfo.slotimages = item.images.images ;
                }
                modalInfo.imagealttext = (modalInfo.slotimages.length) ? ( (item.images.itemdescription.length) ? item.images.itemdescription : item.images.itemname + ' image' ) : '';
                modalInfo.title = item.item;
                modalInfo.slotid = slot.slotid;
                modalInfo.itemid = item.itemid;
                if(slot.timeLabel && slot.timeLabel.length){
                    modalInfo.timelabel = slot.timeLabel.replace(/<br>/g,'').replace(/-/g,' - ') + '&nbsp;<span>' + tzshort + '</span>';
                }
                modalInfo.datalabel = slot.dateLabel;
                modalInfo.locdetail = slot.locdetail ? slot.locdetail : {};
                modalInfo.locdetail.location = slot.location;

                return modalInfo;
            };

            // user clicks on edit button for an itemmember
            $scope.editItemMember = function(itemmemberid,slotitemid,memberid){
                var attrsObj = {};
                attrsObj.imid = itemmemberid;
                attrsObj.mid = memberid;
                attrsObj.siid = slotitemid;
                attrsObj.urlid = $scope.signupInfo.urlid;
                generateAttrs(attrsObj);

                var signupformpath = '/form/' + $scope.signupInfo.listformat;
                $location.path (signupformpath);
            };

            // user clicks on swap button for an itemmember
            $scope.swapItemMember = function(itemmemberid,slotitemid,memberid,myqty){
                // direct to old form (for now) - like http://local.signupgenius.com/index.cfm?go=s.swap&id=39362&siid=78716&thisqty=1&imid=41418&mid=37925
                var swappath = '/index.cfm?go=s.swap';
                swappath += '&id=' + $scope.signupInfo.id;  // sign up id
                swappath += '&siid=' + slotitemid;  // slot item id
                swappath += '&thisqty=' + myqty;  // qty signed up for
                swappath += '&imid=' + itemmemberid;  // item member id
                swappath += '&mid=' + memberid;  // member id of item member id
                $window.location.href = swappath;
            };

            /**
             *  Toggles the slot item selection.  Fires when the sign up button beside a slot item is pressed.
             *  @param  {Integer}  slotitem - the slotitemid
             *  @param  {Boolean}  unwind - optional, allows Calendar VM to unwind history (qty limit is already checked, this prevents duplicate error messages.)
             *  @return {Boolean}  returns boolean for Calendar view to record unwind history (for undo).
             */
            $scope.toggleSlotItem = function(slotitem, unwind){

                if (typeof unwind == 'undefined') {
                    unwind = false; //default parameter if missing
                }

                // this tells us that the slotitems sign up buttons have been interacted with
                $scope.selectedSlotItemsDirty = true;
                var slotitemid = slotitem.slotitemid;
                // see if the slot item was already selected
                var selectedIdx = $scope.selectedSlotItems.findIndex( function(siID){
                    return siID === slotitemid;
                });

                // if not found, add it to the array
                if ( selectedIdx < 0 ) {
                    // ensure we have not hit the signup's quantity limit
                    if ( !unwind && checkSignupQuantityLimit() && checkItemQuantityLimit(slotitem.myqty) ) {
                        $scope.selectedSlotItems.push(slotitemid);
                        return(true);
                    } else if (unwind) {
                        $scope.selectedSlotItems.push(slotitemid);
                    } else {
                        // restore the button's state since the user can't select anymore slotitems
                        slotitem.btnState = 'default';
                        return(false);
                    }
                } else {
                    // found in the array, so we want to remove it
                    $scope.selectedSlotItems.splice(selectedIdx,1);
                    return(true);
                }
            };

            /**
             * Checks to see if the user has hit the slotitem's quantity limit (if creator has enabled it) and shows the user a warning modal
             * if it limit has been reached. Returns true if the limit setting is off or participant is under the limit
             * @param {Integer} myqty - quantity already signed up for previously
             */
            var checkItemQuantityLimit = function(myqty){
                var qtyLimit = parseInt($scope.signupInfo.qtylimit_slotitems);
                // if the qty limit is zero, then the setting is turned off
                if( qtyLimit <= 0 ){ return true;}

                // factor in the quantity already signed up for (specific to a slotitem)
                qtyLimit -= myqty;
                // check to see if we hit our limit
                if( qtyLimit <= 0 ){
                    var qtyLimitMessage = 'You have reached the quantity limit set up by the sign up creator. You are not allowed to sign up for more than ';
                    qtyLimitMessage += parseInt($scope.signupInfo.qtylimit_slotitems) + ' of any individual item';
                    var participantItemStr = myqty.toString() + ((myqty > 1) ? ' items' : ' item');
                    qtyLimitMessage += ' and you already have ' + participantItemStr + ' that you are signed up for.';
                    util.showMagnificAlert( qtyLimitMessage, 'warning', undefined, 'Sign Up Quantity Limit' );
                    return false;
                }else{
                    return true;
                }
            };

            /**
             * Checks to see if the user has hit the sign up quantity limit (if creator has enabled it) and shows the user a warning modal
             * if it limit has been reached. Returns true if the limit setting is off or participant is under the limit
             */
            var checkSignupQuantityLimit = function(){
                var qtyLimit = parseInt($scope.signupInfo.qtylimit_signup);
                // if the qty limit is zero, then the setting is turned off
                if( qtyLimit <= 0 ){ return true;}

                // factor in the participants already signed up items
                qtyLimit -= $scope.userSignUp.totalQty;
                // check to see if we hit our limit
                if( qtyLimit <= $scope.selectedSlotItems.length ){
                    var qtyLimitMessage = 'You have reached the quantity limit set up by the sign up creator. You are not allowed to sign up for more than ';
                    var qtyLimitStr = ($scope.signupInfo.qtylimit_signup > 1) ? 'items' : 'item';
                    qtyLimitMessage += $scope.signupInfo.qtylimit_signup + ' total ' + qtyLimitStr + ' on this sign up';
                    if( $scope.userSignUp.totalQty ){
                        var participantItemStr = $scope.userSignUp.totalQty.toString() + (($scope.userSignUp.totalQty > 1) ? ' items' : ' item');
                        qtyLimitMessage += ' and you already have ' + participantItemStr + ' that you are signed up for.';
                    }else{
                        qtyLimitMessage += '.';
                    }
                    util.showMagnificAlert( qtyLimitMessage, 'warning', undefined, 'Sign Up Quantity Limit' );
                    return false;
                }else{
                    return true;
                }
            };

            // set member id and if user is logged in
            var setMember = function(){
                if( typeof $scope.memberInfo !== 'undefined'
                    && util.keyExists($scope.memberInfo,'memberid',true)
                    && $scope.memberInfo.memberid > 0 )
                {
                    $scope.isUserLoggedIn = true;
                    $scope.memberId = $scope.memberInfo.memberid;
                }
            };

            // determine if user is sign up owner, call after setMember
            var setIsUserSignUpAdmin = function(){
                let subAdminHasPermission = false;

                if( $scope.isUserLoggedIn && $scope.memberId == $scope.signupInfo.owner )
                {
                    $scope.isUserSignUpOwner = true;
                }
                else if( $scope.isUserLoggedIn
                    && util.keyExists($scope.memberInfo,'parentid',true)
                    && $scope.memberInfo.parentid == $scope.signupInfo.owner
                ){
                    $scope.isUserSignUpAdmin = true;
                    
                    if( $scope.memberInfo.perms ){
                        $scope.canManageSignUp = $scope.memberInfo.perms.manage ? $scope.memberInfo.perms.manage : false;
                        $scope.canManageGroups = $scope.memberInfo.perms.group ? $scope.memberInfo.perms.group : false;
                        $scope.canViewReports = $scope.memberInfo.perms.report ? $scope.memberInfo.perms.report : false;
                        $scope.canManagePeople = $scope.memberInfo.perms.people ? $scope.memberInfo.perms.people : false;

                        // iterates the perms fields by (key, value) and test if any one is set to true then returns true else false
                        subAdminHasPermission = Object.entries($scope.memberInfo.perms).some(([key, value]) => value === true);
                    }
                }

                //set showadminbar
                if ( ($scope.isUserSignUpAdmin  && subAdminHasPermission) || $scope.isUserSignUpOwner ) {
                    $scope.objConfig['showadminbar'] = 1;
                } else {
                    $scope.objConfig['showadminbar'] = 0;
                }

            };

            // user is sign up admin and participants are hidden show participant note
            var setParticipantNote = function(){
                if( ( ( util.keyExists($scope.signupInfo, 'shownames', true) && !$scope.signupInfo.shownames )
                    || ( util.keyExists($scope.signupInfo, 'hashidenames', true) && $scope.signupInfo.hashidenames ) )
                    && ( $scope.isUserSignUpAdmin || $scope.isUserSignUpOwner ) ){
                    $scope.showParticipantNote = true;
                    // add logout link
                    $scope.strings.lbls.participantNote = 'PLEASE NOTE: Names are only viewable on this sign up because you are logged in as an administrator. To see how this sign up looks to your users, <a href="' + baseURL + '/index.cfm?go=c.logout&signupurl=' + $scope.signupInfo.urlid + '">click here to logout</a>.';
                }
            };

            // determine if user is a participant, call after setMember
            // consider moving this to the rsvp controller since it appears to only apply there (ap: also used it in standard signups to count the number of already signed up slots)
            var setUserParticipant = function(){
                if( $scope.isUserLoggedIn && util.keyExists($scope.signupInfo,'participants',true) ){
                    var stcParticipants = util.deepCopy( $scope.signupInfo.participants );
                    // scan participants for memberid
                    for( var key in stcParticipants ){
                        // particiant is array
                        if( typeof stcParticipants[key] === 'object' && stcParticipants[key].length ){
                            for( var i=0; i<stcParticipants[key].length; i++ ){
                                if( stcParticipants[key][i].hasOwnProperty('memberid') && stcParticipants[key][i].memberid == $scope.memberId ){
                                    $scope.userSignUp.participantRecs.push(stcParticipants[key][i]);
                                    $scope.userSignUp.totalQty += stcParticipants[key][i].myqty;
                                    $scope.showEditMySignUp = true;

                                    // If signup is expired but user is a participant, set expired to false and redetermine the sign up type so the signup displays for the user
                                    if ($scope.signupInfo.expired) {
                                        $scope.signupInfo.expired = false;
                                        // determine which view, display, format to use
                                        format = $scope.determineSignupType();

                                        // select proper template
                                        $scope.template = getTemplate();
                                    }

                                }
                            }
                        }
                    }
                }
                // also need to check for rsvps with no as a response since participants would be empty
                if( $scope.isUserLoggedIn && $scope.signupInfo.usersvp && util.keyExists($scope.signupInfo,'rsvp',true) && $scope.signupInfo.rsvp.length ){
                    var arrRSVP = util.deepCopy( $scope.signupInfo.rsvp );
                    // scan participants for memberid
                    for( var j=0; j<arrRSVP.length; j++ ){
                        if( arrRSVP[j].memberid === $scope.memberId ){
                            if( !util.keyExists($scope.userSignUp, 'rsvpRecs', true) ){
                                $scope.userSignUp['rsvpRecs'] = [];
                            }
                            $scope.userSignUp.rsvpRecs.push( arrRSVP[j] );
                            $scope.showEditMySignUp = true;

                            // If signup is expired but user is a participant, set expired to false and redetermine the sign up type so the signup displays for the user
                            if ($scope.signupInfo.expired) {
                            $scope.signupInfo.expired = false;
                            // determine which view, display, format to use
                            format = $scope.determineSignupType();

                            // select proper template
                            $scope.template = getTemplate();
                        }
                        }
                    }
                }
            };

            // determine if sign up has participants
            var setHasParticipants = function(){
                $scope.hasParticipants = (util.keyExists($scope.signupInfo, 'participants',true) && Object.keys($scope.signupInfo.participants).length > 0) || $scope.signupInfo.participantcount > 0;
            };

            // determine whether to show already signed up button
            var setShowAlreadySignedUp = function(){
                if( $scope.hasParticipants && !$scope.isUserLoggedIn && !$scope.signupInfo.usersvp ){
                    $scope.showAlreadySignedUp = true;
                }
            };

            // helper method for recalculating style of header images
            $scope.getImageStyle = function( elemId, img ){
                var elem = document.getElementById(elemId);
                    elem = angular.element(elem);
                var coords = img.imagecropcoords;
                var cw = elem[0].offsetWidth;
                var ch = elem[0].offsetHeight;
                // Handle situations where the offset values come back as 0 by setting the values equal to the image dimensions
                if (cw === 0 || ch === 0) {
                    cw = img.imagewidth;
                    ch = img.imageheight;
                }
                var x1 = coords[0];
    			var y1 = coords[1];
    			// var x2 = coords[2];
    			// var y2 = coords[3];
    			var coordw = coords[4];
    			var coordh = coords[5];
                var width = img.imagewidth;
    			var height = img.imageheight;
                var left = ( cw / coordw ) * x1  * -1;
    			var top = (ch / coordh) * y1 * -1;
    			var newwidth = ( cw / coordw  * width);
    			var newheight = ( ch / coordh * height);

                // build the style
                return {
                    'margin-left': left,
                    'margin-top': top,
                    'width': newwidth,
                    'height': newheight
                };
            };
            // set sign up and edit urls
            var setUrls = function(){
                $scope.url.signup = baseURL + '/index.cfm?go=s.PreProcessSignup&URLID=' + $scope.signupInfo.urlid;
                $scope.url.editSignUp = baseURL + '/index.cfm?go=s.EditHelp&urlid=' + $scope.signupInfo.urlid;
                if( $scope.signupInfo.usersvp ){ $scope.url.editRSVP += '&useRSVP=1';}
            };

            // when user clicks on slot image zoom icon
            $scope.showZoomedImage = function( itemid ){
                if( parseInt(itemid) > 0 ){
					$.magnificPopup.open({
						removalDelay: 300,
							items: {
								src: '/view/signups/dspItemImages.cfm?itemid=' + itemid,
								type: 'iframe'
							}
					});
				}
            };

            // set fee message
            var setFeeMessage = function(){
                var wprate = $scope.signupInfo.iswp && angular.isDefined($scope.signupInfo.wprate) ? $scope.signupInfo.wprate : {'p':0,'t':0,'fee_payer':'payer_from_app'};
                var cur = $scope.signupInfo.currency;
                var fee_payer = ( $scope.signupInfo.iswp && angular.isDefined( $scope.signupInfo.wprate.fee_payer ) ) ? $scope.signupInfo.wprate.fee_payer : 'payer_from_app';
                // set fee message
                if( fee_payer == 'payer_from_app' && $filter('number')(wprate.p * 100) > 0){
                    $scope.strings.feeMessage = "A service fee of " + $filter('number')($scope.signupInfo.wprate.p * 100) + "% + " + $filter('currency')($scope.signupInfo.wprate.t) + ' ' + cur + " will be added to your purchase at checkout.";
                }
            };

            // set whether to show Fundly
            var setShowFundly = function(){
                $scope.showFundly = util.keyExists($scope.signupInfo, 'fundlyurl', true) && $scope.signupInfo.fundlyurl.length ? true : false;
            };

            // Find any messages that should be displayed from ancillary pages
            var getAncillaryMessage = function(){
                var urlParms = utility.getAllUrlParams();
                var msg = util.keyExists(urlParms, 'msg', true) ? $scope.strings.ancillary.messages[urlParms.msg] : '';

                if ( msg.indexOf('!email!') > -1 && util.keyExists(urlParms, 'email', true) ) {
                    msg = msg.replace('!email!',urlParms.email);
                }
                return msg;
            };


            var procesSignupObject = function (signup, theme) {
                // sign up info

                if( util.ajaxResultInvalid(signup) ){
                    $scope.errorMessage = util.getAjaxResponseMessage( signup.data );
                    // will get here if user submitted invalid passcode
                    // build signupInfo for processing by passcode template
                    if( util.keyExists(signup, 'data.data.passcode') && signup.data.data.passcode ){
                        $scope.signupInfo = {
                            passcode: true,
                            success: false,
                            message: $scope.errorMessage,
                            mid: util.keyExists(signup, 'data.data.mid') ? signup.data.data.mid : 0,
                            id: util.keyExists(signup, 'data.data.id') ? signup.data.data.id : 0,
                        };
                        svc.setSignUpInfo( $scope.signupInfo );
                        svc.setThemeClassInfo( $scope.signupInfo.themeclass );
                    }
                }
                else {
                    $scope.signupInfo = signup.data.data;
                    $scope.virtualLocations = $scope.signupInfo.virtuallocations;
                                    // Initialize list view pagination objects
                           
                    //svc.initializePagination($scope.signupInfo, $scope.frmObj);

                    if (!$scope.signupInfo.allSlotsHidden) {
                        // Set up a watcher on the currentPage prop, which will eventually be changed by the pagination directive. This will trigger the functionality to display the current page's slots/eventually trigger a request to the backend
                       /* $scope.$watch('signupInfo.listPagination.currentPage', function(newValue) {
                            $scope.getPage(newValue);
                        }); */
                    }

                    // If the sign up uses a custom url and the sug generated urlid is used, redirect the user to the custom url
                    if ($scope.urlkey.toString().trim().toLowerCase() !== $scope.signupInfo.urlid.toString().trim().toLowerCase()) {
                        $scope.urlkey = $scope.signupInfo.urlid;
                        $window.location.href = "/go/"+$scope.urlkey+'#/';
                    }

                    $scope.locations = typeof $scope.signupInfo.locations !== 'undefined' ? $scope.signupInfo.locations : {};
                    svc.setSignUpInfo( $scope.signupInfo );
                    svc.setThemeClassInfo( $scope.signupInfo.themeclass );
                }

                // theme object
                if( util.ajaxResultInvalid(theme) ){
                    $scope.errorMessage = util.getAjaxResponseMessage( theme.data );
                }
                else {
                    initializeTheme( theme.data.data );
                }
                // handle pass code form
                if( $scope.signupInfo.passcode ){
                    format = 'passcode';
                    $scope.template = getTemplate();
                }
                // if not errors - proceed
                if( $scope.errorMessage === '' && format !== 'passcode' ){

                    // set page title
                    var pageTitle = util.keyExists($scope.signupInfo, 'header.group') ? $scope.signupInfo.header.group : ''; // sanity check
                    if( util.keyExists($scope.signupInfo, 'header.title') ){
                        if( pageTitle.length ){
                            pageTitle += ': ';
                        }
                        pageTitle += $scope.signupInfo.header.title;
                    }
                    if( pageTitle.length ){
                        $window.document.title = sce.trustAsHtml(pageTitle.trim());
                    }

                    $scope.showsegments = $scope.signupInfo.showsegments;

                    // set show calendar view
                    if( !!$scope.signupInfo.calendarview && !$scope.showHeaderDate() ){ // calendar view is true and sign up has >1 date
                        $scope.showCalendarView = true;
                    }
                    else {
                        $scope.showCalendarView = false;
                    }

                    // determine which view, display, format to use
                    format = $scope.determineSignupType();

                    // select proper template
                    $scope.template = getTemplate();
                    // build header
                    buildHeader();

                    // pull calendar view query parameter if exists
                    var urlParams = utility.getAllUrlParams();
                    if( typeof urlParams.view !== 'undefined' ){
                        if( urlParams.view == 'calendar' ){
                            $scope.toggleCalendarView('cal', true);
                        }
                        else if( urlParams.view == 'standard' ){
                            $scope.toggleCalendarView('standard', true);
                        }
                    }

                    // if sign up is locked
                    if( $scope.isLocked() ){
                        $scope.errorStrings = {
                            errorsTitle: '',
                            errorsPleaseCorrect: $scope.signupInfo.lockedmessage,
                        };
                        $scope.es.setError('error-top-level', 'no msg');
                    }
                    // if sign up has no available slots
                    if( !$scope.hasAvailableSlots() ){
                        $scope.errorStrings = {
                            errorsTitle: '',
                            errorsPleaseCorrect: $scope.signupInfo.noavailableslotsmessage,
                        };
                        $scope.es.setError('error-top-level', 'no msg');
                    }
                    if( $scope.isAllDatesHidden() ){
                        $scope.errorStrings = {
                            errorsTitle: '',
                            errorsPleaseCorrect: $scope.signupInfo.hiddendatesmessage,
                        };
                        $scope.es.setError('error-top-level', 'no msg');
                    }
                    // ancillary messages
                    var ancillaryMessage = getAncillaryMessage();
                    if( ancillaryMessage.length ){
                        $scope.ancillaryMessage = {
                            type: 'success',
                            title: '',
                            text: ancillaryMessage,
                            dismissable: false,
                            show: true
                        };
                    }

                    // set header ad code
                    $scope.adconfig.themeid = $scope.signupInfo.themeid;
                    $scope.objConfig['isRSVP'] = $scope.signupInfo.usersvp;
                    $scope.objConfig['themeid'] = $scope.signupInfo.themeid;

                    var adnetworks = typeof $rootScope.adnetworkdatafile !== 'undefined' && typeof $rootScope.adnetworkdatafile.networks !== 'undefined' ? $rootScope.adnetworkdatafile.networks : {};
                    $scope.adconfig.network = adSvc.getAdNetwork($scope.adconfig,adnetworks);
                    adSvc.setHeaderAdCode( $scope.adconfig );

                    if( $scope.showsegments ){
                        $scope.hSegmentWidth = 190;
                        if( $scope.containerWidth > 1199 )
                            $scope.hSegmentWidth = 330;
                        // determine side ad will show on
                        var r = Math.floor((Math.random() * 100) + 1);
                        if( r % 2 === 0 ){
                            $scope.segmentSide = 'left';
                            $scope.contentSide = 'right';
                        }
                        else {
                            $scope.segmentSide = 'right';
                            $scope.contentSide = 'left';
                        }
                    }

                    //determine copyright year
                    $scope.strings.lbls.copyrightYear = new Date().getFullYear();

                    // set user as logged in / memberid
                    setMember();
                    // set flag to determine if user is sign up owner / administrator
                    setIsUserSignUpAdmin();
                    // set participant note
                    setParticipantNote();
                    // set user as participant
                    setUserParticipant();
                    // set participant
                    setHasParticipants();
                    // set show already signed up button
                    setShowAlreadySignedUp();
                    // set urls
                    setUrls();
                    // set fee message
                    setFeeMessage();
                    // set show Fundly
                    setShowFundly();

                    // show sign up sheet queued ads after loading 
                    if ($scope.showsegments && signup.data.data.displayvideoadonsignupsheet) {
                        $timeout(function() {
                            adSvc.queueSignUpSheetLoadedAds();
                        }, 1000);
                    }
                }

                /* Runs if viewing a sign up that is part of a tab group, loaded via the /go/urlid path.
                   In this case the tabgroup object isn't initialized when the page loads and has to be done here
                */
                if (!$scope.isTabGroup && util.keyExists(signup.data.data, 'tabs', true) && signup.data.data.tabs.istabbed) {
                    // hide tabs if we are viewing this sign up via embed directly. We want tabs if this is from a Portal Page.
                    if( !$scope.signupInfo.allowembed || hasPortalId() ){
                        $scope.isTabbedSignup = true;

                        svc.gettabgroup({tabgroupid: $scope.signupInfo.tabs.tabgroupid})
                        .then(function(result) {
                            var tabData = util.lowerCaseKeys(result);
                            tabgroup = {};
                            tabgroup = tabData;
                            // tabgroup object
                            if( util.ajaxResultInvalid(tabgroup) ){
                                $scope.errorMessage = util.getAjaxResponseMessage( tabgroup.data );
                            } else {
                                svc.setTabGroup ( tabgroup );
                                initializeTabObject(tabgroup);
                                lookupTabIndex($scope.urlkey);
                                setTabProperties();
                            }
                        });
                    }
                }



            };

            // Looks up the signup assoicated with the specified urlkey and sets the index into the tab group signups array based on the result.
            var lookupTabIndex = function (urlkey) {
                var urlid = typeof urlkey !== 'undefined' ? urlkey : $scope.urlkey;
                // look up signups array and find the index of the corresponding tab group
                for (var i=0; i < $scope.tab.tabcount; i++){
                    if ($scope.tabsignups.hasOwnProperty(i)){
                        if ($scope.tabsignups[i].urlid.toString().trim().toLowerCase() === urlid.toString().trim().toLowerCase()) {
                            $scope.tab.index = i;
                            svc.setTabIndex(i);
                            break;
                        }
                    }
                }
            };

            // Sets values used to determine what tabs display
            var setTabProperties = function () {
                // Adjust the max tab groups value if the tab group has less signups than the max number to display,
                $scope.tab.tabsToDisplay = $scope.tab.tabcount <= $scope.tab.maxtabGroups ? $scope.tab.tabcount : $scope.tab.maxtabGroups;

                if ($scope.tab.tabcount > $scope.tab.maxtabGroups) {
                    $scope.tab.firstDisplay = $scope.tab.index;
                    $scope.tab.lastDisplay = $scope.tab.index + $scope.tab.maxtabGroups;
                    if ($scope.tab.lastDisplay > $scope.tab.tabcount) {
                        var i = 0;
                        while ($scope.tab.lastDisplay > $scope.tab.tabcount) {
                            $scope.tab.lastDisplay--;
                            $scope.tab.firstDisplay--;
                            i++;
                            // Fallback to force a break and prevent an infinite loop if something goes wrong.
                            if (i >= $scope.tab.tabcount) {
                                break;
                            }
                        }
                    }

                    $scope.tab.previous = $scope.tab.index > 0 ? $scope.tabsignups.slice(0,$scope.tab.firstDisplay) : [];
                    $scope.tab.next = $scope.tab.index < $scope.tab.tabcount ? $scope.tabsignups.slice($scope.tab.index+$scope.tab.tabsToDisplay,($scope.tab.tabcount)) : [];

                }
                setTabThemes();
            };

            var setTabThemes = function() {
                var classContainer = '';
                var suTabBorderColor = '';
                var suTabBackgroundStyle = '';

                // Set the tab top border color for the displayed tabs
                for(var i=0; i<$scope.tabsignups.length; i++) {
                    // Set tab border class for each tab
                    suTabBorderColor = $scope.tabsignups[i].backgroundcolor.length ? ($scope.tabsignups[i].backgroundcolor.toLowerCase().trim() != '#ffffff' ? $scope.tabsignups[i].backgroundcolor : '#d9d9d9') : ($scope.tabsignups[i].textcolor1.toLowerCase().trim() != '#ffffff' ? $scope.tabsignups[i].textcolor1 :'#d9d9d9') ;
                    classContainer += '.tabGroup .multiple-signup--menu li.tab-' + $scope.tabsignups[i].listid +':before { border-top: 5px solid '+ suTabBorderColor + ' !important;} ';

                    // Side border for the +More menu
                    classContainer += '.tabGroup .multiple-signup--menu span ul.dropdown-menu li.plussmore-' + $scope.tabsignups[i].listid +' { border-left: 5px solid ' + suTabBorderColor + ';} ';
                }
                // Set active class based on selected tab
                suTabBackgroundStyle = $scope.tabsignups[$scope.tab.index].backgroundimage.length ? 'background-image: url("/images/theme/' + $scope.tabsignups[$scope.tab.index].backgroundimage + '") !important;' : 'background-color: ' + $scope.tabsignups[$scope.tab.index].backgroundcolor + ' !important';
                classContainer += '.tabGroup .multiple-signup--menu li.active a { color: ' + $scope.tabsignups[$scope.tab.index].textcolor1 + ' !important; ' + suTabBackgroundStyle + ' }';

                //SU pages use the No Brand footer by default; NB footer code omits these styles if SU is part of a TG, so we need to define them here for the specific SU shown
                classContainer += '.nb-copyright-text { color: ' + $scope.tabsignups[$scope.tab.index].textcolor1 + ' !important; } ';
                classContainer += '.nb-links { color: ' + $scope.tabsignups[$scope.tab.index].textcolor2 + ' !important; } ';

                // this is where our dynamic style container will be
                var styleContainer = angular.element( document.querySelector( '#tabStyles' ) );

                // create a style tag containing all the classes
                var dStyles = angular.element( '<style type="text/css">' + classContainer + '</style>' );

    			// append the style to the container
                styleContainer.html( dStyles );

                // Re-run this so the current signup's theme details are applied to the page, mainly the body background
                $scope.createSignUpStyle();
            };

            // Handles changing the tab when clicked
            $scope.changeTab = function(urlid) {
                // Only run code if the urlid is not the same as the urlid for the current tab.
                if (urlid !== $scope.tabsignups[$scope.tab.index].urlid) {
                    lookupTabIndex(urlid);
                    svc.setThemeInfo({});
                    $scope.urlkey = "";
                    svc.setUrlKey($scope.urlkey);

                    $window.location.href = '/go/' + $scope.tabsignups[$scope.tab.index].urlid + $scope.pidParam.newformat + '#/';
                    /* Used to reload route on change tabs as part of a SPA
                    if ($scope.isTabGroup) {
                        $route.reload();
                    } else if ($scope.isTabbedSignup) {
                        $window.location.href = '/go/' + $scope.tabsignups[$scope.tab.index].urlid + pidParam + '#/';
                    }
                    */
                }
            };

            /**
             * Setup tab data for the view
             */
            var initializeTabObject = function(tabgroup) {
                $scope.tabgroup = tabgroup.data.data;
                $scope.tabheader = tabgroup.data.data.header[0];
                $scope.tabsignups = $scope.tabgroup.signups;
                // Form object for handing More Sign Up Groups drop down
                $scope.frm = {
                    selectedTabGroup: ""
                 };
                $scope.othertabs = tabgroup.data.data.othertabs;
                $scope.tab = {
                    tabcount: $scope.tabgroup.signups.length,
                    selectedTabGroup: "",
                    maxtabGroups: 5,
                    index: 0,
                    previous: [],
                    next: [],
                    tabsToDisplay: 0,
                    firstDisplay: 0,
                    lastDisplay: 0
                };

                if ($scope.tab.index===0) {
                    lookupTabIndex();
                 }
            };

            /**
             * Determines whether or not the tab title is truncated,
             * then populates or clears out the tooltip text appropriately
             */
            $scope.checkForTabTruncation = function (fullTitle,id){
                $scope.popText = ( angular.element(document.getElementById(id))[0].offsetWidth < angular.element(document.getElementById(id))[0].scrollWidth ) ? fullTitle : "";
            };

            /**
             * Setup code for displaying a tabGroup.
             * Moved from init() to separate code
             */
            var setupTabGroup = function(){
                if (util.ajaxResultInvalid(tabgroup)) {
                    $scope.errorMessage = util.getAjaxResponseMessage( tabgroup.data );
                } else {
                    initializeTabObject(tabgroup);
                    svc.setTabGroup( tabgroup );
                    $scope.tab.index = svc.getTabIndex();

                    // Get urlkey based on tab index
                    if (!$scope.urlkey.length) {
                        $scope.urlkey = $scope.tabsignups[$scope.tab.index].urlid;
                        svc.setUrlKey($scope.urlkey);
                    }

                    svc.getsignup({forSignUpView:true, urlid:$scope.urlkey , portalid: $scope.portalid})
                    .then(function(result) {
                        var signupData = util.lowerCaseKeys(result);
                        signup = {};
                        signup = signupData;

                        if( util.ajaxResultInvalid(signup) || signup.data.data.urlid.toString().trim().toLowerCase()=='test-fail-tab'){
                            $scope.errorMessage = util.getAjaxResponseMessage( signup.data );
                        } else {
                            misvc.getMemberInfo({extended:true, forceRefresh:true, listid:0, urlid:signup.data.data.urlid})
                            .then(function(result) {
                                var memInfo = util.lowerCaseKeys(result);
                                memberinfo = {};
                                memberinfo = memInfo;

                                // memberinfo
                                $scope.memberInfo = memberinfo;
                                svc.setMemberInfo( memberinfo );

                                svc.gettheme({urlid:$scope.urlkey}).then(function(result) {
                                    var themeData = util.lowerCaseKeys(result);
                                    theme = themeData;
                                    if( util.ajaxResultInvalid(theme) ){
                                        $scope.errorMessage = util.getAjaxResponseMessage( theme.data );
                                    } else {
                                        procesSignupObject(signup, theme);
                                        setTabProperties();
                                    }
                                });

                            });
                        }
                    });
                }
            };

            /**
             * Method runs code to setup the signupController.
             * Moved from the init() to make it easer to call
             */
            var setupController = function(){
                // tab group
                if ($scope.isTabGroup) {
                    setupTabGroup();
                } else {
                    // memberinfo
                    $scope.memberInfo = memberinfo;
                    svc.setMemberInfo( memberinfo );
                    procesSignupObject(signup, theme);
                }
            };

            /**
             * initialize page
             */
            var init = function(){
                //If sign up is from an embedded portal, load some portal details before setting up the page
                if( fromEmbeddedPortal() ){
                    loadPortalEmbedData()
                    .then(function(){
                        setupController();
                    });
                } else {
                    setupController();
                }
                if (!tabgroup.signuptabbing) {
                    $location.path($scope.signupInfo.fullpath);
                }
            };

            /**
             * Method retrieves basic portal details for an embedded portal page.
	         * Embedded sign up pages use this to get back to the embedded portal they came from.
             */
            var loadPortalEmbedData = function(){
                var deferred = $q.defer();

                svc.getportalembeddata( { portalid: $scope.portalid } )
                .then(function(response){
                    //if an error occurs, a default object is still returned and the backToPortal view handled it
                    $scope.embedportalinfo = svc.getEmbedPortalInfo();
                    $scope.showBackToPortal = true;
                    $scope.pidParam.newformat = '/pid/' + $scope.portalid;
                    $scope.pidParam.oldformat = '&pid=' + $scope.portalid;

                    deferred.resolve();
                }, function(err){
                    deferred.reject(err);
                });

                return deferred.promise;
            };

            /**
             * Helper function to indicate if the signup is embedded and was opened from an embedded portal page
             * If sign up is loaded, check signup.data.data instead of $scope.signupInfo in case setupController() hasn't run yet
             * If a Tab Group is loaded we need to check tabgroup.data.data model for the allowEmbed flag
             */
            var fromEmbeddedPortal = function(){
                return ( (typeof signup.data != 'undefined' && signup.data.data.allowembed) || ($scope.isTabGroup && typeof tabgroup.data != 'undefined' && tabgroup.data.data.allowembed) ) && hasPortalId() ;
            };

            /**
             * Helper function to indicate if a portalId exists bc the SUP was loaded from an embedded Portal Page.
             */
            var hasPortalId = function(){
                return !Number.isNaN($scope.portalid) && $scope.portalid > 0;
            };

            $scope.determineSignupType = function(){
                // determine which view, display, format to use
                if ($scope.signupInfo.expired)
                    return 'expired';
                else if ( $scope.signupInfo.nodate )
                    return 'nodate';
                else if( $scope.signupInfo.usersvp )
                    return 'rsvp';
                else if( $scope.signupInfo.calendarview && $scope.showCalendarView )
                    return 'calendar';
                else if($scope.signupInfo.itemsort.toString().toLowerCase() === 'd' )
                    return 'standard_d';
                else
                    return 'standard_i';
            };

            /**
             * Calculates the total quantity already signed up for the given member
             * @param {Array} participantData - array of participant data for a specific slot/date combination
             * @param {Integer} memberid - memberid of the logged in user
             */
            $scope.getQtyForMember = function( participantData, memberid ){
                var myqty = 0;
                participantData.forEach( function(participant){
                    if( participant.memberid === memberid ){
                        myqty += participant.myqty;
                    }
                });

                return myqty;
            };

            // Build object based on session.signupformattrs object used by old sign up form to pass data to form when a user signs up
            var generateAttrs = function (data) {
                var attrsObj = {};
                attrsObj.mid = data.mid ? data.mid : $scope.memberInfo.memberid;
                attrsObj.requirecompany = data.requirecompany ? data.requirecompany : 0;
                attrsObj.showcompany = data.showcompany ? data.showcompany : 0;
                attrsObj.siid = data.siid ? data.siid : $scope.selectedSlotItems; // single slotitemid
                attrsObj.siids = data.siids ? data.siids : $scope.selectedSlotItems; // list of slotitemids
                attrsObj.urlid = data.urlid ? data.urlid : $scope.signupInfo.urlid;
                attrsObj.listid = data.listid ? data.listid : '';
                attrsObj.rsvpid = data.rsvpid ? data.rsvpid : '';
                attrsObj.token = data.token ? data.token : '';
                attrsObj.imid = data.mid ? data.imid : '';   //itemmemberid
                // Cache attr object
                svc.setAttrs (attrsObj);
            };

            $scope.saveAndContinue = function() {
                // if we are in preview mode, don't save
                if( $scope.previewMode ) return;

                var attrsObj = {};
                attrsObj.mid = $scope.memberInfo.memberid;
                attrsObj.siids = $scope.selectedSlotItems;
                attrsObj.urlid = $scope.signupInfo.urlid;
                generateAttrs(attrsObj);

                var signupformpath = '/form/' + $scope.signupInfo.listformat;
                $location.path (signupformpath);
            };

            /** method for social media sharing **/
            $scope.share = function( media ){
                // if we are in preview mode, don't execute
                if( $scope.previewMode ) return;

                var winorigin = angular.isDefined($window.location.origin) ? $window.location.origin : $window.location.protocol + '//' + $window.location.host;
                var signupurl = angular.isDefined($scope.signupInfo.fullurl) && $scope.signupInfo.fullurl !== '' ? $scope.signupInfo.fullurl : encodeURIComponent(winorigin + "/go/" + $scope.urlkey);
                var signupimage = $scope.theme.mainimage !== '' ? encodeURIComponent($scope.theme.mainimage) : encodeURIComponent(winorigin + "/images/theme/" + $scope.theme.id + "-large.jpg");
                var mediaurl = '';
                var winsize = '';
                var py = 0;
                var px = 0;
                var tweettext = encodeURIComponent('Check out "' + $scope.signupInfo.header.title.toString().trim() + '" on @SignUpGenius');
                if( media === 'fb' ){
                    winsize = "width=640,height=400";
                    py = $window.top.outerHeight / 2 + $window.top.screenY - ( 400 / 2);
                    px = $window.top.outerWidth / 2 + $window.top.screenX - ( 640 / 2);
                    mediaurl = "http://www.facebook.com/sharer/sharer.php?u=" + signupurl + "&src=sp";
                }
                else if( media === 'pinterest' ){
                    winsize = "width=740,height=700";
                    py = $window.top.outerHeight / 2 + $window.top.screenY - ( 700 / 2);
                    px = $window.top.outerWidth / 2 + $window.top.screenX - ( 740 / 2);
                    mediaurl = "http://pinterest.com/pin/create/button/?url=" + signupurl + "&media=" + signupimage + "&description=" + tweettext + '%20' + signupurl;
                }
                else if( media === 'twitter' ){
                    winsize = "width=640,height=320";
                    py = $window.top.outerHeight / 2 + $window.top.screenY - ( 320 / 2);
                    px = $window.top.outerWidth / 2 + $window.top.screenX - ( 640 / 2);
                    mediaurl = "https://twitter.com/share?text=" + tweettext + "&url=" + signupurl;
                }

                // open the window
                winsize += ",top=" + py + ",left=" + px;
                $window.open(mediaurl,'_blank',winsize);
            };

            // Used by the More Sign Up Groups drop down list to direct the user to a different tab group.
            $scope.changeTabGroup = function () {
                if ($scope.frm.selectedTabGroup.length) {
                    var url = '/tabs/' + $scope.frm.selectedTabGroup.toString().trim() + $scope.pidParam.newformat;
                    $window.location.href = url;
                }
            };

            // init page
            init();
        }
    ]);

    // helper methods - move these helpers to a service
    var getContainerClass = function( s ){
        var container = {
            'background-color' : s.backgroundcolor
            , 'width' : '100%'
        };
        if( s.backgroundimage !== '' )
            container['background-image'] = 'url(' + s.backgroundimage + ') !important';


        // moved the container styles to the body: SUG-2579
        var classContainer = " body {";
        for( var key in container ){
            if(!container.hasOwnProperty(key))
                continue;
            classContainer += key + ':' + container[key] + ';';
        }
        classContainer += '}';

        // back to portal nav
        classContainer += ' .l-signuppage .backtoportal { ';
        classContainer += ' background-color: ' + s.tableheaderbackground + ';';
        classContainer += ' color: ' + s.tableheadertext + ';';
        classContainer += ' border-bottom: 1px solid ' + s.textcolor1 + ' !important;';
        if( s.tableheaderimage !== '' )
            classContainer += ' background-image: url(' + s.tableheaderimage + ') !important;';
        classContainer += '}';
        classContainer += ' .l-signuppage .backtoportal li a {  color: ' + s.tableheadertext + '; }';

        // Moved color back to signupPage to prevent unintended impacts on sign up form: SUG-2835, SUG-2838, SUG-3840, SUG-2845
        classContainer += ' .signupPage { color: ' + s.textcolor1 + ' }';
        classContainer += ' .signupPage p { color: ' + s.textcolor1 + ' }';
        classContainer += ' .signupPage h1 { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .signupPage .SUGlink { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .signupPage .hdr-labels { color: ' + s.textcolor1 + ' !important; }';
        classContainer += ' .signupPage .sugbutton { color: ' + s.backgroundcolor + ' !important; font-weight: bold; background-color: ' + s.textcolor1 + ' !important; font-size:inherit; margin-left:10px; padding:8px; border-radius: 17px;}';
        // hyperlinks
        classContainer += ' .signupPage a, .signupPage .hyperlink { color: ' + s.textcolor2 + '; }';
        classContainer += ' .signupPage .hyperlink:focus, .signupPage .hyperlink:hover, .signupPage .hyperlink:active, .signupPage a:focus, .signupPage a:hover, .signupPage a:active  { color: ' + s.textcolor2 + '; text-decoration: underline;  }';
        // thead
        classContainer += ' .signupPage thead { ';
        classContainer += ' background-color: ' + s.tableheaderbackground + ';';
        classContainer += ' color: ' + s.tableheadertext + ';';
        if( s.tableheaderimage !== '' )
            classContainer += ' background-image: url(' + s.tableheaderimage + ') !important;';
        classContainer += '}';
        // tbody
        classContainer += ' .signupPage tbody { ';
        classContainer += ' background-color: ' + s.backgroundcolor + ';';
        classContainer += ' border-top: 1px solid ' + s.textcolor1 + ' !important;';
        classContainer += '}';
        // this was copied over from the old sign up page styles but not sure why.  Commenting out for now
        //classContainer += ' .signupPage tbody > tr:nth-child(2) > td { ';
        //classContainer += ' padding-top: 0;';
        //classContainer += '}';
        // th
        classContainer += ' .signupPage th { border-bottom: 2px solid ' + s.textcolor1 + ' !important; }';
        // td
        classContainer += ' .signupPage td { border: none !important; }';
        // tfoot
        classContainer += ' .signupPage tfoot { ';
        classContainer += ' background-color: ' + s.tableheaderbackground + ';';
        classContainer += ' color: ' + s.tableheadertext + ';';
        if( s.tableheaderimage !== '' )
            classContainer += ' background-image: url(' + s.tableheaderimage + ') !important;';
        classContainer += '}';
        // table
        classContainer += ' .signupPage table { ';
        classContainer += ' border-top: 3px solid ' + s.textcolor1 + ';';
        classContainer += ' border-right: 1px solid ' + s.textcolor1 + ';';
        classContainer += ' border-bottom: 3px solid ' + s.textcolor1 + ';';
        classContainer += ' border-left: 1px solid ' + s.textcolor1 + ';';
        classContainer += '}';
        classContainer += ' .signupPage .table-wrapper tr:not(:first-child) td:first-child:before { border-bottom-color: ' + s.textcolor1 + ' }';

        // specific classes
        classContainer += ' .signupPage .padded-options.indicator:before { border-left: 2px solid ' + s.textcolor1 + '; }';
        classContainer += ' .signupPage .padded-options.indicator:after { color: ' + s.textcolor1 + '; }';

        // buttons
        classContainer += ' .signupPage .btn-default { ';
        classContainer += " border: 1px solid transparent" + ";";
        classContainer += ' color: ' + s.textcolor1 + ';';
        classContainer += ' background: transparent; ';
        classContainer += '}';
        classContainer += ' .signupPage .btn-success { ';
        classContainer += ' background-color: ' + s.tableheaderbackground + ';';
        classContainer += ' color: ' + s.tableheadertext + ';';
        classContainer += ' border: 1px solid ' + s.textcolor1 + ';';
        if( s.tableheaderimage !== '' )
            classContainer += ' background-image: url(' + s.tableheaderimage + ') !important;';
        classContainer += '}';

        //button bar
        classContainer += ' .signupPage .btn-bar { ';
        if( s.tableheaderimage === '' ){
            classContainer += ' background-color: ' + s.tableheaderbackground  + ';';
        }else{
            classContainer += ' background-color: ' + s.textcolor1 + ';';
        }
        classContainer += ' color: ' + s.tableheadertext + ';';
        classContainer += '}';
        // submit button (this stays here in case we want to change the shadow color based dynamically)
        classContainer += ' .signupPage .btn-bar .submit-btn-wrap .btn-signup-submit { ';
        classContainer += ' -moz-box-shadow: 0px 6px 10px 0 rgba(34,34,34,.35);';
        classContainer += ' -webkit-box-shadow: 0px 6px 10px 0 rgba(34,34,34,.35);';
        classContainer += ' box-shadow: 0 6px 10px 0 rgba(34,34,34,.35);';
        classContainer += ' border: 1px solid ' + s.tableheadertext + ';';
        classContainer += '}';

        // tooltip
        classContainer += ' .signupPage .feedback-tooltip { ';
        classContainer += ' background-color: ' + s.textcolor2 + ' !important;';
        classContainer += ' color: ' + s.backgroundcolor + ' !important;';
        classContainer += '}';
        classContainer += ' .signupPage .feedback-tooltip:before { border-right-color: ' + s.textcolor2 + '; }';
        classContainer += ' .signupPage .table .feedback-tooltip:before { border-bottom-color: ' + s.textcolor2 + '; }';

        // errors
        var errorBGColor = s.buttoncolor;
        var errorBorderColor = s.buttontextcolor;
        var errorTextColor = s.buttontextcolor;
        classContainer += ' .signupPage .form-control-danger { border-color: ' + s.textcolor2 + '; }';
        classContainer += ' .signupPage .form-group.has-error::before, .signupPage .control-group.has-error::before { border-left: 6px solid ' + s.textcolor2 + '; }';
        classContainer += ' .signupPage .feedback-error { ';
        classContainer += ' background-color: ' + errorBGColor + ';';
        classContainer += ' color: ' + errorTextColor + ';';
        classContainer += ' border-color: ' + errorBorderColor + ';';
        classContainer += ' width: 100%;';
        classContainer += '}';
        classContainer += ' .signupPage .feedback-error a { ';
        classContainer += ' color: ' + errorTextColor + '; text-decoration: underline;';
        classContainer += '}';
        classContainer += ' .signupPage .has-error .form-control, .signupPage .has-error .form-control-feedback { ';
        classContainer += ' border-color: ' + s.textcolor2 + ';';
        classContainer += ' color: ##000000;';
        classContainer += '}';
        classContainer += ' .signupPage .has-error label { ';
        classContainer += ' color: ' + s.textcolor2 + ';';
        classContainer += ' font-weight: bold; ';
        classContainer += '}';

        // misc
        classContainer += ' .signupPage .sm-color { fill: ' + s.textcolor2 + '; }';
        classContainer += ' .signupPage .sm-icon-size { width: 48px;  height: 48px; }';
        classContainer += ' .signupPage .signup--badge { background-color: ' + s.buttoncolor + '; color: ' + s.buttontextcolor + '}';

        classContainer += ' .signupPage .sub-footer .nobrand { ';
        classContainer += ' background-color: ' + s.backgroundcolor + ';';
        if( s.backgroundimage !== '' )
            classContainer += ' background-image: url(' + s.backgroundimage + ') !important;';
        classContainer += '}';
        classContainer += ' .signupPage .sub-footer .nobrand > .hyperlink, .signupPage .sub-footer .nobrand > .verysmalllink { ';
        classContainer += ' text-decoration: underline;';
        classContainer += ' color: ' + s.TextColor2 + ';';
        classContainer += '}';

        // data grid
        classContainer += ' .signupPage .date-sorted .signupdata--date-dt { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .signupPage .slot-sorted .signupdata--slot-title { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .l-signuppage .no-date .signupdata--slot-title { color: ' + s.textcolor2 + '!important; }';

        // calendar view
        classContainer += ' .signupPage .calendar-view .cv-month-label--month { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .signupPage .calendar-view .cv-month-label--nav a { color: ' + s.textcolor2 + ' !important; }';
        classContainer += ' .signupPage .calendar-view .cv-hdr { ';
        classContainer += ' background-color: ' + s.tableheaderbackground + ';';
        classContainer += ' color: ' + s.tableheadertext + ';';
        if( s.tableheaderimage !== '' )
            classContainer += ' background-image: url(' + s.tableheaderimage + ') !important;';
        classContainer += '}';
        var cvBorderColor = s.textcolor1;
        classContainer += ' .signupPage .calendar-view .cv-grid { border-color: ' + cvBorderColor + '; }';
        classContainer += ' .signupPage .calendar-view .cv-day { box-shadow: -1px -1px ' + cvBorderColor + ', inset -1px -1px 0 0 ' + cvBorderColor + ';}';
        classContainer += ' .signupPage .calendar-view .cv-day.weekend { background-color: ' + s.mutedTextColor1 + ';}';
        classContainer += ' .signupPage .calendar-view .cv-day:hover { background-color: ' + s.mutedButtonColor + ';}';

       classContainer += '.tabBackground { background-color:  '+ s.backgroundcolor + 'width: 100%; background-image: url( ' + s.backgroundimage + ') !important;}';

        // return styles
        return classContainer;

    };


    // passcode controller
    SUGApp.controller('signUpPasscodeController',
        ['$scope','$location','signupPageService','SUGUtilities','errorService','$route',
        function( $scope,$location,svc,util,errorService,$route ) {

        $scope.errorMessage = '';
        $scope.disableForm = true;
        $scope.portalid = svc.getPortalId();
        $scope.str = {
            instruction: 'To view this sign up, please enter the Access Code provided by the sign up creator in the email invitation.  Contact the sign up creator to obtain the access code if you did not receive an email invitation.',
            label: 'Access Code:',
            title: 'Access Code Required',
            contact: 'Having problems with access? For help, ',
            contactlink: 'contact the sign up creator.',
        };
        $scope.frmObj = {
            accessCode: '',
        };

        // instantiate error handler
        $scope.es = errorService.newInstance();
        $scope.errorStrings = {
            errorsTitle: '',
            errorsPleaseCorrect: 'Please correct the issues indicated below.'
        };

        /**
         * Validate and submit access code
         */
        $scope.submitAccessCode = function(){
            $scope.es.clearErrors();
            if( $scope.frmObj.accessCode.length ){
                $scope.disableForm = true;

                var params = { forSignUpView:true, urlid: $scope.urlkey, passcode: $scope.frmObj.accessCode , portalid: $scope.portalid };

                svc.getsignup(params,1)
                    .then(function(result){
                        var r = util.lowerCaseKeys( result );
                        if (r.data.success) {
                            svc.toggleDefaultTtl()
                            // If the passcode is successfully entered, reload the route properly direct the user to the the signup and prevent scoping issues
                            $route.reload();
                        } else {
                            // If passcode was incorrect, reenable the form and display the error message.
                            $scope.disableForm = false;
                            $scope.es.setError('accesscode','no msg');
                            $scope.es.setError('error-top-level',r.data.message);
                        }
                    });
            } else{
                $scope.es.setError('accesscode','no msg');
                $scope.es.setError('error-top-level','no msg');
            }
        };

        var init = function(){
            $scope.disableForm = false;
            // get signup info
            svc.getsignup({ forSignUpView:true, urlid: $scope.urlkey, portalid: $scope.portalid })
                .then(function(response){
                    var r = util.lowerCaseKeys( response );
                    if( !util.ajaxResultInvalid(r) ){
                        var signup = r.data.data;
                        // set contact creator link and append the portalId param
                        $scope.contactLink = '/index.cfm?go=c.help&mid=' + signup.mid + '&id=' + signup.id;
                        // get theme info
                        var theme = svc.getThemeInfo();
                        $scope.linkcolor = util.keyExists(theme, 'textcolor2', true) ? theme.textcolor2 : '';
                        // set instruction to message if not an error
                        $scope.str.instruction = signup.message;
                        //Append portal id parameter if necessary
                        if( signup.allowembed && (!Number.isNaN($scope.portalid) && $scope.portalid > 0) ){
                            $scope.contactLink += '&pid=' + $scope.portalid;
                        }
                    }else{
                        var errorMessage = r.data && r.data.data && r.data.data.message ? r.data.data.message : 'An error occurred while retrieving the sign up information. Please try again at a later time.';
                        $scope.es.setError('error-top-level',errorMessage);
                    }
                }
            );

        };

        init();
    }]);

    // standard sign up controller
    SUGApp.controller('standardSignUpController',
        ['$scope','SUGUtilities','signupPageService','$filter','errorService','$sce','$window','$timeout',
        function( $scope,util,svc,$filter,errorService,sce,$window,$timeout ) {

        // get the cached info
        $scope.memberInfo = svc.getMemberInfo();
        $scope.signupInfo = svc.getSignUpInfo();
        $scope.themeInfo = svc.getThemeInfo();
        $scope.dateFormat = typeof $scope.signupInfo.shortdformat !== 'undefined' ? $scope.signupInfo.shortdformat.replace("mm","MM") : 'MM/dd/yyyy';

        var arrData = [];

        // limits on inital load
        $scope.displayLimits = {
            dates: 5,
            items: 8
        };
        $scope.slotCount = 0;
        $scope.filteredData = [];
        $scope.showLocation = false;
        $scope.slotTemplate = 'slots_standard.html';
        $scope.columnCount = 1;

        // set slot title
        if( util.keyExists($scope.signupInfo, 'slottitle', true) && $scope.signupInfo.slottitle !== $scope.strings.lbls.availableSlot ){
            $scope.strings.lbls.availableSlot = $scope.signupInfo.slottitle;
        }
        
        /*
        // handles page setup when new slots added
        $scope.$watch('signupInfo.currentSlots', function(newValue) {
            $scope.filteredData = [];
            arrData = [];
            init();
        })*/

        /**
         * Prep data for UI presentation
         */
        var prepData = function(){
            /*if ($scope.signupInfo.allSlotsHidden)
                return;
            */
            $scope.showTime = false;

            
            /*var currentPageObj = $scope.signupInfo.currentSlots[0];
            var objSlots = util.deepCopy(currentPageObj);
            */
            // Uncomment to use old non-paginated version
            var objSlots = util.deepCopy($scope.signupInfo.slots);
            
            $scope.virtualLocations = $scope.signupInfo.virtuallocations;
            // build return value to be iterated
            for (var key in objSlots) {
                if (objSlots.hasOwnProperty(key)) {
                    // date label
                    objSlots[key]['dateLabel'] = getDateLabel( objSlots[key].starttime );
                    // time label
                    objSlots[key]['timeLabel'] = objSlots[key].usetime ? getTimeLabel( objSlots[key].starttime, objSlots[key].endtime ) : '';
                    // location
                    if( objSlots[key].location.length ){ $scope.showLocation = true; }
                    var stcLoc = typeof objSlots[key].locationid !== 'undefined' && objSlots[key].locationid > 0 ? getLocationObj(objSlots[key].locationid) : getLocationObj( 0 );
                    objSlots[key]['locdetail'] = {
                        url: stcLoc.url,
                        full: stcLoc.full,
                        address1: stcLoc.address1,
                        address2: stcLoc.address2,
                        city: stcLoc.city,
                        state: stcLoc.state,
                        zipcode: stcLoc.zipcode,
                        showicon: true,
                        virtuallocationurl: null,
                        physicalandvirtual: false
                    };
                    // Add the virtual location detials to the object slots view model
                    if (objSlots[key].virtuallocationid) {
                        const virtualLocationId =  objSlots[key].virtuallocationid;
                        objSlots[key]['virtualocdetail'] = $scope.virtualLocations[virtualLocationId];
                        objSlots[key]['locdetail'].virtuallocationurl =  $scope.virtualLocations[virtualLocationId].virtuallocationlinkurl;
                        objSlots[key]['locdetail'].virtuallocationtype =  $scope.virtualLocations[virtualLocationId].type;
                    }
                    // Some locations can be both physical and virtual, so we need to add some details around that that can be passed into the <sug-address> directive
                    objSlots[key].virtuallocationid > 0 && objSlots[key].locationid > 0  ? objSlots[key]['locdetail'].physicalandvirtual = true : objSlots[key]['locdetail'].physicalandvirtual = false;
                    // iterate items
                    for( var i=0; i<objSlots[key].items.length; i++ ){
                        var itemId = objSlots[key].items[i].itemid;
                        // complete image object, needed for image zoom modal
                        var objImages = typeof $scope.signupInfo.itemimages[itemId] !== 'undefined' ? $scope.signupInfo.itemimages[itemId] : {};
                        objSlots[key].items[i]['images'] = objImages;
                        // add main image per item
                        if( typeof objSlots[key].items[i]['itemimage'] === 'undefined' ){
                            objSlots[key].items[i]['itemimage'] = util.keyExists($scope.signupInfo.itemimages[itemId],'images',true) && $scope.signupInfo.itemimages[itemId].images.length ? $scope.signupInfo.itemimages[itemId].images[0] : '';

                        }
                        // handle availability and participants
                        objSlots[key].items[i]['participants'] = util.keyExists($scope.signupInfo, 'participants', true) && util.keyExists($scope.signupInfo.participants, objSlots[key].items[i].slotitemid, true) ? $scope.signupInfo.participants[objSlots[key].items[i].slotitemid] : [];
                        var stcAvailable = svc.getAvailability( objSlots[key].items[i].qty, objSlots[key].items[i].qtytaken, objSlots[key].items[i].isaddlocked, $scope.isLocked(), objSlots[key].items[i].hidenumberwanted, objSlots[key].items[i].waitlist, svc.getMemberParticipantData(objSlots[key].items[i]['participants'], $scope.memberId) );
                        objSlots[key].items[i]['waitlistPosition'] = stcAvailable.waitlistPosition;
                        objSlots[key].items[i]['qtyLabel'] = stcAvailable.qtyLabel;
                        objSlots[key].items[i]['qtyLabelResponsive'] = stcAvailable.qtyLabelResponsive;
                        objSlots[key].items[i]['waitlistQtyLabel'] = svc.getWaitlistAvailability(objSlots[key].items[i].waitlist, objSlots[key].items[i].waitlistedparticipantcount, objSlots[key].items[i].qty, objSlots[key].items[i].qtytaken);
                        // if there are selected slotitems in scope, first determine if this slotid is selected
                        var isSelected = false;
                        if( $scope.selectedSlotItems.length ){
                            var selectedIdx = $scope.selectedSlotItems.findIndex( function(siID){
                                return siID === objSlots[key].items[i].slotitemid;
                            });
                            if( selectedIdx > -1 ){
                                isSelected = true;
                            }
                        }
                        objSlots[key].items[i]['btnState'] = isSelected ? 'selected' : stcAvailable.btnState;
                        // get the logged in member's qty already signed up for
                        objSlots[key].items[i]['myqty'] = ( $scope.memberId ) ? $scope.getQtyForMember(objSlots[key].items[i]['participants'], $scope.memberId) : 0;
                        objSlots[key].items[i]['deleteModalInfo'] = $scope.getDeleteModalInfo( objSlots[key].items[i], objSlots[key], objSlots[key].items[i].slotitemid );
                    }

                    // add item
                    arrData.push(objSlots[key]);
                }
            }

            // sort by date and then location
            arrData.sort(function(a, b) {
                var dtA = new Date(a.starttime);
                var dtB = new Date(b.starttime);
                var locA = a.location;
                var locB = b.location;
                var locIdA = a.locationid;
                var locIdB = b.locationid;

                if( dtA.getTime() < dtB.getTime() ){
                    return -1;
                }
                if( dtA.getTime() > dtB.getTime() ){
                    return 1;
                }
                // dates are equal if we got this far (dtA == dtB will always return false)
                if( locA < locB ){
                    return -1;
                }
                if( locA > locB ){
                    return 1;
                }
                // if dates and location names are the same, ensure locationid is sorted as well
                if( locIdA < locIdB ){
                    return -1;
                }
                if( locIdA > locIdB ){
                    return 1;
                }

                // everything is equal
                return 0;
            });
        };

        /**
         * Deletes an item member.
         *
         * @modalInfo {Object} - see getDeleteModalInfo for contents
         * @itemmember {Object} - the itemmember to delete
         */
        $scope.deleteItemMember = function(modalInfo, itemmember){
            // wait for the promise to resolve and if successful, delete the item member from the client side cache
            svc.deleteItemMemberModal(modalInfo, itemmember).then(function (deleteInfo) {
                // delete the itemmember from the main participants array
                var participants = $scope.signupInfo.participants[modalInfo.slotitemid];
                $scope.signupInfo.participants[modalInfo.slotitemid] = participants.filter( function(itemmember){
                    return itemmember.itemmemberid != deleteInfo.itemmemberid;
                });

                // update the filterdata participants array for the slotitem
                // find the item's index
                var slotIdx;
                $scope.filteredData.some( function(slot, sIdx){
                    if( slot.slotid === modalInfo.slotid ){
                        slotIdx = sIdx;
                        return true;
                    }else{
                        return false;
                    }
                });

                // if item found, find the slottitem
                if( util.isIntegerGTE0(slotIdx) ){
                    var slotitemIdx;
                    $scope.filteredData[slotIdx].items.some( function(slotitem, siIdx){
                        if( slotitem.slotitemid === modalInfo.slotitemid ){
                            slotitemIdx = siIdx;
                            return true;
                        }else{
                            return false;
                        }
                    });
                    // if slotitem found, update the participants array and quantity info for the item member
                    if( util.isIntegerGTE0(slotitemIdx) ){
                        $scope.filteredData[slotIdx].items[slotitemIdx].participants = $scope.signupInfo.participants[deleteInfo.slotitemid];
        
                        if (!deleteInfo.waitlistsignup && $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount > 0) {
                            // take the deleted signup myqty and remove from the waitlistedparticipantcount
                            // if the result of the waitlistedparticipantcount is negative, then remove that from the qtytaken and zero out the waitlistedparticipantcount

                            $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount = ($scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[slotIdx].items[slotitemIdx].myqty);
                           
                            if ($scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount < 0) {
                                $scope.filteredData[slotIdx].items[slotitemIdx].qtytaken += $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount;
                                $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount = 0;
                            }
                        }
                        else if (deleteInfo.waitlistsignup) {
                            $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount = Math.max($scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[slotIdx].items[slotitemIdx].myqty, 0);
                            $scope.filteredData[slotIdx].items[slotitemIdx].qtytaken = Math.max($scope.filteredData[slotIdx].items[slotitemIdx].qtytaken, 0);
                        }
                        else {
                            $scope.filteredData[slotIdx].items[slotitemIdx].qtytaken = Math.max($scope.filteredData[slotIdx].items[slotitemIdx].qtytaken - $scope.filteredData[slotIdx].items[slotitemIdx].myqty, 0);
                        }

                        var stcAvailable = svc.getAvailability( $scope.filteredData[slotIdx].items[slotitemIdx].qty, $scope.filteredData[slotIdx].items[slotitemIdx].qtytaken, $scope.filteredData[slotIdx].items[slotitemIdx].isaddlocked, $scope.isLocked(), $scope.filteredData[slotIdx].items[slotitemIdx].hidenumberwanted, $scope.filteredData[slotIdx].items[slotitemIdx].waitlist, svc.getMemberParticipantData($scope.filteredData[slotIdx].items[slotitemIdx].participants, $scope.memberId) );
                        $scope.filteredData[slotIdx].items[slotitemIdx].waitlistPosition = stcAvailable.waitlistPosition;
                        $scope.filteredData[slotIdx].items[slotitemIdx].qtyLabel = stcAvailable.qtyLabel;
                        $scope.filteredData[slotIdx].items[slotitemIdx].qtyLabelResponsive = stcAvailable.qtyLabelResponsive;
                        $scope.userSignUp.totalQty -= $scope.filteredData[slotIdx].items[slotitemIdx].myqty;
                        $scope.filteredData[slotIdx].items[slotitemIdx].myqty = ( $scope.memberId ) ? $scope.getQtyForMember($scope.filteredData[slotIdx].items[slotitemIdx].participants, $scope.memberId) : 0;
                        $scope.filteredData[slotIdx].items[slotitemIdx].waitlistQtyLabel = svc.getWaitlistAvailability($scope.filteredData[slotIdx].items[slotitemIdx].waitlist, $scope.filteredData[slotIdx].items[slotitemIdx].waitlistedparticipantcount, $scope.filteredData[slotIdx].items[slotitemIdx].qty, $scope.filteredData[slotIdx].items[slotitemIdx].qtytaken);

                        // If a person was just removed from a slot then we know we have at least 1 available slot, so be sure to reset hasAvailableSlots
                        if (!$scope.signupInfo.hasavailableslots) {
                            $scope.signupInfo.hasavailableslots = true;
                            $scope.es.clearErrors();
                        }

                        $scope.filteredData[slotIdx].items[slotitemIdx].btnState = stcAvailable.btnState;
                    }
                }
            });
        };

        /**
         * Iterate arrData and determine what dates should be grouped together
         */
        var groupDates = function(){
            var uniqueDates = {};
            var flags = [];
            var dateCount = 0;
            var last = {
                date: '',
                time: '',
            };
            var calcShowTimeColumn = !$scope.showHeaderTime();

            // get unique dates
            for( var i=0; i < arrData.length; i++ ){
                // if key doesn't exist - shouldn't get here
                if( !util.keyExists( arrData[i], 'dateLabel', true ) && !util.keyExists( arrData[i].dateLabel, 'date', true ) ){
                    continue;
                }

                // compare with last time - if same date has multiple times, set to show time column
                if( calcShowTimeColumn ){
                    if( arrData[i].dateLabel.date == last.date ){
                        if( arrData[i].timeLabel != last.time ){
                            $scope.showTimeColumn = true;
                        }
                        last.time = arrData[i].timeLabel;
                    }
                    else{
                        last.date = arrData[i].dateLabel.date;
                        last.time = arrData[i].timeLabel;
                    }
                }

                // if showing dates in data grid
                if( !$scope.showHeaderDate() ){
                    // if key already exists, increment counter and continue
                    if( flags[arrData[i].dateLabel.date] ){
                        uniqueDates[arrData[i].dateLabel.date].count += 1;
                        continue;
                    }
                    // if key doesn't exist, add it
                    flags[arrData[i].dateLabel.date] = true;
                    uniqueDates[arrData[i].dateLabel.date] = {
                        count: 1,
                        firstslotid: arrData[i].slotid,
                    };
                    dateCount += 1;
                }
            }
            // iterate through items and append row span
            for( var dt=0; dt < arrData.length; dt++ ){
                var daterowspan = 0;
                for( var item in uniqueDates ){
                    if( arrData[dt].slotid == uniqueDates[item].firstslotid ){
                        daterowspan = uniqueDates[item].count;
                        break;
                    }
                }
                arrData[dt]["daterowspan"] = daterowspan;
            }
            // if there is more than date, show calendar icon
            if( dateCount > 1 ){
                $scope.showCalendarIcon = true;
            }
        };

        /**
         * Iterate arrData and determine what locations should be grouped together
         * Group rows with the same date and location in the same row
         */
        var groupLocations = function(){
            var uniqueLocs = {};
            var flags = [];
            // if showing locations in data grid
            if( !$scope.showHeaderLocation() ){

                // get unique locations
                var loc_key;
                var loc_slot_key;
                for( var i=0; i < arrData.length; i++ ){
                    // if key doesn't exist - shouldn't get here
                    if( ( !util.keyExists( arrData[i], 'dateLabel', true) && !util.keyExists( arrData[i].dateLabel, 'date', true) )
                        || !util.keyExists( arrData[i], 'location', true)
                        || !util.keyExists( arrData[i], 'locationid', true)
                        || !util.keyExists( arrData[i], 'starttime', true)
                        || !util.keyExists( arrData[i], 'endtime', true)
                        ){
                        continue;
                    }
                    // define key
                    // used location name (arrData[ul].location) - may need to hash this if some data values become problematic as object property names
                    var newLocation = ( loc_key !== arrData[i].dateLabel.date + '_' + arrData[i].location + '_' + arrData[i].locationid );
                    if( newLocation ){
                        loc_key = arrData[i].dateLabel.date + '_' + arrData[i].location + '_' + arrData[i].locationid;
                    }

                    // if key already exists, increment counter and continue
                    if( flags[loc_key] && !newLocation ){
                        uniqueLocs[loc_key][loc_slot_key].count += 1;
                        continue;
                    }else if( flags[loc_key] && newLocation ){
                        loc_slot_key = arrData[i].slotid;
                        if( util.keyExists(uniqueLocs[loc_key],loc_slot_key,true) ){
                            uniqueLocs[loc_key][loc_slot_key].count += 1;
                        }else{
                            uniqueLocs[loc_key][loc_slot_key] = {
                                count: 1
                            };
                        }
                        continue;
                    }
                    // if key doesn't exist, add it
                    loc_slot_key = arrData[i].slotid;
                    flags[loc_key] = true;
                    uniqueLocs[loc_key] = { date: arrData[i].dateLabel.date };
                    uniqueLocs[loc_key][loc_slot_key] = {
                        count: 1
                    };
                }
            }

            // iterate through items and append row span
            for( var l=0; l < arrData.length; l++ ){
                var locrowspan = 0;
                for( var item in uniqueLocs ){
                    if( uniqueLocs.hasOwnProperty(item) ){
                        if( arrData[l].dateLabel.date == uniqueLocs[item].date
                            && util.keyExists(uniqueLocs[item],arrData[l].slotid,true) ){
                                locrowspan = uniqueLocs[item][arrData[l].slotid].count;
                            break;
                        }
                    }
                }
                arrData[l]["locationrowspan"] = locrowspan;
            }
        };

        /**
         * Sets filter on slots - returns filtered slots as $scope.filteredData
         *      (similar function - rsvpSignUpController::filterSlots - may be able to combine in signupController)
         */
        $scope.setFilteredData = function(){
            $scope.filteredData = arrData;
        };

        /**
         * Returns the most slots in a single date
         */
        var getSlotCount = function( filteredData ){
            var mostSlots = 0;

            for(var f=0; f < filteredData.length; f++){
                if( filteredData[f].items && (mostSlots < filteredData[f].items.length) ){
                    mostSlots = filteredData[f].items.length;
                }
            }

            return mostSlots;
        };

        /*
        * method called on scroll
        *   expects a scrollable element to have class="scrollable"
        *   and a parent wrapping element with the same id as itself plus "-wrap"
        *   (i.e. id="myelement" with parent of id="myelement-wrap")
		*/
		var setScroll = function(){
            var scrollableElems = document.getElementsByClassName('scrollable');
            var intBuffer = 8;
            for (var i = 0; i < scrollableElems.length; i++) {
                var elemWrap = document.getElementById( scrollableElems[i].id + '-wrap' );
                var elemSubj = $( '#' + scrollableElems[i].id );
                calcScroll( elemWrap, elemSubj, intBuffer );
            }
        };

        /**
		 * Helper method to calulate scroll for sticky segment - adds appropriate css to subject element
		 * @elWrap - reference to DOM wrapping element (sets the top and bottom of the content section to scroll)
		 * @elSubject - reference to subject element to scroll
		 * @intBuffer - int, pixels to add as a buffer to the top and bottom of the scrolled content
		 */
        var calcScroll = function( elWrap, elSubject, intBuffer ){
            var elemHeight = elSubject.height();
            var intSubjectWidth = $scope.columnWidths[elSubject[0].id];
            var intWrapWidth = $scope.columnWidths[elWrap.id];
            if( elWrap.getBoundingClientRect().top > 0 ){   // scroll has not reached top of subject yet
                elSubject.css({ position:'relative', top: 0 });
            }
            else if( elWrap.getBoundingClientRect().bottom - elemHeight - (2 * intBuffer) >= 0 ){ // scroll is between top of subject element and bottom (including top and bottom buffer)
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: intBuffer });
                // reset width of wrapping element
                // this was required in some cases where the only child of the wrapper was the one being scrolled and position:fixed caused all columns to collapse
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else if( elWrap.getBoundingClientRect().bottom >= 0 ){  // scroll is after element height minus top/bottom buffer but before subject bottom
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: elWrap.getBoundingClientRect().bottom - elemHeight - intBuffer });
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else{   // scroll is passed element bottom (element is off screen)
                elSubject.css({ position: 'relative', top: 0});
            }
        };

        /**
		 * Helper method to set starting column widths scrollable elements and wrappers
         * Subsequently used by scrolling method to ensure originally rendered widths are retained
         * Sets a scoped object with key value pairs where key is the element id and value is the pixel width
         * (i.e. { 39821-48522-date-wrap: 100, ... } )
		 */
        var setStartingColumnWidths = function(){
            $scope.columnWidths = {};
            var scrollableElems = document.getElementsByClassName('scrollable');
            for (var i = 0; i < scrollableElems.length; i++) {
                $scope.columnWidths[ scrollableElems[i].id ] = document.getElementById( scrollableElems[i].id ).getBoundingClientRect().width;
                $scope.columnWidths[ scrollableElems[i].id + '-wrap' ] = document.getElementById( scrollableElems[i].id + '-wrap' ).getBoundingClientRect().width;
            }
        };

        /**
		 * Helper method to return formatted date and day
		 * @strStart - start time
		 */
        var getDateLabel = function( strStart ){
            var dtStart = new Date(strStart);
            var stcStartDate = {
                "date": $filter('date')(dtStart, $scope.signupInfo.shortdformat.replace('mm','MM')),
                "day": $filter('date')(dtStart, 'EEEE'),
            };
            return stcStartDate;
        };

        /**
		 * Helper method to return formatted start time, and end time if appropriate
		 * @strStart - start time
		 * @strStart - end time, empty string if empty
		 */
        var getTimeLabel = function( strStart, strEnd ){
            var dtStart = new Date(strStart);
            var strLabel = '';
            // Add start time
            strLabel += '<span class="no-wrap">' + $filter('date')(dtStart, 'h:mma').toLowerCase();
            if( !strEnd.length ){
                strLabel += '</span>';
            }
            else{
                var dtEnd = new Date(strEnd);
                strLabel += '- </span><br><span class="no-wrap">' + $filter('date')(dtEnd, 'h:mma').toLowerCase() + '</span>';
            }
            if( strLabel.length ){ $scope.showTime = true; }
            return strLabel;
        };

        /**
		 * Helper method to return formatted location info
		 * @locId - location id
		 */
        var getLocationObj = function( locId ){
            var stcLocation = {
                url: '',
                full: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zipcode: '',
            };
            if( $scope.signupInfo.locations[locId] && Object.keys($scope.signupInfo.locations[locId]).length !== 0 ){
                // location object
                var stcLoc = $scope.signupInfo.locations[locId];
                // build address string
                var strLoc = stcLoc.address1.length ? stcLoc.address1 : '';
                strLoc += stcLoc.address2.length ? ' ' + stcLoc.address2 : '' ;
                if( strLoc.length ){ strLoc += ', '; }
                strLoc += stcLoc.city.length ? stcLoc.city + ', ' : '';
                strLoc += stcLoc.state.length ? stcLoc.state + ' ' : '';
                strLoc += stcLoc.zipcode > 0 ? stcLoc.zipcode.toString() : '';
                strLoc = strLoc.trim();
                // set address and url
                if( strLoc.length ){
                    stcLocation.full = strLoc;
                    stcLocation.url = 'https://www.google.com/maps/search/?api=1&query=' + strLoc.replace(/ /g, '+');
                    stcLocation.address1 = stcLoc.address1;
                    stcLocation.address2 = stcLoc.address2;
                    stcLocation.city = stcLoc.city;
                    stcLocation.state = stcLoc.state;
                    stcLocation.zipcode = stcLoc.zipcode;
                }
            }
            return stcLocation;
        };

        /**
         * Determine how many columns are shown in the table.
         */
        $scope.getColumnCount = function(showDateColumn, showLocationColumn, showTimeColumn){
            // we start at one because we always display the first column
            var columnCountShown = 1;
            if( showDateColumn ){ columnCountShown++; }
            if( showTimeColumn ){ columnCountShown++; }
            if( showLocationColumn ){ columnCountShown++; }
            return columnCountShown;
        };

        /**
         * Determine which slot template to use based on how many columns we are displaying
         */
        var setLayoutValues = function(){
            $scope.columnCount = $scope.getColumnCount( !$scope.showHeaderDate(),!$scope.showHeaderLocation() && $scope.showLocation,!$scope.showHeaderTime() && $scope.showTimeColumn );
            $scope.slotTemplate = ( $scope.columnCount >= 3 ) ? 'slots_stacked.html' : 'slots_standard.html';
        };

        var init = function(){
            prepData();
            groupDates();
            groupLocations();
            $scope.setFilteredData();
            $scope.slotCount = getSlotCount($scope.filteredData);
            setLayoutValues();

            // set starting column width for scrollable wrappers
            // allow time for table to render and any slot images to load
            $timeout(function(){
                // bind scroll to function
                $( window ).scroll( setScroll );

                setStartingColumnWidths();
            }, 900);

            increaseDisplayLimits(true);
        };

        /**
         * Increases the limitTo value of the ng-repeat of filteredData by incrementing it periodically until all data is rendered,
         * this improves loading time for large signups
         */
        var increaseDisplayLimits = function( firstIteration ){
            var timeoutTime = firstIteration ? 600:25;
            var increaseSlotLimit = $scope.slotCount > $scope.displayLimits.items;
            var increaseDateLimit = $scope.filteredData.length > $scope.displayLimits.dates;

            if( increaseSlotLimit || increaseDateLimit ){
                $timeout( function(){
                    if( increaseSlotLimit ){
                        $scope.displayLimits.items = $scope.displayLimits.items+20;
                    }
                    if( increaseDateLimit ){
                        $scope.displayLimits.dates = $scope.displayLimits.dates+20;
                    }
                }, timeoutTime).then( increaseDisplayLimits );
            }
        };


        // DEV NOTE: Comment out in SUG-16260. Will be delegated to $watch 
        init();

    }]);


    // rsvp sign up controller
    SUGApp.controller('rsvpSignUpController',
        ['$scope','SUGUtilities','signupPageService','$filter','errorService','$sce','$window','$timeout',
        function( $scope,util,svc,$filter,errorService,sce,$window,$timeout ) {

        // get the cached sign up info
        $scope.signupInfo = svc.getSignUpInfo();
        $scope.themeInfo = svc.getThemeInfo();
        $scope.dateFormat = typeof $scope.signupInfo.shortdformat !== 'undefined' ? $scope.signupInfo.shortdformat.replace("mm","MM") : 'MM/dd/yyyy';

        // scope variables
        $scope.filteredSlots = [];
        $scope.responses = {
            yes: [],
            no: [],
            maybe: [],
            responded: [],
            noresponse: [],
        };
        $scope.counts = {
            response: {
                yes: 0,
                no: 0,
                maybe: 0,
                noresponse: 0,
            },
            guest: {
                confirmed: 0,
                maybe: 0,
            },
            child: {
                confirmed: 0,
                maybe: 0,
            },
        };
        $scope.show = {
            slots: false,
            responses: false,
            child: false,
            responseNote: false,
            participantNames: false,
            participantNote: false,
            detail: {
                yes: false,
                no: false,
                maybe: false,
                noresponse: false,
            }
        };
        // local variables
        var slots = [];     // unfiltered slots

        /**
         * Prep slot for presentation - updates local slots object
         */
        var prepSlots = function(){
            slots = [];
            if( $scope.show.slots ){
                // set slot title
                if( util.keyExists($scope.signupInfo, 'slottitle') && $scope.signupInfo.slottitle !== $scope.strings.lbls.availableSlot ){
                    $scope.strings.lbls.availableSlot = $scope.signupInfo.slottitle;
                }
                slots = $scope.signupInfo.rsvpdetails.rsvpitems;
                // add quantity label
                for( var i=0; i<slots.length; i++ ){
                    // add quantity label
                    if( slots[i].qty < 999999 ){
                        slots[i]['qtyLabel'] = '(' + slots[i].qty + ')';
                    }
                    else{
                        slots[i]['qtyLabel'] = '';
                    }
                    // participant header label (e.g., '1 slot filled - more available')
                    var qtyTaken = slots[i].qty - slots[i].availableqty;
                    if( qtyTaken > 0 ){
                        if( slots[i].qty == 999999 ){
                            slots[i]['participantLabel'] = qtyTaken.toString() + ' slot';
                            if( qtyTaken > 1 ){ slots[i]['participantLabel'] += 's'; }
                            slots[i]['participantLabel'] += ' filled - more available';
                        }
                        else{
                            slots[i]['participantLabel'] = qtyTaken.toString() + ' of ' + slots[i].qty.toString() + ' slot';
                            if( slots[i].qty > 1 ){ slots[i]['participantLabel'] += 's'; }
                            slots[i]['participantLabel'] += ' filled';
                        }
                    }
                    else{ // none taken yet
                        slots[i]['participantLabel'] = '';
                    }
                    // participant names
                    slots[i]['participantNames'] = [];
                    if( $scope.show.participantNames ){
                        if( util.keyExists($scope.signupInfo, 'participants.' + slots[i].slotitemid.toString()) ){
                            var objParticipant = $scope.signupInfo.participants[ slots[i].slotitemid ];
                            for( var j=0; j<objParticipant.length; j++){
                                var stcNameInitials = getNameInitialDisplay( objParticipant[j]['firstname'], objParticipant[j]['lastname'] );
                                slots[i].participantNames.push({
                                    displayname: stcNameInitials.displayname,
                                    mycomment: objParticipant[j].mycomment,
                                    initials: stcNameInitials.initials,
                                });
                            }
                        }
                    }

                }
            }
        };

        /**
         * Sets filter on slots - returns filtered slots as $scope.filteredSlots
         *      (does nothing right now but stubbed out here when filter is introduced)
         */
        $scope.filterSlots = function(){
            // add filter in here
            $scope.filteredSlots = slots;
        };

        /**
         * Sets what rsvp page elements to show - returns $scope.filteredSlots
         */
        var setRSVPDisplay = function(){
            // signupInfo.showrsvp = show responses section - 'Allow everyone to see RSVP attendees'
            // signupInfo.childrsvp = show child/adult breakdown, show guests otherwise
            // $scope.signupInfo.rsvpdetails.rsvpitems.length = include sign up slots
            $scope.show.responses = isTrue( $scope.signupInfo.showrsvp ) ? true : false;
            $scope.show.participantNames = isTrue( $scope.signupInfo.shownames ) ? true : false;
            // handle exception where show response is hidden but sign up creator is logged in
            // TODO: consider condition for 'previewonly'
            if( !$scope.show.responses && $scope.isUserSignUpAdmin ){
                $scope.show.responseNote = true;
                $scope.show.responses = true;
            }
            if( !$scope.show.participantNames && $scope.isUserSignUpAdmin ){
                $scope.show.participantNote = true;
                $scope.show.participantNames = true;
            }
            $scope.show.slots = util.keyExists($scope.signupInfo, 'rsvpdetails.rsvpitems') && $scope.signupInfo.rsvpdetails.rsvpitems.length;
            if( $scope.show.responses ){
                if( isTrue( $scope.signupInfo.childrsvp ) ){
                    $scope.show.child = true;
                }
                $scope.counts = {
                    response: {
                        yes: util.keyExists($scope.signupInfo, 'rsvpdetails.count.yesrsvps') ? $scope.signupInfo.rsvpdetails.count.yesrsvps : 0,
                        no: util.keyExists($scope.signupInfo, 'rsvpdetails.count.norsvps') ? $scope.signupInfo.rsvpdetails.count.norsvps : 0,
                        maybe: util.keyExists($scope.signupInfo, 'rsvpdetails.count.maybersvps') ? $scope.signupInfo.rsvpdetails.count.maybersvps : 0,
                        noresponse: util.keyExists($scope.signupInfo, 'rsvpdetails.count.noresponse') ? $scope.signupInfo.rsvpdetails.count.noresponse : 0,
                    },
                    guest: {   // will be the same as adult in cases where
                        confirmed: util.keyExists($scope.signupInfo, 'rsvpdetails.count.yesguests') ? $scope.signupInfo.rsvpdetails.count.yesguests : 0,
                        maybe: util.keyExists($scope.signupInfo, 'rsvpdetails.count.maybeguests') ? $scope.signupInfo.rsvpdetails.count.maybeguests : 0,
                    },
                    child: {
                        confirmed: util.keyExists($scope.signupInfo, 'rsvpdetails.count.yeschild') ? $scope.signupInfo.rsvpdetails.count.yeschild : 0,
                        maybe: util.keyExists($scope.signupInfo, 'rsvpdetails.count.maybechild') ? $scope.signupInfo.rsvpdetails.count.maybechild : 0,
                    },
                };
                // iterate through responses and populate yes/no/maybe arrays
                $scope.responses = { yes: [], no: [], maybe: [], responded: [], noresponse: []};
                var rsvps = util.deepCopy($scope.signupInfo.rsvp);
                for( var i=0; i<rsvps.length; i++ ){
                    // prep displayname and initials
                    var stcNameInitials = getNameInitialDisplay( rsvps[i]['displayfirstname'], rsvps[i]['displaylastname'] );
                    // prep participant count summary
                    var participantCountSummary = getParticipantCountSummary(rsvps[i].rsvpcount, rsvps[i].rsvpchildcount );
                    if( participantCountSummary.length ){ participantCountSummary = '(' + participantCountSummary + ')'; }
                    // set participant to append
                    var stcParticipant = {
                        displayname: stcNameInitials.displayname,
                        initials: stcNameInitials.initials,
                        comment: rsvps[i].comment,
                        summaryLabel: participantCountSummary,
                    };
                    // append
                    switch( rsvps[i].rsvp ){
                        case 'Y':
                            $scope.responses.yes.push(stcParticipant);
                            $scope.responses.responded.push({memberid: rsvps[i].memberid,});
                            break;
                        case 'N':
                            $scope.responses.no.push(stcParticipant);
                            $scope.responses.responded.push({memberid: rsvps[i].memberid,});
                            break;
                        case 'M':
                            $scope.responses.maybe.push(stcParticipant);
                            $scope.responses.responded.push({memberid: rsvps[i].memberid,});
                            break;
                    }
                }
                // populate non-responsive participant(s) list
                //      - may want to make this a one-off server request once user clicks to display no responses
                var inv = util.deepCopy($scope.signupInfo.rsvpdetails.invitees);
                for( var j=0; j<inv.length; j++ ){
                    var isHasReponded = false;
                    // skip invitees who have responded
                    for( var k=0; k<$scope.responses.responded.length; k++){
                        if( inv[j].memberid === $scope.responses.responded[k].memberid ){
                            isHasReponded = true;
                            break;
                        }
                    }
                    if( isHasReponded ){
                        continue;
                    }
                    // prep displayname and initials
                    var stcNRNameInitials = getNameInitialDisplay( inv[j]['firstname'], inv[j]['lastname'] );
                    if( !stcNRNameInitials.displayname.length ){
                        stcNRNameInitials.displayname = inv[j].emailpart;
                    }
                    $scope.responses.noresponse.push({displayname: stcNRNameInitials.displayname, initials: stcNRNameInitials.initials});
                }
                // sort by display name
                $scope.responses.noresponse.sort(function(a, b) {
                    var displaynameA = a.displayname.toString().toLowerCase();
                    var displaynameB = b.displayname.toString().toLowerCase();
                    return ( displaynameA < displaynameB ) ? -1 : ( displaynameA > displaynameB ) ? 1 : 0;
                });
            }
            // set My RSVP display
            setMyRSVP();
        };

        /**
         * Helper method to generate participant count label (e.g. '1 adult, 2 children')
         * @param  {Number} adultCount - count of adults / guests (when there is not a separate count for children)
         * @param  {Number} childCount - count of children (0 if not applicable)
         */
        var getParticipantCountSummary = function( adultCount, childCount ){
            var participantCountSummary = '';
            var adultDescriptor = $scope.show.child ? 'adult': 'guest';
            if( adultCount > 0 ){
                participantCountSummary += adultCount.toString() + ' ' + adultDescriptor;
                if( adultCount > 1 ){ participantCountSummary += 's'; }
            }
            if( $scope.show.child && childCount > 0 ){
                if( participantCountSummary.length ){ participantCountSummary += ', '; }
                participantCountSummary += childCount.toString() + ' child';
                if( childCount > 1 ){ participantCountSummary += 'ren'; }
            }
            return participantCountSummary;
        };

        /**
         * Helper method to get member display name and initials - returns structure of both (e.g. {displayname: '', initials: ''} )
         * @param  {String} firstname - first name
         * @param  {String} lastname - last name
         */
        var getNameInitialDisplay = function( firstname, lastname ){
            var displayname = '';
            var initials = '';
            if( typeof firstname !== 'undefined' && firstname.toString().length ){
                displayname = firstname.toString();
                initials = firstname.toString().charAt(0).toUpperCase();
            }
            displayname += displayname.length > 0 ? ' ' : '';
            if( typeof lastname !== 'undefined' && lastname.toString().length ){
                displayname += lastname.toString();
                initials += lastname.toString().charAt(0).toUpperCase();
            }
            return {displayname: displayname, initials: initials};
        };

        /**
         * Helper method to set member rsvp details - updates $scope.userSignUp
         *  Note: 3 sources of rsvp data -
         *      $scope.signupInfo.rsvp (who actually rsvp'd) = response (y/n/m), adult/child counts
         *      $scope.signupInfo.rsvpdetails.rsvpitems (items available for sign up) = slot name
         *      $scope.signupInfo.participants (who is confirmed) = quantity, name
         */
        var setMyRSVP = function(){
            if( $scope.showEditMySignUp ){
                $scope.userSignUp['myRSVP'] = {};
                // iterate although there should only ever be 1 rsvp record for the user
                for( var i=0; i<$scope.userSignUp.rsvpRecs.length; i++ ){
                    // user display name
                    var stcNameInitials = getNameInitialDisplay( $scope.userSignUp.rsvpRecs[i]['displayfirstname'], $scope.userSignUp.rsvpRecs[i]['displaylastname'] );
                    $scope.userSignUp.myRSVP['displayname'] = stcNameInitials.displayname;
                    // rsvp label
                    var responseLabel = '';
                    switch ($scope.userSignUp.rsvpRecs[i].rsvp) {
                        case 'Y':
                            responseLabel += $scope.strings.rsvp.countOnYes;
                            responseLabel += getParticipantCountSummary($scope.userSignUp.rsvpRecs[i].rsvpcount, $scope.userSignUp.rsvpRecs[i].rsvpchildcount );
                            break;
                        case 'N':
                            responseLabel += 'NO';
                            break;
                        case 'M':
                            responseLabel += $scope.strings.rsvp.countOnMaybe;
                            responseLabel += getParticipantCountSummary($scope.userSignUp.rsvpRecs[i].rsvpcount, $scope.userSignUp.rsvpRecs[i].rsvpchildcount );
                            break;
                    }
                    $scope.userSignUp.myRSVP['responseLabel'] = responseLabel;
                }
                // set sign up items
                $scope.userSignUp.myRSVP['items'] = [];
                if( util.keyExists($scope.signupInfo, 'rsvpdetails.rsvpitems') ){
                    var rsvpitems = util.deepCopy($scope.signupInfo.rsvpdetails.rsvpitems);
                    for( var j=0; j<$scope.userSignUp.participantRecs.length; j++ ){
                        for( var k=0; k<rsvpitems.length; k++ ){
                            if( $scope.userSignUp.participantRecs[j].slotitemid === rsvpitems[k].slotitemid ){
                                var itemlabel = rsvpitems[k].item;
                                if( $scope.userSignUp.participantRecs[j].myqty > 1 ){
                                    itemlabel += '(' + $scope.userSignUp.participantRecs[j].myqty.toString() + ')';
                                }
                                $scope.userSignUp.myRSVP.items.push(itemlabel);
                            }
                        }
                    }
                }
            }
        };

        // tests if an object exists and if it is true
        var isTrue = function( obj ){
            if( typeof obj === 'undefined' ){
                return false;
            }
            if( obj == true ){
                return true;
            }
            return false;
        };

        // initialize page
        var init = function(){
            // show rsvp page elements
            setRSVPDisplay();
            // prepare slot data
            prepSlots();
            // filter slots
            $scope.filterSlots();
        };
        init();

    }]);

    // slot sorted sign up controller
    SUGApp.controller('slotSortSignUpController',
        ['$scope','SUGUtilities','signupPageService','$filter','errorService','$sce','$window','$timeout',
        function( $scope,util,svc,$filter,errorService,sce,$window,$timeout ) {

        // get the cached info
        $scope.memberInfo = svc.getMemberInfo();
        $scope.signupInfo = svc.getSignUpInfo();
        $scope.themeInfo = svc.getThemeInfo();
        $scope.dateFormat = typeof $scope.signupInfo.shortdformat !== 'undefined' ? $scope.signupInfo.shortdformat.replace("mm","MM") : 'MM/dd/yyyy';

        // limits on inital load
        $scope.displayLimits = {
            dates: 8,
            items: 5
        };
        $scope.dateCount = 0;

        var arrData = [];
        $scope.filteredData = [];
        $scope.slotTitleTruncateAt = 200;
        $scope.slotTemplate = 'slots_standard.html';
        $scope.columnCount = 1;

        $scope.defaultBtnState = 'default';
        $scope.selectedBtnState = 'selected';

        //svc.initializePagination($scope.signupInfo, $scope.frmObj);


        // set slot title
        if( util.keyExists($scope.signupInfo, 'slottitle') && $scope.signupInfo.slottitle !== $scope.strings.lbls.availableSlot ){
            $scope.strings.lbls.availableSlot = $scope.signupInfo.slottitle;
        }

        /*
        if (!$scope.signupInfo.allSlotsHidden) {
            // handles page setup when new slots added
            $scope.$watch('signupInfo.currentSlots', function(newValue) {
                $scope.filteredData = [];
                arrData = [];
                init();
            })

            // Set up a watcher on the currentPage prop, which will eventually be changed by the pagination directive. This will trigger the functionality to display the current page's slots/eventually trigger a request to the backend
            $scope.$watch('signupInfo.listPagination.currentPage', function(newValue) {
                $scope.getPage(newValue);
            })
        }
        */

        /**
         * Prep data for UI presentation
         */
        var prepData = function(){
            /*if ($scope.signupInfo.allSlotsHidden)
                return;
            */
            $scope.showTime = false;

            /*
            var currentPageObj = $scope.signupInfo.currentSlots[0];
            var objSlots = util.deepCopy(currentPageObj);
            */

            // Uncomment to use old non-paginated version
            var objSlots = util.deepCopy($scope.signupInfo.slots);
            $scope.virtualLocations = $scope.signupInfo.virtuallocations;
            // build return value to be iterated
            for (var key in objSlots) {
                if (objSlots.hasOwnProperty(key)) {
                    // complete image object, needed for image zoom modal
                    var objImages = typeof $scope.signupInfo.itemimages[key] !== 'undefined' ? $scope.signupInfo.itemimages[key] : {};
                    objSlots[key]['images'] = objImages;
                    // add main image per item
                    if( typeof objSlots[key]['itemimage'] === 'undefined' ){
                        objSlots[key]['itemimage'] = util.keyExists($scope.signupInfo.itemimages[key],'images',true) && $scope.signupInfo.itemimages[key].images.length ? $scope.signupInfo.itemimages[key].images[0] : '';
                    }
                    // iterate dates
                    for( var i=0; i<objSlots[key].dates.length; i++ ){
                        const currentDate = objSlots[key].dates[i];
                        // date label
                        currentDate['dateLabel'] = getDateLabel( currentDate.starttime );
                        // time label
                        currentDate['timeLabel'] = currentDate.usetime ? getTimeLabel( currentDate.starttime, currentDate.endtime ) : '';
                        // location
                        if( currentDate.location.length ){ $scope.showLocation = true; }
                        var stcLoc = typeof currentDate.locationid !== 'undefined' && currentDate.locationid > 0 ? getLocationObj(currentDate.locationid) : getLocationObj( 0 );
                        currentDate['locdetail'] = {
                            url: stcLoc.url,
                            full: stcLoc.full,
                            address1: stcLoc.address1,
                            address2: stcLoc.address2,
                            city: stcLoc.city,
                            state: stcLoc.state,
                            zipcode: stcLoc.zipcode,
                            showicon: true,
                            virtuallocationurl: null,
                            physicalandvirtual: false
                        };
                        // Add the virtual location detials to the object slots view model

                        if (objSlots[key].dates[i].virtuallocationid) {
                            const virtualLocationId =  currentDate.virtuallocationid;
                            currentDate['virtualocdetail'] = $scope.virtualLocations[virtualLocationId];
                            currentDate['locdetail'].virtuallocationurl =  $scope.virtualLocations[virtualLocationId].virtuallocationlinkurl;
                            currentDate['locdetail'].virtuallocationtype =  $scope.virtualLocations[virtualLocationId].type;
                        }
                        // Some locations can be both physical and virtual, so we need to add some details around that that can be passed into the <sug-address> directive
                        currentDate.virtuallocationid > 0 && currentDate.locationid > 0  ? currentDate['locdetail'].physicalandvirtual = true : currentDate['locdetail'].physicalandvirtual = false;

                        // handle availability and participants
                        objSlots[key].dates[i]['participants'] = util.keyExists($scope.signupInfo, 'participants', true) && util.keyExists($scope.signupInfo.participants, objSlots[key].dates[i].slotitemid, true) ? $scope.signupInfo.participants[objSlots[key].dates[i].slotitemid] : [];
                        var stcAvailable = svc.getAvailability( objSlots[key].qty, objSlots[key].dates[i].qtytaken, objSlots[key].dates[i].isaddlocked, $scope.isLocked(), objSlots[key].hidenumberwanted, objSlots[key].waitlist, svc.getMemberParticipantData(objSlots[key].dates[i]['participants'], $scope.memberId) );
                        objSlots[key].dates[i]['waitlistPosition'] = stcAvailable.waitlistPosition;
                        objSlots[key].dates[i]['qtyLabel'] = stcAvailable.qtyLabel;
                        objSlots[key].dates[i]['qtyLabelResponsive'] = stcAvailable.qtyLabelResponsive;
                        objSlots[key].dates[i]['btnState'] = stcAvailable.btnState;
                        objSlots[key].dates[i]['waitlistQtyLabel'] = svc.getWaitlistAvailability(objSlots[key].waitlist, objSlots[key].dates[i].waitlistedparticipantcount, objSlots[key].qty, objSlots[key].dates[i].qtytaken);
                        //our button is selected, but is not found in our selected items array - set it to default
                        if ( objSlots[key].dates[i].btnState === $scope.selectedBtnState && $scope.selectedSlotItems.indexOf(objSlots[key].dates[i].slotitemid) === -1) {
                            objSlots[key].dates[i].btnState = $scope.defaultBtnState;
                        //our button is not selected, but is found in our selected items array - set it to selected
                        } else if ( objSlots[key].dates[i].btnState === $scope.defaultBtnState && $scope.selectedSlotItems.indexOf(objSlots[key].dates[i].slotitemid) !== -1) {
                            objSlots[key].dates[i].btnState = $scope.selectedBtnState;
                        }

                        // get the logged in member's qty already signed up for
                        objSlots[key].dates[i]['myqty'] = ( $scope.memberId ) ? $scope.getQtyForMember(objSlots[key].dates[i]['participants'], $scope.memberId) : 0;
                        objSlots[key].dates[i]['deleteModalInfo'] = $scope.getDeleteModalInfo( objSlots[key], objSlots[key].dates[i], objSlots[key].dates[i].slotitemid);
                    }
                    // add item
                    arrData.push(objSlots[key]);
                }
            }

            // sort by date and then location
            arrData.sort(function(a, b) {
                var oA = a.itemorder;
                var oB = b.itemorder;
                return oA < oB ? -1 : ( oA > oB ? 1 : 0 );
            });
        };

        /**
         * Deletes an item member.
         *
         * @modalInfo {Object} - see getDeleteModalInfo for contents
         * @itemmember {Object} - the itemmember to delete
         */
        $scope.deleteItemMember = function(modalInfo, itemmember){
            // wait for the promise to resolve and if successful, delete the item member from the client side cache
            svc.deleteItemMemberModal(modalInfo,itemmember).then(function (deleteInfo) {
                // delete the itemmember from the main participants array
                var participants = $scope.signupInfo.participants[modalInfo.slotitemid];
                $scope.signupInfo.participants[modalInfo.slotitemid] = participants.filter( function(itemmember){
                    return itemmember.itemmemberid != deleteInfo.itemmemberid;
                });

                // update the filterdata participants array for the slotitem
                // find the item's index
                var itemIdx;
                $scope.filteredData.some( function(item, Iidx){
                    if( item.itemid === modalInfo.itemid ){
                        itemIdx = Iidx;
                        return true;
                    }else{
                        return false;
                    }
                });

                // if item found, find the slottitem
                if( util.isIntegerGTE0(itemIdx) ){
                    var slotitemIdx;
                    $scope.filteredData[itemIdx].dates.some( function(slotitem, siIdx){
                        if( slotitem.slotitemid === modalInfo.slotitemid ){
                            slotitemIdx = siIdx;
                            return true;
                        }else{
                            return false;
                        }
                    });
                    // if slotitem found, update the participants array and quantity info for the item member
                    if( util.isIntegerGTE0(slotitemIdx) ){
                        $scope.filteredData[itemIdx].dates[slotitemIdx].participants = $scope.signupInfo.participants[deleteInfo.slotitemid];
        
                        if (!deleteInfo.waitlistsignup && $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount > 0) {
                            // take the deleted signup myqty and remove from the waitlistedparticipantcount
                            // if the result of the waitlistedparticipantcount is negative, then remove that from the qtytaken and zero out the waitlistedparticipantcount

                            $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount = ($scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[itemIdx].dates[slotitemIdx].myqty);
                           
                            if ($scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount < 0) {
                                $scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken += $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount;
                                $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount = 0;
                            }
                        }
                        else if (deleteInfo.waitlistsignup) {
                            $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount = Math.max($scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[itemIdx].dates[slotitemIdx].myqty, 0);
                            $scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken = Math.max($scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken, 0);
                        }
                        else {
                            $scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken = Math.max($scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken - $scope.filteredData[itemIdx].dates[slotitemIdx].myqty, 0);
                        }

                        var stcAvailable = svc.getAvailability( $scope.filteredData[itemIdx].qty, $scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken, $scope.filteredData[itemIdx].dates[slotitemIdx].isaddlocked, $scope.isLocked(), $scope.filteredData[itemIdx].hidenumberwanted, $scope.filteredData[itemIdx].waitlist, svc.getMemberParticipantData($scope.filteredData[itemIdx].dates[slotitemIdx].participants, $scope.memberId) );
                        $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistPosition = stcAvailable.waitlistPosition;
                        $scope.filteredData[itemIdx].dates[slotitemIdx].qtyLabel = stcAvailable.qtyLabel;
                        $scope.filteredData[itemIdx].dates[slotitemIdx].qtyLabelResponsive = stcAvailable.qtyLabelResponsive;
                        $scope.userSignUp.totalQty -= $scope.filteredData[itemIdx].dates[slotitemIdx].myqty;
                        $scope.filteredData[itemIdx].dates[slotitemIdx].myqty = ( $scope.memberId ) ? $scope.getQtyForMember($scope.filteredData[itemIdx].dates[slotitemIdx].participants, $scope.memberId) : 0;
                        $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistQtyLabel = svc.getWaitlistAvailability($scope.filteredData[itemIdx].waitlist, $scope.filteredData[itemIdx].dates[slotitemIdx].waitlistedparticipantcount, $scope.filteredData[itemIdx].qty, $scope.filteredData[itemIdx].dates[slotitemIdx].qtytaken);

                        // If a person was just removed from a slot then we know we have at least 1 available slot, so be sure to reset hasAvailableSlots
                        if (!$scope.signupInfo.hasavailableslots) {
                            $scope.signupInfo.hasavailableslots = true;
                            $scope.es.clearErrors();
                        }

                        $scope.filteredData[itemIdx].dates[slotitemIdx].btnState = stcAvailable.btnState;
                    }
                }
            });
        };

        /**
         * Iterate arrData and determine what dates should be grouped together
         * Slot sorted needs to determine unique dates within slots
         * Aggregate date uniqueness is also required to determine if calendar icon will show for calendar view
         */
        var groupDates = function(){
            var uniqueDates = {};       // unique dates within slots
            var uniqueAggDates = {};    // unique aggregate dates among all slots
            var flags = [];
            var aggFlags = [];

            // if showing dates in data grid
            if( !$scope.showHeaderDate() ){
                // iterate slots
                for( var s=0; s < arrData.length; s++ ){
                    // if key doesn't exist - shouldn't get here
                    if( !util.keyExists( arrData[s], 'dates') ){
                        continue;
                    }
                    // iterate dates within slot
                    for( var d=0; d < arrData[s].dates.length; d++ ){
                        // if key already exists, increment counter and continue

                        // handle agreggate dates...
                        // for overall date uniqueness only concerned about the date value
                        var aggKey = arrData[s].dates[d].dateLabel.date;
                        // add to aggregate key count if already exists
                        if( aggFlags[aggKey] ){
                            uniqueAggDates[aggKey].count += 1;
                        }
                        else{
                            // if aggregate key doesn't exist, add it
                            aggFlags[aggKey] = true;
                            uniqueAggDates[aggKey] = {
                                count: 1,
                            };
                            $scope.dateCount += 1;
                        }

                        // handle dates within slot...
                        // for uniquesness within slot, concatenate itemid with date
                        var key = arrData[s].itemid.toString() + '_' + arrData[s].dates[d].dateLabel.date;
                        if( flags[key] ){
                            uniqueDates[key].count += 1;
                            continue;
                        }
                        // if key doesn't exist, add it
                        flags[key] = true;
                        uniqueDates[key] = {
                            count: 1,
                            firstslotitemid: arrData[s].dates[d].slotitemid,
                        };
                    }
                }
            }
            // iterate through items and append row span
            for( var sl=0; sl < arrData.length; sl++ ){
                for( var dt=0; dt < arrData[sl].dates.length; dt++ ){
                    var daterowspan = 0;
                    for( var item in uniqueDates ){
                        if( arrData[sl].dates[dt].slotitemid == uniqueDates[item].firstslotitemid ){
                            daterowspan = uniqueDates[item].count;
                            break;
                        }
                    }
                    arrData[sl].dates[dt]["daterowspan"] = daterowspan;
                    $scope.dateCount += 1;
                }
            }
            // if there is more than date, show calendar icon
            if( $scope.dateCount > 1 ){
                $scope.showCalendarIcon = true;
            }
        };

        /**
         * Iterate arrData and determine what locations should be grouped together
         * Group rows with the same date and location in the same row
         */
        var groupLocations = function(){
            var arrLocs = [];
            // if showing locations in data grid
            if( !$scope.showHeaderLocation() ){
                // iterate slots
                for( var s=0; s < arrData.length; s++ ){
                    // if key doesn't exist - shouldn't get here
                    if( !util.keyExists( arrData[s], 'dates') ){
                        continue;
                    }
                    // iterate dates within slot
                    // get unique locations
                    var i = 0;
                    for( var d=0; d < arrData[s].dates.length; d++ ){
                        // if key doesn't exist - shouldn't get here
                        if( !util.keyExists( arrData[s].dates[d], 'slotid')
                            || !util.keyExists( arrData[s].dates[d], 'dateLabel.date')
                            || !util.keyExists( arrData[s].dates[d], 'location')
                            || !util.keyExists( arrData[s].dates[d], 'locationid')
                            || !util.keyExists( arrData[s].dates[d], 'starttime')
                            || !util.keyExists( arrData[s].dates[d], 'endtime')
                            ){
                            continue;
                        }
                        // get current index
                        i = arrLocs.length;
                        // get current date / location
                        var tempLoc = {
                            count: 1,
                            itemid: arrData[s].itemid,
                            date: arrData[s].dates[d].dateLabel.date,
                            locationid: arrData[s].dates[d].locationid,
                            location: arrData[s].dates[d].location,
                            firstslotitemid: arrData[s].dates[d].slotitemid,
                        };
                        // if it's the first, add current
                        if( i == 0 ){
                            arrLocs.push(tempLoc);
                        }
                        else {
                            var lastLoc = util.deepCopy(arrLocs[i-1]);
                            // current is the same as last, so increment the counter so they are grouped together
                            if( lastLoc.itemid == arrData[s].itemid
                                && lastLoc.date == arrData[s].dates[d].dateLabel.date
                                && lastLoc.locationid == arrData[s].dates[d].locationid
                                && lastLoc.location == arrData[s].dates[d].location ){
                                    arrLocs[i-1].count += 1;
                            }
                            else {  // current doesn't match last so add a new record to arrLocs
                                arrLocs.push(tempLoc);
                            }
                        }
                    }
                }
            }

            // iterate through items and append row span
            for( var sl=0; sl < arrData.length; sl++ ){
                for( var dt=0; dt < arrData[sl].dates.length; dt++ ){
                    var locrowspan = 0;
                    for( var idx=0; idx<arrLocs.length; idx++ ){
                        if( arrData[sl].itemid == arrLocs[idx].itemid
                            && arrData[sl].dates[dt].dateLabel.date == arrLocs[idx].date
                            && arrData[sl].dates[dt].location == arrLocs[idx].location
                            && arrData[sl].dates[dt].locationid == arrLocs[idx].locationid
                            && arrData[sl].dates[dt].slotitemid == arrLocs[idx].firstslotitemid ){
                                locrowspan = arrLocs[idx].count;
                            break;
                        }
                    }
                    arrData[sl].dates[dt]["locationrowspan"] = locrowspan;
                }
            }
        };

        /**
         * Sets filter on slots - returns filtered slots as $scope.filteredData
         *      (similar function - rsvpSignUpController::filterSlots - may be able to combine in signupController)
         */
        $scope.setFilteredData = function(){
            // filter arrData here

            // set bottom borders for filtered data
            setBottomBorders( arrData );
            $scope.filteredData = arrData;
        };

        /*
        * method called on scroll
        *   expects a scrollable element to have class="scrollable"
        *   and a parent wrapping element with the same id as itself plus "-wrap"
        *   (i.e. id="myelement" with parent of id="myelement-wrap")
		*/
		var setScroll = function(){
            var scrollableElems = document.getElementsByClassName('scrollable');
            var intBuffer = 8;
            for (var i = 0; i < scrollableElems.length; i++) {
                var elemWrap = document.getElementById( scrollableElems[i].id + '-wrap' );
                var elemSubj = $( '#' + scrollableElems[i].id );
                calcScroll( elemWrap, elemSubj, intBuffer );
            }
        };

        /**
		 * Helper method to calulate scroll for sticky segment - adds appropriate css to subject element
		 * @elWrap - reference to DOM wrapping element (sets the top and bottom of the content section to scroll)
		 * @elSubject - reference to subject element to scroll
		 * @intBuffer - int, pixels to add as a buffer to the top and bottom of the scrolled content
		 */
        var calcScroll = function( elWrap, elSubject, intBuffer ){
            var elemHeight = elSubject.height();
            var intSubjectWidth = $scope.columnWidths[elSubject[0].id];
            var intWrapWidth = $scope.columnWidths[elWrap.id];
            if( elWrap.getBoundingClientRect().top > 0 ){   // scroll has not reached top of subject yet
                elSubject.css({ position:'relative', top: 0 });
            }
            else if( elWrap.getBoundingClientRect().bottom - elemHeight - (2 * intBuffer) >= 0 ){ // scroll is between top of subject element and bottom (including top and bottom buffer)
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: intBuffer });
                // reset width of wrapping element
                // this was required in some cases where the only child of the wrapper was the one being scrolled and position:fixed caused all columns to collapse
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else if( elWrap.getBoundingClientRect().bottom >= 0 ){  // scroll is after element height minus top/bottom buffer but before subject bottom
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: elWrap.getBoundingClientRect().bottom - elemHeight - intBuffer });
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else{   // scroll is passed element bottom (element is off screen)
                elSubject.css({ position: 'relative', top: 0});
            }
        };

        /**
		 * Helper method to set starting column widths scrollable elements and wrappers
         * Subsequently used by scrolling method to ensure originally rendered widths are retained
         * Sets a scoped object with key value pairs where key is the element id and value is the pixel width
         * (i.e. { 39821-48522-date-wrap: 100, ... } )
		 */
        var setStartingColumnWidths = function(){
            $scope.columnWidths = {};
            var scrollableElems = document.getElementsByClassName('scrollable');
            for (var i = 0; i < scrollableElems.length; i++) {
                $scope.columnWidths[ scrollableElems[i].id ] = document.getElementById( scrollableElems[i].id ).getBoundingClientRect().width;
                $scope.columnWidths[ scrollableElems[i].id + '-wrap' ] = document.getElementById( scrollableElems[i].id + '-wrap' ).getBoundingClientRect().width;
            }
        };

        /**
		 * Helper method to return formatted date and day
		 * @strStart - start time
		 */
        var getDateLabel = function( strStart ){
            var dtStart = new Date(strStart);
            var stcStartDate = {
                "date": $filter('date')(dtStart, $scope.signupInfo.shortdformat.replace('mm','MM')),
                "day": $filter('date')(dtStart, 'EEEE'),
            };
            return stcStartDate;
        };

        /**
		 * Helper method to return formatted start time, and end time if appropriate
		 * @strStart - start time
		 * @strStart - end time, empty string if empty
		 */
        var getTimeLabel = function( strStart, strEnd ){
            var dtStart = new Date(strStart);
            var strLabel = '';
            // Add start time
            strLabel += '<span class="no-wrap">' + $filter('date')(dtStart, 'h:mma').toLowerCase();
            if( !strEnd.length ){
                strLabel += '</span>';
            }
            else{
                var dtEnd = new Date(strEnd);
                strLabel += '-' + $filter('date')(dtEnd, 'h:mma').toLowerCase() + '</span>';
            }
            if( strLabel.length ){ $scope.showTime = true; }
            return strLabel;
        };

        /**
		 * Helper method to return formatted location info
		 * @locId - location id
		 */
        var getLocationObj = function( locId ){
            var stcLocation = {
                url: '',
                full: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zipcode: '',
            };
            if( $scope.signupInfo.locations[locId] && Object.keys($scope.signupInfo.locations[locId]).length !== 0 ){
                // location object
                var stcLoc = $scope.signupInfo.locations[locId];
                // build address string
                var strLoc = stcLoc.address1.length ? stcLoc.address1 : '';
                strLoc += stcLoc.address2.length ? ' ' + stcLoc.address2 : '' ;
                if( strLoc.length ){ strLoc += ', '; }
                strLoc += stcLoc.city.length ? stcLoc.city + ', ' : '';
                strLoc += stcLoc.state.length ? stcLoc.state + ' ' : '';
                strLoc += stcLoc.zipcode > 0 ? stcLoc.zipcode.toString() : '';
                strLoc = strLoc.trim();
                // set address and url
                if( strLoc.length ){
                    stcLocation.full = strLoc;
                    stcLocation.url = 'https://www.google.com/maps/search/?api=1&query=' + strLoc.replace(/ /g, '+');
                    stcLocation.address1 = stcLoc.address1;
                    stcLocation.address2 = stcLoc.address2;
                    stcLocation.city = stcLoc.city;
                    stcLocation.state = stcLoc.state;
                    stcLocation.zipcode = stcLoc.zipcode;
                }
            }
            return stcLocation;
        };

        /**
		 * Helper method to set bottom border flag
         * Necessary for slot sorted since some dates and locations are grouped in the data grid (so $last is not last for those columns)
		 * @arrData - data to set borders on
		 */
        var setBottomBorders = function( arrData ){
            // iterate slots
            for( var sl=0; sl < arrData.length; sl++ ){
                if( !util.keyExists( arrData[sl], 'dates' ) ){
                    continue;
                }
                // iterate dates
                for( var dt=0; dt < arrData[sl].dates.length; dt++ ){
                    var showBottomDateBorder = false;
                    var showBottomLocBorder = false;
                    // if rowspan + index is less than array length (not the last date), add the border
                    if( util.keyExists(arrData[sl].dates[dt], 'daterowspan')
                        && arrData[sl].dates[dt].daterowspan > 0
                        && arrData[sl].dates[dt].daterowspan + dt < arrData[sl].dates.length ){
                            showBottomDateBorder = true;
                    }
                    if( util.keyExists(arrData[sl].dates[dt], 'locationrowspan')
                    && arrData[sl].dates[dt].locationrowspan > 0
                    && arrData[sl].dates[dt].locationrowspan + dt < arrData[sl].dates.length ){
                            showBottomLocBorder = true;
                    }
                    arrData[sl].dates[dt]['showbottomdateborder'] = showBottomDateBorder;
                    arrData[sl].dates[dt]['showbottomlocborder'] = showBottomLocBorder;
                }
            }
        };

        /**
		 * Helper method to set colspan for nested table
		 */
        var setNestedColSpan = function(){
            // always include time/signup button column
            var colspan = 1;
            // add date column
            if( !$scope.showHeaderDate() ){
                colspan += 1;
            }
            // add location column
            if( !$scope.showHeaderLocation() && $scope.showLocation ){
                colspan += 1;
            }

            $scope.nestedColSpan = colspan;
        };

        /**
		 * Helper method to set height of nested table
         * Necessary when available slot was taller than nested table - resulted in short vertical borders in nested table
		 */
        var setNestedTableHeight = function(){
            var filteredData = $scope.filteredData;
            // iterate slots
            for( var sl=0; sl < filteredData.length; sl++ ){
                if( !util.keyExists( filteredData[sl], 'dates',true ) ){
                    continue;
                }
                // get height of Available Slot cell
                var elSlot = document.getElementById( filteredData[sl].itemid + '-slot-wrap' );
                var intNestedHeight = 0;
                var elLastButtonTD = null;
                // iterate dates to determine sum of nested
                for( var dt=0; dt < filteredData[sl].dates.length; dt++ ){
                    var elButtonTd = document.getElementById( filteredData[sl].itemid + '-' + filteredData[sl].dates[dt].slotid + '-signup-btn-td' );
                    // true for stacked
                    if( elButtonTd == null){
                        elButtonTd = document.getElementById( filteredData[sl].itemid + '-' + filteredData[sl].dates[dt].slotid + '-details-wrap' );
                    }
                    intNestedHeight += elButtonTd ? elButtonTd.getBoundingClientRect().height : 0;
                    // set last td element
                    elLastButtonTD = elButtonTd;
                }

                // add difference to last element td height to make the sum equal to the slot cell height
                var intDifference = (elSlot ? elSlot.getBoundingClientRect().height:0) - intNestedHeight;
                if( intDifference > 1 && elLastButtonTD ){
                    elLastButtonTD.style.height = elLastButtonTD.getBoundingClientRect().height + intDifference + "px";
                }
            }
        };

        /**
         * Determines the fit-to-width value for the fit-ellipsis directive used on the Slot Sorted SU view
         * If the slot has more than 3 columns, we use 190 bc the slot column is much smaller, otherwise we can use 295.
         */
        var setSlotTitleTruncateAt = function(){
            $scope.slotTitleTruncateAt = (!$scope.showHeaderLocation() && $scope.showLocation) ? 190 : 295;
        };

        /**
         * Determine how many columns are shown in the table.
         */
        $scope.getColumnCount = function(showDateColumn, showLocationColumn, showTimeColumn){
            // we start at one because we always display the first column
            var columnCountShown = 1;
            if( showDateColumn ){ columnCountShown++; }
            if( showTimeColumn ){ columnCountShown++; }
            if( showLocationColumn ){ columnCountShown++; }
            return columnCountShown;
        };

        /**
         * Determine which slot template to use based on how many columns we are displaying
         * DIFFERENCE: For Slot Sorted, do NOT pass in $scope.showTimeColumn as part of the "showTimeColumn" value. In StandardSignUpController we DO pass this in.
         */
        var setLayoutValues = function(){
            $scope.columnCount = $scope.getColumnCount( !$scope.showHeaderDate(),!$scope.showHeaderLocation() && $scope.showLocation,!$scope.showHeaderTime() );
            $scope.slotTemplate = ( $scope.columnCount >= 3 ) ? 'slots_stacked.html' : 'slots_standard.html';
        };

        var init = function(){
            prepData();
            groupDates();
            groupLocations();
            setNestedColSpan();
            $scope.setFilteredData();
            setSlotTitleTruncateAt();
            setLayoutValues();

            // need to wait for images and fit-ellipsis directives to render
            // allow time for table to render and any slot images to load
            $timeout(function(){
                // bind scroll to function
                $( window ).scroll( setScroll );

                // set table height of nested data table (date, location, time, sign up button)
                setNestedTableHeight();
                // set starting column width for scrollable wrappers
                setStartingColumnWidths();
            }, 900);

            increaseDisplayLimits(true);
        };

        /**
         * Increases the limitTo value of the ng-repeat of filteredData by incrementing it periodically until all data is rendered,
         * this improves loading time for large signups
         */
        var increaseDisplayLimits = function( firstIteration ){
            var timeoutTime = firstIteration ? 600:25;
            var increaseSlotLimit = $scope.filteredData.length > $scope.displayLimits.items;
            var increaseDateLimit = $scope.dateCount > $scope.displayLimits.dates;

            if( increaseSlotLimit || increaseDateLimit ){
                $timeout( function(){
                    if( increaseSlotLimit ){
                        $scope.displayLimits.items = $scope.displayLimits.items+20;
                    }
                    if( increaseDateLimit ){
                        $scope.displayLimits.dates = $scope.displayLimits.dates+20;
                    }
                }, timeoutTime).then( increaseDisplayLimits );
            }
        };

        // DEV NOTE: Comment out in SUG-16260. Will be delegated to $watch 
        init();

    }]);


    // No Date (slots only) sign up controller
    SUGApp.controller('noDateSignUpController',
        ['$scope','SUGUtilities','signupPageService','$filter','errorService','$sce','$window','$timeout',
        function( $scope,util,svc,$filter,errorService,sce,$window,$timeout ) {

        // get the cached info
        $scope.memberInfo = svc.getMemberInfo();
        $scope.signupInfo = svc.getSignUpInfo();
        $scope.themeInfo = svc.getThemeInfo();

        // initial limit on load
        $scope.displayLimit = 10;
        var arrData = [];
        $scope.filteredData = [];
        $scope.showLocation = false;

        // set slot title
        if( util.keyExists($scope.signupInfo, 'slottitle') && $scope.signupInfo.slottitle !== $scope.strings.lbls.availableSlot ){
            $scope.strings.lbls.availableSlot = $scope.signupInfo.slottitle;
        }

        // handles page setup when new slots added
        $scope.$watch('signupInfo.currentSlots', function(newValue) {
            $scope.filteredData = [];
            arrData = [];
            init();
        })

        /**
         * Prep data for UI presentation
         */
        var prepData = function(){
            $scope.showTime = false;
            /*
            var currentPageObj = $scope.signupInfo.currentSlots[0];
            var objSlots = util.deepCopy(currentPageObj);
            */
            // Uncomment to use old non-paginated version
            var objSlots = util.deepCopy($scope.signupInfo.slots);
            // build return value to be iterated
            for (var key in objSlots) {
                if (objSlots.hasOwnProperty(key)) {
                    // dateLabel
                    objSlots[key]['dateLabel'] = getDateLabel( objSlots[key].starttime );
                    // iterate items
                    for( var i=0; i<objSlots[key].items.length; i++ ){
                        var itemId = objSlots[key].items[i].itemid;
                        // complete image object, needed for image zoom modal
                        var objImages = typeof $scope.signupInfo.itemimages[itemId] !== 'undefined' ? $scope.signupInfo.itemimages[itemId] : {};
                        objSlots[key].items[i]['images'] = objImages;
                        // add main image per item
                        if( typeof objSlots[key].items[i]['itemimage'] === 'undefined' ){
                            objSlots[key].items[i]['itemimage'] = util.keyExists($scope.signupInfo.itemimages[itemId],'images',true) && $scope.signupInfo.itemimages[itemId].images.length ? $scope.signupInfo.itemimages[itemId].images[0] : '';

                        }
                        // handle availability and participants
                        objSlots[key].items[i]['participants'] = util.keyExists($scope.signupInfo, 'participants', true) && util.keyExists($scope.signupInfo.participants, objSlots[key].items[i].slotitemid, true) ? $scope.signupInfo.participants[objSlots[key].items[i].slotitemid] : [];
                        var stcAvailable = svc.getAvailability( objSlots[key].items[i].qty, objSlots[key].items[i].qtytaken, objSlots[key].items[i].isaddlocked, $scope.isLocked(), objSlots[key].items[i].hidenumberwanted, objSlots[key].items[i].waitlist, svc.getMemberParticipantData(objSlots[key].items[i]['participants'], $scope.memberId) );
                        objSlots[key].items[i]['waitlistPosition'] = stcAvailable.waitlistPosition;
                        objSlots[key].items[i]['qtyLabel'] = stcAvailable.qtyLabel;
                        objSlots[key].items[i]['qtyLabelResponsive'] = stcAvailable.qtyLabelResponsive;
                        objSlots[key].items[i]['btnState'] = stcAvailable.btnState;
                        // get the logged in member's qty already signed up for
                        objSlots[key].items[i]['myqty'] = ( $scope.memberId ) ? $scope.getQtyForMember(objSlots[key].items[i]['participants'], $scope.memberId) : 0;
                        objSlots[key].items[i]['deleteModalInfo'] = $scope.getDeleteModalInfo( objSlots[key].items[i], objSlots[key], objSlots[key].items[i].slotitemid );
                        objSlots[key].items[i]['waitlistQtyLabel'] = svc.getWaitlistAvailability(objSlots[key].items[i].waitlist, objSlots[key].items[i].waitlistedparticipantcount, objSlots[key].items[i].qty, objSlots[key].items[i].qtytaken);
                    }

                    // add item
                    arrData.push(objSlots[key]);
                }
            }
        };

        /**
         * Deletes an item member.
         *
         * @modalInfo {Object} - see getDeleteModalInfo for contents
         * @itemmember {Object} - itemmember to delete
         */
        $scope.deleteItemMember = function(modalInfo, itemmember){
            // wait for the promise to resolve and if successful, delete the item member from the client side cache
            svc.deleteItemMemberModal(modalInfo, itemmember).then(function (deleteInfo) {
                // delete the itemmember from the main participants array
                var participants = $scope.signupInfo.participants[modalInfo.slotitemid];
                $scope.signupInfo.participants[modalInfo.slotitemid] = participants.filter( function(itemmember){
                    return itemmember.itemmemberid != deleteInfo.itemmemberid;
                });

                // no date should only have one array element, if there are any slots
                if( $scope.filteredData.length ){
                    var slotitemIdx;
                    $scope.filteredData[0].items.some( function(slotitem, siIdx){
                        if( slotitem.slotitemid === modalInfo.slotitemid ){
                            slotitemIdx = siIdx;
                            return true;
                        }else{
                            return false;
                        }
                    });
                    // if slotitem found, update the participants array and quantity info for the item member
                    if( util.isIntegerGTE0(slotitemIdx) ){
                        $scope.filteredData[0].items[slotitemIdx].participants = $scope.signupInfo.participants[deleteInfo.slotitemid];
        
                        if (!deleteInfo.waitlistsignup && $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount > 0) {
                            // take the deleted signup myqty and remove from the waitlistedparticipantcount
                            // if the result of the waitlistedparticipantcount is negative, then remove that from the qtytaken and zero out the waitlistedparticipantcount

                            $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount = ($scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[0].items[slotitemIdx].myqty);
                           
                            if ($scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount < 0) {
                                $scope.filteredData[0].items[slotitemIdx].qtytaken += $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount;
                                $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount = 0;
                            }
                        }
                        else if (deleteInfo.waitlistsignup) {
                            $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount = Math.max($scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount - $scope.filteredData[0].items[slotitemIdx].myqty, 0);
                            $scope.filteredData[0].items[slotitemIdx].qtytaken = Math.max($scope.filteredData[0].items[slotitemIdx].qtytaken, 0);
                        }
                        else {
                            $scope.filteredData[0].items[slotitemIdx].qtytaken = Math.max($scope.filteredData[0].items[slotitemIdx].qtytaken - $scope.filteredData[0].items[slotitemIdx].myqty, 0);
                        }

                        var stcAvailable = svc.getAvailability( $scope.filteredData[0].items[slotitemIdx].qty, $scope.filteredData[0].items[slotitemIdx].qtytaken, $scope.filteredData[0].items[slotitemIdx].isaddlocked, $scope.isLocked(), $scope.filteredData[0].items[slotitemIdx].hidenumberwanted, $scope.filteredData[0].items[slotitemIdx].waitlist, svc.getMemberParticipantData($scope.filteredData[0].items[slotitemIdx].participants, $scope.memberId) );
                        $scope.filteredData[0].items[slotitemIdx].waitlistPosition = stcAvailable.waitlistPosition;
                        $scope.filteredData[0].items[slotitemIdx].qtyLabel = stcAvailable.qtyLabel;
                        $scope.filteredData[0].items[slotitemIdx].qtyLabelResponsive = stcAvailable.qtyLabelResponsive;
                        $scope.userSignUp.totalQty -= $scope.filteredData[0].items[slotitemIdx].myqty;
                        $scope.filteredData[0].items[slotitemIdx].myqty = ( $scope.memberId ) ? $scope.getQtyForMember($scope.filteredData[0].items[slotitemIdx].participants, $scope.memberId) : 0;
                        $scope.filteredData[0].items[slotitemIdx].waitlistQtyLabel = svc.getWaitlistAvailability($scope.filteredData[0].items[slotitemIdx].waitlist, $scope.filteredData[0].items[slotitemIdx].waitlistedparticipantcount, $scope.filteredData[0].items[slotitemIdx].qty, $scope.filteredData[0].items[slotitemIdx].qtytaken);

                        // If a person was just removed from a slot then we know we have at least 1 available slot, so be sure to reset hasAvailableSlots
                        if (!$scope.signupInfo.hasavailableslots) {
                            $scope.signupInfo.hasavailableslots = true;
                            $scope.es.clearErrors();
                        }

                        $scope.filteredData[0].items[slotitemIdx].btnState = stcAvailable.btnState;
                    }
                }
            });
        };

        /**
         * Sets filter on slots - returns filtered slots as $scope.filteredData
         *      (similar function - rsvpSignUpController::filterSlots - may be able to combine in signupController)
         */
        $scope.setFilteredData = function(){
            $scope.filteredData = arrData;
        };

        /*
        * method called on scroll
        *   expects a scrollable element to have class="scrollable"
        *   and a parent wrapping element with the same id as itself plus "-wrap"
        *   (i.e. id="myelement" with parent of id="myelement-wrap")
		*/
		var setScroll = function(){
            var scrollableElems = document.getElementsByClassName('scrollable');
            var intBuffer = 8;
            for (var i = 0; i < scrollableElems.length; i++) {
                var elemWrap = document.getElementById( scrollableElems[i].id + '-wrap' );
                var elemSubj = $( '#' + scrollableElems[i].id );
                calcScroll( elemWrap, elemSubj, intBuffer );
            }
        };

        /**
		 * Helper method to calulate scroll for sticky segment - adds appropriate css to subject element
		 * @elWrap - reference to DOM wrapping element (sets the top and bottom of the content section to scroll)
		 * @elSubject - reference to subject element to scroll
		 * @intBuffer - int, pixels to add as a buffer to the top and bottom of the scrolled content
		 */
        var calcScroll = function( elWrap, elSubject, intBuffer ){
            var elemHeight = elSubject.height();
            var intSubjectWidth = $scope.columnWidths[elSubject[0].id];
            var intWrapWidth = $scope.columnWidths[elWrap.id];
            if( elWrap.getBoundingClientRect().top > 0 ){   // scroll has not reached top of subject yet
                elSubject.css({ position:'relative', top: 0 });
            }
            else if( elWrap.getBoundingClientRect().bottom - elemHeight - (2 * intBuffer) >= 0 ){ // scroll is between top of subject element and bottom (including top and bottom buffer)
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: intBuffer });
                // reset width of wrapping element
                // this was required in some cases where the only child of the wrapper was the one being scrolled and position:fixed caused all columns to collapse
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else if( elWrap.getBoundingClientRect().bottom >= 0 ){  // scroll is after element height minus top/bottom buffer but before subject bottom
                elSubject.css({ width: intSubjectWidth, position: 'fixed', top: elWrap.getBoundingClientRect().bottom - elemHeight - intBuffer });
                $( '#' + elWrap.id ).css({ width: intWrapWidth, 'max-width': intWrapWidth, 'min-width': intWrapWidth });
            }
            else{   // scroll is passed element bottom (element is off screen)
                elSubject.css({ position: 'relative', top: 0});
            }
        };

        /**
		 * Helper method to set starting column widths scrollable elements and wrappers
         * Subsequently used by scrolling method to ensure originally rendered widths are retained
         * Sets a scoped object with key value pairs where key is the element id and value is the pixel width
         * (i.e. { 39821-48522-date-wrap: 100, ... } )
		 */
        var setStartingColumnWidths = function(){
            $scope.columnWidths = {};
            var scrollableElems = document.getElementsByClassName('scrollable');
            for (var i = 0; i < scrollableElems.length; i++) {
                $scope.columnWidths[ scrollableElems[i].id ] = document.getElementById( scrollableElems[i].id ).getBoundingClientRect().width;
                $scope.columnWidths[ scrollableElems[i].id + '-wrap' ] = document.getElementById( scrollableElems[i].id + '-wrap' ).getBoundingClientRect().width;
            }
        };

        /**
		 * Helper method to return formatted date and day
		 * @strStart - start time
		 */
        var getDateLabel = function( strStart ){
            var dtStart = new Date(strStart);
            var stcStartDate = {
                "date": $filter('date')(dtStart, $scope.signupInfo.shortdformat.replace('mm','MM')),
                "day": $filter('date')(dtStart, 'EEEE'),
            };
            return stcStartDate;
        };



        var init = function(){
            prepData();
            $scope.setFilteredData();

            // set starting column width for scrollable wrappers
            // allow time for table to render and any slot images to load
            $timeout(function(){
                // bind scroll to function
                $( window ).scroll( setScroll );

                setStartingColumnWidths();
            }, 900);

            increaseDisplayLimit(true);
        };

        /**
         * Increases the limitTo value of the ng-repeat of filteredData by incrementing it periodically until all data is rendered,
         * this improves loading time for large signups
         */
        var increaseDisplayLimit = function( firstIteration ){
            var timeoutTime = firstIteration ? 600:25;

            if( $scope.filteredData.length && $scope.filteredData[0].items && ($scope.filteredData[0].items.length > $scope.displayLimit) ){
                $timeout( function(){
                    $scope.displayLimit = $scope.displayLimit+20;
                }, timeoutTime).then( increaseDisplayLimit );
            }
        };


        // DEV NOTE: Comment out in SUG-16260. Will be delegated to $watch 
        init();

    }]);

    //MARK: calendar view sign up controller
    SUGApp.controller('calendarSignUpController',
    ['$scope','SUGUtilities','signupPageService','$filter','errorService','$sce','$window','$timeout','$modal','$route',
        function( $scope,util,svc,$filter,errorService,sce,$window,$timeout,$modal,$route) {
        // get the cached sign up info
        $scope.memberInfo = svc.getMemberInfo();
        $scope.showCalendarView = true;
        $scope.urlkey = svc.getUrlKey();
        $scope.portalid = svc.getPortalId();
        $scope.baseCalendarParams = { forSignUpView:true, listid: $route.current.params.signupid, urlid: $scope.urlkey , portalid: $scope.portalid, view: 'calendar', calendarMonth: svc.getCurrentMonth() }

        $scope.themeInfo = svc.getThemeInfo();
        // Since the calendar makes paginated requests, we need to clear the existing list view slots out of scope and refetch the initial slots
        $scope.signupInfo.calendarSlots = {};
        $scope.signupInfo.calendarview = true; // needs to true for calendar / list toggle to work when cal is default, otherwise it gets stuck. This is also needed for sign up particiant summary modal to work (for sign up type)
        $scope.hasCalendarSlots = false;

        $scope.str = {
            signedup: 'You are signed up on this date.',
        };
        $scope.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        $scope.calendarGrid = [];       // UI calendar grid

        $scope.dates = {
            next: {
                jsDate: undefined,

            },
            prev: {
                jsDate: undefined,

            },
            selected: {
                monthname: '',
                jsDate: new Date(),
                jsFDOM: undefined,             // first day of the month
                jsLDOM: undefined,             // last day of the month
                firstdayofweek: '',
            },
            jsMinDate: undefined,
            jsMaxDate: undefined,
        };

        $scope.btnState = {
            default:  'default',
            selected: 'selected',
            full:     'full',
            locked:   'locked',
            waitlist:   'waitlist',
            waitlist_disabled:   'waitlist_disabled',
            waitlisted:   'waitlisted'
        };

        var arrSignUpDates = [];    // all dates that have sign up info
        var objCalendarCache = {};   // local calendar grid cache, months get added as requested
        var arrGridDays = [];       // array of day objects
        var objGridDayBlank = {     // blank day object
            show: false,            // show grid on calendar or not (blank vs a numbered calendar day)
        };
        var signUpDateBlank = {     // blank sign up date object
            jsDateOnly: {},
            slots: [],    // array of objects like { time: "9a-10:30am", slots: [...] }
            isUserSignedUp: false,
            isSelected: false,
            isFull: false,
            isLocked: false,
            moreLabel: '',
            hasTimes: false,        // flag for whether any slotitem to be displayed has a time; impacts indentation in UI
        };
        var arrUserSlotItems = [];      // slot items user is signed up for
        var slotsAvailable = false;     // flag to show if sign up has current or future available slots
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var selectedMonth = {};         // date object used by navigation - previous and next
        var itemDisplayLimit = 3;       // the max number of items to display on a calendar date

        /** Initialize a loading event for showing a loading spinner when paging between calendar months.
         *
         */
        $scope.$on('isProcessing', function (event, isProcessing) {
            $scope.calendarLoading = isProcessing;
            if ($scope.calendarLoading) {
                util.showLoading('processing');
            }
        });
        util.broadCast("isProcessing", true);

        /**
		 * Helper method to return formatted date and day
		 * @param {strStart} - start time
		 */
        var getDateLabel = function( strStart ){
            var dtStart = new Date(strStart);
            var stcStartDate = {
                "date": $filter('date')(dtStart, $scope.signupInfo.shortdformat.replace('mm','MM')),
                "day": $filter('date')(dtStart, 'EEEE'),
            };
            return stcStartDate;
        };

        /**
         * Helper method to return formatted start time, and end time if appropriate
         * @strStart - start time
         * @strStart - end time, empty string if empty
         */
        var getTimeLabel = function( strStart, strEnd ){
            var dtStart = new Date(strStart);
            var strLabel = '';
            // Add start time
            strLabel += '<span class="no-wrap">' + $filter('date')(dtStart, 'h:mma').toLowerCase();
            if( !strEnd.length ){
                strLabel += '</span>';
            }
            else{
                var dtEnd = new Date(strEnd);
                strLabel += '- </span><br><span class="no-wrap">' + $filter('date')(dtEnd, 'h:mma').toLowerCase() + '</span>';
            }
            if( strLabel.length ){ $scope.showTime = true; }
            return strLabel;
        };

        /**
         * For only the current day that is selected, this validates our button selections and keeps them in sync with selectedSlotItems.
         * The UI can get out of sync when the user cancels from the sign up page.
         * This prevents this issue while keeping things in order with the calendar view modal.
         * @objDate {ObjDate}  - current signup date object
         * @returns {ObjDate}  - verfied signup date object
         **/
        $scope.validateSelectedSlotItemsForDate = function( objDate ) {
            if (typeof $scope.selectedSlotItems !== 'undefined' && typeof objDate.slots !== 'undefined') {
                for( var s = 0; s < objDate.slots.length; s++ ){

                    var slotitem = objDate.slots[s].slotitems;

                    for( var i = 0; i < slotitem.length; i++ ){

                        //our button is selected, but is not found in our selected items array - set it to default
                        if ( slotitem[i].btnState === $scope.btnState.selected && $scope.selectedSlotItems.indexOf(slotitem[i].slotitemid) === -1) {
                            slotitem[i].btnState = $scope.btnState.default;

                        //our button is not selected, but is found in our selected items array - set it to selected
                        } else if ( slotitem[i].btnState === $scope.btnState.default && $scope.selectedSlotItems.indexOf(slotitem[i].slotitemid) !== -1) {
                            slotitem[i].btnState = $scope.btnState.selected;
                        }
                    }
                }
            }

            return objDate;
        };


        /**
         *  Launches the calendar slot selection modal.  Fires when the sign up button for a calendar date is pressed.
         *  This differs from the button selection in all other templates in that the button represents the entire caledar date
         *  which may include multiple slots and slot items.  In the caledar this event is fired when the user
         *  clicks on a button whose label is 'Sign Up', 'Edit', or 'Selected'.
         * @objDate {Object} - the calendar date object
         * @shortdformat {String} - short date format
         * @dateformat {String} - text date format
         * @tzshort {String} - short timezone format
         */
        $scope.openCalendarItem = function( slotsCopy, objDate, shortdformat, dateformat, tzshort ) {

            //For undo | cancel
            var ObjDateCopy = util.deepCopy(objDate);
            var selectionHistoryArray = [];

            var calendarViewWindow = $modal.open({
                templateUrl: '/view/signups/incl_dspCalendarViewModal.html',
                controller: 'calendarViewModalController',
                resolve: {
                    //pass data into the modal
                      objDate:                          function () { return objDate;                              }
                    , shortdformat:                     function () { return shortdformat;                         }
                    , dateformat:                       function () { return dateformat;                           }
                    , tzshort:                          function () { return tzshort;                              }
                    , theme:                            function () { return $scope.theme;                         }
                    , selectedSlotItems:                function () { return $scope.selectedSlotItems;             }
                    , selectionHistoryArray:            function () { return selectionHistoryArray;                }
                    , memberId:                         function () { return $scope.memberId;                      }
                    , isUserSignUpAdmin:                function () { return $scope.isUserSignUpAdmin;             }
                    , isUserSignUpOwner:                function () { return $scope.isUserSignUpOwner;             }
                    , listid:                           function () { return $scope.signupInfo.id;                 }
                    , signuptype:                       function () { return $scope.determineSignupType();         }
                    , userSignUp:                       function () { return $scope.userSignUp;                    }
                    , memberInfo:                       function () { return $scope.memberInfo;                    }
                    , openParticipantDetails:           function () { return $scope.openParticipantDetails;        }
                    , editItemMember:                   function () { return $scope.editItemMember;                }
                    , swapItemMember:                   function () { return $scope.swapItemMember;                }
                    , signupInfo:                       function () { return $scope.signupInfo;                    }
                    , getQtyForMember:                  function () { return $scope.getQtyForMember;               }
                    , toggleSlotItem:                   function () { return $scope.toggleSlotItem;                }
                    , getDateLabel:                     function () { return getDateLabel;                         }
                    , isLocked:                         function () { return $scope.isLocked;                      }
                    , arrUserSlotItems:                 function () { return arrUserSlotItems;                     }
                }
            }, function () {
                // rejected
            });

            calendarViewWindow.result
                .then( function(response) {

                    //success
                    getButtonStatuses(); //validates button front facing buttons in Calendar View only (not the modal)

                    //if save and continue is selected, go to the sign up page
                    if (response.saveandcontinue) {
                        $scope.saveAndContinue();
                    }

                    return true;
                }, function(response){

                    //User Cancelled - Be Kind Rewind
                    var unwind = true;

                    //validate selected buttons
                    objDate = $scope.validateSelectedSlotItemsForDate(ObjDateCopy);

                    //unwind history selections (also keeps the Save and Continue bar in sync)
                    for( var i = 0; i < selectionHistoryArray.length; i++ ){
                        $scope.toggleSlotItem(selectionHistoryArray[i], unwind);
                    }



                    getButtonStatuses(); //validates button front facing buttons in Calendar View only (not the modal)

                    return false;
                });

        };  // END openCalendarItem


        /**
         *  Prepares the calendar slot selection modal.  Fires when the sign up button for a calendar date is pressed.
         *  This differs from the button selection in all other templates in that the button represents the entire caledar date
         *  which may include multiple slots and slot items.  In the calendar this event is fired when the user
         *  clicks on a button whose label is 'Sign Up', 'Edit', or 'Selected'.
         * @objDate {Object} - the calendar date object
         */
        $scope.toggleDateStatus = function(objDate){
            // launch slot selection modal
            // TODO: Build launch of slot selection modal
            // Temp message for testers

            //used to format the date inside the view controller
            var shortdformat = $scope.signupInfo.shortdformat;
            var tzshort      = $scope.signupInfo.tzshort;
            var dateformat   = $scope.strings.lbls.dateformat;

            //validate selected buttons
            objDate = $scope.validateSelectedSlotItemsForDate(objDate);

            var slotsCopy = util.deepCopy(objDate.slots);

            if (objDate.buttonStatus == $scope.btnState.default) {
                objDate.buttonStatus =  $scope.btnState.selected;
            }

            $scope.openCalendarItem( slotsCopy, objDate, shortdformat, dateformat, tzshort );
        };


        /**
         * Changes the display month based on user selection
         * @newDate {Object} - the new date to set the calendar to
         *
         */
        $scope.changeMonth = function( newDate, disabled ){
            if (disabled) {
                return;
            }
            util.broadCast("isProcessing", true);

            // set selected month
            selectedMonth = newDate;
            // determine diplay month
            setDisplayMonth();
            // get the slots for the new current month and re-build the calendar
            getSlotsForCurrentMonth({calendarMonth: $scope.dates.selected.queryMonth})
            // refresh ads upon month change
            util.refreshPageAds();
        };

        /**
         * Tooltip for a Selected sign up button
         *  Uses inline html breaks to control width
         */
        $scope.getSelectedTooltip = function ( count ){
            var tip = 'You have selected<br>' + count + ' slot';
            if( count > 1 ){ tip += 's'; }
            tip += ', "Save & Continue"<br>to complete your sign up';
            return tip;
        };

        /**
         * Get all dates for the sign up
         *  Populates arrSignUpDates
         */
        var prepSignUpDates = function(){
            arrSignUpDates = []; //This needs to re-init for back-to-signup to work properly, otherwise particiant object changes are not updated.

            // Local sign up data object
            var objSignupInfo = {};
            // For slot sorted, we essentially have to convert the object from slot sorted to date sorted
            if( $scope.signupInfo.itemsort.toString().toLowerCase() === 'i' ){
                //  We don't want to manipulate $scope.signupInfo directly since user can switch back to list view
                objSignupInfo = util.deepCopy( $scope.signupInfo );
                objSignupInfo = rebuildSlotSorted( objSignupInfo );
            }
            else{
                // since we aren't changing the structure for non-slot sorted, we can use a reference to $scope variable (copy is resource intensive)
                objSignupInfo = $scope.signupInfo;
            }

            $scope.virtualLocations = objSignupInfo.virtuallocations;


            // populate arrSignUpDates
            angular.forEach(objSignupInfo.calendarSlots, function( slot ){
                // grab copy to make it easier to deal with
                var date = util.deepCopy( slot );
                var jsDateOnly = new Date( new Date( date.starttime ).toDateString() ); // convert starttime (string) to just the date without the time
                // if date is already in addSignUpDates, append slots to existing, otherwise add new date to arrSignUpDates
                var isDateAlreadyExists = false;
                // get date (no time) for slot - if date already exists in arrSignUpDates, append slots
                for( var i=0; i<arrSignUpDates.length; i++ ){
                    if( arrSignUpDates[i].jsDateOnly.getTime() === jsDateOnly.getTime() ){
                        arrSignUpDates[i].slots.push( getSlotsForDate( date ) );
                        isDateAlreadyExists = true;
                        break;
                    }
                }
                // if date isn't already in arrSignUpDates, add it
                if( !isDateAlreadyExists ){
                    var _signUpDate = util.deepCopy(signUpDateBlank);
                    _signUpDate.jsDateOnly = jsDateOnly;
                    _signUpDate.slots = [ getSlotsForDate( date ) ];
                    arrSignUpDates.push( _signUpDate );
                }
            });
            // Set items to display and the more label subject to display limits
            applyDisplayLimit();
            // Determine button statuses
            getButtonStatuses();
            // sort data structure - order by date, times within date, then name
            sortSignUpDates();
            // cache data
            svc.setSignUpDates( arrSignUpDates );
        };

        /**
         * Helper method to get the locaton for our UI
         * @param {integer} locId - determines if usetime should run
         * @param {integer} virtualLocationId - the id of the virtual location who's location data we need
         * @returns {object} stcLocation - location used for signup display
         */
        var getLocationObj = function( locId, virtualLocationId ){
            var stcLocation = {
                url: '',
                full: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zipcode: '',
                virtuallocationurl: null,
                physicalandvirtual: false
            };
            // Some dates can have both a virtual and physical location, so we build some metadata around that.
            const virtualLocation = $scope.virtualLocations[virtualLocationId];
            const location = $scope.signupInfo.locations[locId];
            if (virtualLocation) {
                stcLocation.virtuallocationurl = virtualLocation.virtuallocationlinkurl;
            }
            if (location && virtualLocation) {
                stcLocation.physicalandvirtual = true;
            }
            if( location && Object.keys($scope.signupInfo.locations[locId]).length !== 0 ){
                // location object
                var stcLoc = $scope.signupInfo.locations[locId];
                // build address string
                var strLoc = stcLoc.address1.length ? stcLoc.address1 : '';
                strLoc += stcLoc.address2.length ? ' ' + stcLoc.address2 : '' ;
                if( strLoc.length ){ strLoc += ', '; }
                strLoc += stcLoc.city.length ? stcLoc.city + ', ' : '';
                strLoc += stcLoc.state.length ? stcLoc.state + ' ' : '';
                strLoc += stcLoc.zipcode > 0 ? stcLoc.zipcode.toString() : '';
                strLoc = strLoc.trim();
                // set address and url
                if( strLoc.length ){
                    stcLocation.full = strLoc;
                    stcLocation.url = 'https://www.google.com/maps/search/?api=1&query=' + strLoc.replace(/ /g, '+');
                    stcLocation.address1 = stcLoc.address1;
                    stcLocation.address2 = stcLoc.address2;
                    stcLocation.city = stcLoc.city;
                    stcLocation.state = stcLoc.state;
                    stcLocation.zipcode = stcLoc.zipcode;
                }
            }


            return stcLocation;
        };

         /**
          * Get slots for a date
          * @param {object} objDate - date object that stores signup items for this date - MARK2date
          * @returns {object} returnObj - signup items for our calendar view modal
          */
        var getSlotsForDate = function( objDate ){
            var returnObj = {
                usetime: objDate.usetime,
                starttime: objDate.starttime,
                endtime: objDate.endtime,
                locationid: objDate.locationid,
                location: objDate.location,
                locdetail: getLocationObj(objDate.locationid, objDate.virtuallocationid),
                time: getTimeWithMinutesLabel(objDate.starttime, objDate.endtime, objDate.usetime ),
                jsstarttime: new Date( objDate.starttime ),
                slotitems: [],
                displayitems: [],
                moreLabel: '',
                showPaymentMessage: false,
                paymentMessage: '',
                timeLabel :  objDate.usetime ? getTimeLabel( objDate.starttime, objDate.endtime ) : '',
                dateLabel : getDateLabel( objDate.starttime ),
                virtuallocationid: objDate.virtuallocationid
            };

            returnObj.locdetail.showicon = true;
            returnObj.locdetail.location = objDate.location;

            objDate['dateLabel'] = getDateLabel( objDate.starttime );
            for( var i=0; i<objDate.items.length; i++ ){
                var slotitem = objDate.items[i];
                //pull item images
                if (typeof $scope.signupInfo.itemimages[slotitem.itemid] == 'object') {
                    var product = $scope.signupInfo.itemimages[slotitem.itemid];

                    if (typeof product['images'] !== 'undefined') {
                        if (product['images'].length) {
                            slotitem.itemimage = product['images'][0];
                            slotitem.images = product;
                        }
                    }
                }

                slotitem.isaddlocked = !!slotitem.isaddlocked ? slotitem.isaddlocked : ( !!objDate.isaddlocked ? objDate.isaddlocked : false );

                if (!slotitem.isaddlocked) {
                    slotitem.isaddlocked = $scope.isLocked();
                }

                returnObj.displayitems.push( slotitem.item );

                /* normalize important calendar view data - This info is undefined if accessed directly from the Calendar View, this ensures we have the correct data */
                slotitem['participants'] = util.keyExists($scope.signupInfo, 'participants', true) && util.keyExists($scope.signupInfo.participants, slotitem.slotitemid, true) ? $scope.signupInfo.participants[slotitem.slotitemid] : [];

                var stcAvailable = svc.getAvailability( slotitem.qty, slotitem.qtytaken, slotitem.isaddlocked, $scope.isLocked(), slotitem.hidenumberwanted, slotitem.waitlist, svc.getMemberParticipantData(slotitem['participants'], $scope.memberId) );
                slotitem['qtyLabel'] = stcAvailable.qtyLabel;
                slotitem['qtyLabelResponsive'] = stcAvailable.qtyLabelResponsive;
                slotitem['waitlistQtyLabel'] = svc.getWaitlistAvailability(slotitem.waitlist, slotitem.waitlistedparticipantcount, slotitem.qty, slotitem.qtytaken);
                slotitem['waitlistPosition'] = stcAvailable.waitlistPosition;

                // if there are selected slotitems in scope, first determine if this slotid is selected
                if( $scope.selectedSlotItems.length ){
                    //our button is selected, but is not found in our selected items array - set it to default
                    if ( slotitem.btnState === $scope.btnState.selected && $scope.selectedSlotItems.indexOf(slotitem.slotitemid) === -1) {
                        slotitem.btnState = $scope.btnState.default;

                    //our button is not selected, but is found in our selected items array - set it to selected
                    } else if ( slotitem.btnState === $scope.btnState.default && $scope.selectedSlotItems.indexOf(slotitem.slotitemid) !== -1) {
                        slotitem.btnState = $scope.btnState.selected;
                    }
                }

                if ( slotitem.isaddlocked ) {
                    slotitem.btnState = $scope.btnState.locked;
                }

                slotitem['deleteModalInfo'] = $scope.getDeleteModalInfo( slotitem, objDate, slotitem.slotitemid );
                slotitem['myqty'] = ( $scope.memberId ) ? $scope.getQtyForMember(slotitem['participants'], $scope.memberId) : 0;


                //get show payment message
                if (typeof slotitem.paymenttype !== 'undefined' && slotitem.paymenttype !== 'none') {
                    returnObj.paymentMessage = svc.setFeeMessage($scope.signupInfo);
                    if (returnObj.paymentMessage.length) {
                        returnObj.showPaymentMessage = true;
                    }
                }

                //qty is full, set button status to full
                if( slotitem.qty <= slotitem.qtytaken ){
                    // check for waitlist available
                    if (stcAvailable.btnState == $scope.btnState.waitlist 
                        || stcAvailable.btnState == $scope.btnState.waitlisted 
                        || stcAvailable.btnState == $scope.btnState.waitlist_disabled) {
                            
                        slotitem.btnState = stcAvailable.btnState;  // use the determined state from the getAvailability() method
                    }
                    else {
                        slotitem.btnState = $scope.btnState.full;
                    }
                }

                returnObj.slotitems.push(slotitem);
            }

            // sort slotitems by itemsort (should be done by back end, but just in case)
            returnObj.slotitems.sort(function( a, b ){
                return a.itemorder - b.itemorder;
            });

            return returnObj;
        };


        /**
         * Get slots for a date - used for date sorted sign ups
         *  Essentially rebuilds a slot sorted sign up as date sorted to be more easily used by the date-centric calendar view
         * @param  {Object} objSignup - sign up data - copy of $scope.SignupInfo
         */
        var rebuildSlotSorted = function( objSignup ){
            // get dates
            var arrDates = getDatesFromSlotSorted( objSignup );
            // get slots
            var arrSlots = getSlotsFromSlotSorted( objSignup );

            // get an index of slot item objects
            var objSlotItemIndex = getSlotItemIndex( objSignup );
            // rebuild new items array - will be nested within new slots object
            var arrNewItems = util.deepCopy(arrDates);
            if(arrNewItems.length){
                for(var didx=0;didx<arrNewItems.length;didx++){
                    arrNewItems[didx].items = getUpdatedItem( arrNewItems[didx].slotid, objSlotItemIndex, arrSlots );
                }
            }

            // rebuild new slots object
            var objNewSlots = {};
            for( var i=0; i<arrNewItems.length; i++ ){
                objNewSlots[arrNewItems[i].slotid] = arrNewItems[i];
            }
            // set slots = new slots
            objSignup.slots = objNewSlots;
            objSignup.calendarSlots = objNewSlots;

            //add missing key,value pairs to our slotitems - this info was getting lost in the re-compiling from slot sorted to date sorted - tried to find a better place, the setup is confusing
            var keys = ['amountpledged','amountraised','amounttotal','btnState','deleteModalInfo','isaddlocked','ismodifylocked','myqty','qtytaken','participants','participantcount','qtyLabel','qtyLabelResponsive'];

            angular.forEach(objSignup.slots, function (signupslot) {
                angular.forEach(signupslot.items, function (slotitem) {
                    angular.forEach(slotitem.dates, function (date) {
                        if (slotitem.slotitemid === date.slotitemid) {

                            //move to slotitem
                            if (slotitem.slotitemid === date.slotitemid) {

                                //copy key value pair to slotitem
                                angular.forEach(keys, function (key) {
                                    if (date[key] !== 'undefined') {
                                        slotitem[key] = date[key];
                                    }
                                });
                            }
                        }
                    });

                    delete slotitem.dates; //clean up
                });

                //remove extraneous top level data - these fragments are ending up on the top level
                angular.forEach(keys, function (key) {
                    if (keys[key] !== 'undefined') {
                        delete signupslot[key];
                    }
                });

            });

            // return updated object
            return objSignup;
        };

        /**
         * Get all the dates from a slot sorted sign up
         *  Helper method for rebuildSlotSorted
         * @param  {Object} objSignup - sign up data - copy of $scope.SignupInfo
         */
        var getDatesFromSlotSorted = function( objSignup ){
            var retDates = [];
            // loop through each slot and its dates array, and add all the unique dates to the dates array
            angular.forEach(objSignup.slots, function (slot) {
                angular.forEach(slot.dates, function (date) {
                    var dateHit = retDates.some(function (dt) {
                        return dt.slotid.toString() === date.slotid.toString();
                    });
                    if (!dateHit) {
                        var currentDate = angular.copy(date);
                        retDates.push(currentDate);
                    }
                });
            });

            return retDates;
        };

        /**
         * Get all the slots from a slot sorted sign up
         *  Helper method for rebuildSlotSorted
         * @param  {Object} objSignup - sign up data - copy of $scope.SignupInfo
         */
        var getSlotsFromSlotSorted = function( objSignup ){
            var arrSlots = [];
            // remove the dates key and return only the slots
            angular.forEach(objSignup.slots, function(slot){
                var currentSlot = util.deepCopy(slot);
                arrSlots.push(currentSlot);
            });
            return arrSlots;
        };

        /**
         * Get all the slotitems from a slot sorted sign up
         *  Helper method for rebuildSlotSorted
         * @param  {Object} objSignup - sign up data - copy of $scope.SignupInfo
         */
        var getSlotItemsFromSlotSorted = function( objSignup ){
            var slotitems = [];
            angular.forEach(objSignup.slots, function(st){
                st.dates.forEach( function(dt){
                    slotitems.push( { slotid: st.itemid, dateid: dt.slotid, slotitemid: dt.slotitemid } );
                });
            });
            return slotitems;
        };

        /**
         * Builds a quickly searchable index of dates, slots, and their relationships/slotitems
         *  Helper method for rebuildSlotSorted
         * @param  {Object} objSignup - sign up data - copy of $scope.SignupInfo
         */
        var getSlotItemIndex = function( objSignup ){
            var slotItemsByDate = {};
            var siidx = 0;
            var arrSlotItems = getSlotItemsFromSlotSorted( objSignup );
            for(siidx=0;siidx<arrSlotItems.length;siidx++){
                // BUILD DATES
                // if there is no dateid key, create it
                if(typeof slotItemsByDate[arrSlotItems[siidx].dateid] === 'undefined'){
                    slotItemsByDate[arrSlotItems[siidx].dateid] = {};
                }
                // if there is no dateid.slots key, create it
                if(typeof slotItemsByDate[arrSlotItems[siidx].dateid].slots === 'undefined'){
                    slotItemsByDate[arrSlotItems[siidx].dateid].slots = [];
                }
                // populate dateid.slotid with slotitemid
                slotItemsByDate[arrSlotItems[siidx].dateid][arrSlotItems[siidx].slotid] = arrSlotItems[siidx].slotitemid;
                // populate dateid.slots with each slotid
                slotItemsByDate[arrSlotItems[siidx].dateid].slots.push(arrSlotItems[siidx].slotid.toString());
            }
            return slotItemsByDate;
        };

        /**
         * Rearranges and returns an array of items with embedded slotitemid based on an array of slots (sign up dates)
         *  Helper method for rebuildSlotSorted
         * @param  {Number|String} dateid - subject date
         * @param  {Object} slotItemIndex - index of slot item associations
         * @param  {Object} arrSlots - array of slots with data - represents sign up dates but called slots since that's the data model (and to make things as confusing as possible)
         */
        var getUpdatedItem = function( dateid, slotItemIndex, arrSlots ){
            if( util.isUndefinedOrNullOrEmpty(dateid) ){    // shouldn't happen
                return [];
            }
            if(typeof slotItemIndex[dateid] !== 'undefined'){
                var tmpSlots = [];
                var tmpSlot = {};
                for(var sidx=0;sidx<arrSlots.length;sidx++){
                    // if slot has an itemid and the itemid is found in the index, update date and add it to the return object
                    if( arrSlots[sidx].itemid && slotItemIndex[dateid].slots.indexOf( arrSlots[sidx].itemid.toString() ) > -1){
                        // get data for slot
                        tmpSlot = util.deepCopy( arrSlots[sidx] );
                        // add slotitemid from index
                        tmpSlot.slotitemid = slotItemIndex[dateid][tmpSlot.itemid.toString()];
                        // add to return object
                        tmpSlots.push(tmpSlot);
                    }
                }
                return tmpSlots;
            }
            return [];
        };

        /**
         * Determine the display items and show more flag for each calendar date based on display limits
         */
        var applyDisplayLimit = function(){
            for( var i=0; i<arrSignUpDates.length; i++ ){
                var itemCount = 0;
                // set display items
                for( var j=0; j<arrSignUpDates[i].slots.length; j++ ){
                    arrSignUpDates[i].slots[j]['displayitems'] = [];
                    for( var k=0; k<arrSignUpDates[i].slots[j].slotitems.length; k++ ){
                        if( itemCount < itemDisplayLimit ){
                            // append slot item name to displayitems
                            arrSignUpDates[i].slots[j].displayitems.push( arrSignUpDates[i].slots[j].slotitems[k].item );
                            if( arrSignUpDates[i].slots[j].time.length ){
                                arrSignUpDates[i].hasTimes = true;
                            }
                        }
                        itemCount++;
                    }
                }
                if( itemCount - itemDisplayLimit > 0 ){    // if more are hidden, update the more label
                    arrSignUpDates[i].moreLabel = '+' + (itemCount - itemDisplayLimit).toString() + ' More';
                }
            }
        };

        /**
         * Determine the button statuses for each calendar date
         *  Button statuses are different than list views since we have to aggregate all slotitems for a given date
         */
        var getButtonStatuses = function(){
            for( var i=0; i<arrSignUpDates.length; i++ ){
                arrSignUpDates[i].isFull = getIsFull( arrSignUpDates[i] );
                arrSignUpDates[i].isLocked = getIsLocked( arrSignUpDates[i] );
                arrSignUpDates[i].isUserSignedUp = getIsUserSignedUp( arrSignUpDates[i] );
                arrSignUpDates[i].isSelected = getIsSelected( arrSignUpDates[i] );
                // determine button status based on date booleans
                arrSignUpDates[i].buttonStatus = getButtonStatus( arrSignUpDates[i].isFull, arrSignUpDates[i].isLocked, arrSignUpDates[i].isUserSignedUp, arrSignUpDates[i].isSelected );
            }
        };

        /**
         * Determine if a calendar date should show the Full button
         * @param {object} date
         *  As soon as first slotitem with availability is hit, return false
         *  Otherwise, true
         */
        var getIsFull = function(date) {
            for (let i = 0; i < date.slots.length; i++) {
                for (let j = 0; j < date.slots[i].slotitems.length; j++) {
                    // slotitem is not full
                    const slotItem = date.slots[i].slotitems[j];
                    if (slotItem.qty > slotItem.qtytaken || slotItem.waitlist) {
                        // mark available flag if slot is in the future
                        if (date.slots[i].jsstarttime > new Date()) {
                            slotsAvailable = true;
                        }
                        return false;
                    }
                }
            }
            // if we got here, none of the slotitems had availability, so return true
            return true;
        };

        /**
         * Determine if a calendar date should show the Locked button
         * @param {object} date
         */
        var getIsLocked = function( date ){
            // A Full button status will take precedence over Locked
            if( date.isFull ){
                return false;
            }
            // If the sign up is locked return true
            if( $scope.isLocked() ){
                return true;
            }
            // All slotitems for a give date will have the same locked status
            for( var i=0; i<date.slots.length; i++ ){
                for( var j=0; j<date.slots[i].slotitems.length; j++ ){
                    // See if there are any UNLOCKED slotitems; if so, the SU button is active
                    if(!date.slots[i].slotitems[j].isaddlocked){
                        return !!date.slots[i].slotitems[j].isaddlocked;
                    }
                }
            }

            // If no slots were open in the loop above, then return TRUE for "all slotitems locked"
            return true;
        };

        /**
         * Determine if a calendar date should show the Edit button
         *  True if user is signed up for any slotitem for that day, false otherwise
         * @param {object} date
         */
        var getIsUserSignedUp = function( date ){
            for( var us=0; us<arrUserSlotItems.length; us++ ){
                for( var i=0; i<date.slots.length; i++ ){
                    for( var j=0; j<date.slots[i].slotitems.length; j++ ){
                        if( date.slots[i].slotitems[j].slotitemid == arrUserSlotItems[us].slotitemid ){
                            return true;
                        }
                    }
                }
            }
            // if we got here, user is not signed up for a slotitem for this date
            return false;
        };

        /**
         * Determine if a calendar date should show the Selected button
         *  True if user has selected any slotitem for that day, false otherwise
         * @param {object} date
         */
        var getIsSelected = function( date ){
            for( var i=0; i<date.slots.length; i++ ){
                for( var j=0; j<date.slots[i].slotitems.length; j++ ){
                    // see if the slot item was already selected
                    var selectedIdx = $scope.selectedSlotItems.findIndex( function(siID){
                        return siID === date.slots[i].slotitems[j].slotitemid;
                    });
                    if( selectedIdx > -1 ){
                        return true;
                    }
                }
            }
            // if we got here, nothing on this date has been selected
            return false;
        };

        /**
         * Determine which button to show based on date's boolean inputs
         * @param {Boolean} isFull - Date is full
         * @param {Boolean} isLocked - Date is locked
         * @param {Boolean} isUserSignedUp - User has signed up for a slot item on this date
         * @param {Boolean} isSelected - User has selected a slot item on this date
         */
        var getButtonStatus = function( isFull, isLocked, isUserSignedUp, isSelected ){
            if( isSelected ){
                return 'selected';
            }
            if( isUserSignedUp ){
                return 'edit';
            }
            if( isFull ){
                return 'full';
            }
            if( isLocked ){
                return 'locked';
            }
            // otherwise
            return 'default';
        };

        /**
         * Sort arrSignUpDates by date, then time
         */
        var sortSignUpDates = function(){
            // sort by dates
            arrSignUpDates.sort(function( a, b ){
                var dtA = a.jsDateOnly;
                var dtB = b.jsDateOnly;
                if( dtA < dtB ){ return -1; }
                if( dtA > dtB ){ return 1; }
                else { return 0; }
            });
            // sort by time
            // slots within dates are already sorted by itemorder
            for( var i=0; i<arrSignUpDates.length; i++ ){
                // sort details by start time
                if( util.keyExists( arrSignUpDates[i], 'slots' ) && arrSignUpDates[i].slots.length ){
                    arrSignUpDates[i].slots.sort(function( c, d ){
                        var dtC = c.jsstarttime;
                        var dtD = d.jsstarttime;
                        if( dtC < dtD ){ return -1; }
                        if( dtC > dtD ){ return 1; }
                        else { return 0; }
                    });
                }
            }
        };

        /**
         * Get participant records for user
         *  Populates arrUserSlotItems
         */
        var setUserSignups = function(){
            if( $scope.isUserLoggedIn && util.keyExists($scope.signupInfo, 'participants') && !util.isEmptyObject($scope.signupInfo.participants) ){
                // iterate participants and find matching memberid
                angular.forEach($scope.signupInfo.participants, function( value, key ){
                    for( var i=0; i<$scope.signupInfo.participants[key].length; i++ ){
                        if( util.keyExists($scope.signupInfo.participants[key][i], 'memberid') && $scope.signupInfo.participants[key][i].memberid == $scope.memberId ){
                            arrUserSlotItems.push( $scope.signupInfo.participants[key][i] );
                        }
                    }
                });
                // order by date
                arrUserSlotItems.sort(function( a, b ){
                    var dtA = new Date( a.starttime );
                    var dtB = new Date( b.starttime );
                    if( dtA < dtB ){ return -1; }
                    if( dtA > dtB ){ return 1; }
                });
            }
        };

        /**
         * Helper method to get time label based on start and end dates in HH:MM format. Ex: "9:00am-10:30am"
         * @param {string}  start - start time
         * @param {string}  end - end time
         * @param {boolean} usetime - determines if usetime should run
         * @returns {string} formatted time or empty
         */
        var getTimeWithMinutesLabel = function( start, end, usetime ){

            var timelabel = '';

            if( usetime ){
                var dtStart = new Date(start);
                timelabel += $filter('date')(dtStart, 'shortTime').replace(' ','').toLowerCase();  // '9:00AM' -> '9:00am'
                if( end.length ){
                    var dtEnd = new Date(end);
                    timelabel += '-' + $filter('date')(dtEnd, 'h:mma').replace(' ','').toLowerCase();
                }
            }

            return timelabel;
        };

        /**
         * Sets the calendar month to display - chooses in order
         * The user-selected month (via nav buttons)
         * If the user is logged in, the month of the user's first sign up
         * The first current or future month with available slots
         * The last month that had slots (sign up expired)
         */
        var setDisplayMonth = function(){

            var d = new Date();
            // selected month
            if( angular.isDate( selectedMonth ) ){
                d = selectedMonth;
            }
            // cached value. This happens when we navigate back to the calendar from the confirmation page.
            else if( !util.isEmptyObject( svc.getDisplayMonth() ) ){
                $scope.dates = svc.getDisplayMonth();
                // Set the previous and next months from the current date in the cache before exiting.
                $scope.dates.prev = getPrevMonth($scope.dates.selected.jsDate)
                $scope.dates.next = getNextMonth($scope.dates.selected.jsDate)
                return;
            }
            // current or future available slots
            else if( slotsAvailable ){
                // get first of the month for currDate
                var currFOM = new Date( new Date( d ).toDateString() );
                currFOM.setDate(1);
                for( var i=0; i<arrSignUpDates.length; i++ ){
                    if( !arrSignUpDates[i].isFull && arrSignUpDates[i].jsDateOnly.getTime() >= currFOM.getTime() ){
                        d = arrSignUpDates[i].jsDateOnly;
                        break;
                    }
                }
            }
            // last slot
            else {
                if (arrSignUpDates.length > 0) {
                    // get last slot
                    d = arrSignUpDates[ arrSignUpDates.length - 1].jsDateOnly;
                }
            }
            var queryMonth = d.getMonth() + 1 + "-" + d.getFullYear();
            // set dates
            $scope.dates = {
                selected:  {
                    monthname: months[d.getMonth()] + ' ' + d.getFullYear().toString(),
                    jsDate: d,
                    jsFDOM: new Date(d.getFullYear(), d.getMonth(), 1),    // first day of the month
                    jsLDOM: new Date(d.getFullYear(), d.getMonth()+1, 0),    // last day of the month
                    firstdayofmonth: $scope.daysOfWeek[new Date(d.getFullYear(), d.getMonth(), 1).getDay()],
                    queryMonth: queryMonth
                },
                // set next and previous
                prev: getPrevMonth(d),
                next: getNextMonth(d)
            };
            // Set the current month string into the service cache so we can show the user their last selected month when coming back from a confirmation page
            svc.setCurrentMonth(queryMonth)
            // set cache
            svc.setDisplayMonth( $scope.dates );
        };

        /**
         * Build calendar days
         *  The calendar itself can range from 4 to 6 rows (examples: 4 - 02/2026, 6 - 05/2020)
         *  Build out array of calendar square objects based on month selected
         *  Return from memory if month has already been built
         */
        var buildCalendar = function(){
            // reset grid days
            arrGridDays = [];
            // get first day of first week - starting index
            var startingIndex = $scope.dates.selected.jsFDOM.getDay();
            // last day of the month
            var endingIndex = $scope.dates.selected.jsLDOM.getDate() + startingIndex;
            // if month already exists in Calendar data, return it

            if( util.keyExists( objCalendarCache, $scope.dates.selected.monthname ) ){
                arrGridDays = objCalendarCache[$scope.dates.selected.monthname];
            }
            else {
                // iterate all possible dates and fill out calendar - 6 rows x 7 days = 42
                for( var i=0; i<42; i++ ){
                    var objDay = util.deepCopy( objGridDayBlank );
                    if( i >= startingIndex && i < endingIndex ){
                        objDay = {
                            show: true,
                            label: i - startingIndex + 1,
                        };
                    }
                    // set day of the month
                    arrGridDays.push( objDay );
                    // break out of the loop if it's a multiple of 6 (Sat) and we are at or past the last index
                    if( (i+1) % 7 == 0 && i >= endingIndex-1 ){
                        break;
                    }
                }
                // cache it
                objCalendarCache[$scope.dates.selected.monthname] = arrGridDays;
            }
            // put sign up dates on calendar grid
            // get subset of sign up dates that are within the calendar range
            for( var j=0; j<arrSignUpDates.length; j++ ){
                if( arrSignUpDates[j].jsDateOnly.getTime() >= $scope.dates.selected.jsFDOM.getTime() && arrSignUpDates[j].jsDateOnly.getTime() <= $scope.dates.selected.jsLDOM.getTime() ){
                    // add data object to arrGridDays based on index value of sign up date-1 + starting index so that sign up date matches grid date label
                    arrGridDays[ arrSignUpDates[j].jsDateOnly.getDate()-1 + startingIndex ]['data'] = arrSignUpDates[j];
                }
            }
            $scope.calendarGrid = arrGridDays;
            // the calendar is rebuilt, lets show it to the user
            util.broadCast("isProcessing", false);
        };

        /**
         * Determine previous month, returns an object with date
         * @param {Date} currDate - Current display date
         */
        var getPrevMonth = function( currDate ){
            var prevMonth = new Date ( currDate );
            prevMonth.setDate(0);       // sets to last day of previous month
            prevMonth.setDate(1);       // sets to first day of previous month
            // get first of the month for currDate
            var currFOM = new Date( new Date( currDate ).toDateString() );
            currFOM.setDate(1);
            // Disable the previous month button if the first slot is after the current month.
            var metadata = svc.getPaginationMetadata();
            if (metadata) {
                $scope.signupInfo.prevMonthDisabled = metadata.calendarview.firstCalendarMonth.getTime() > currFOM.getTime();
            } else {
                $scope.signupInfo.prevMonthDisabled = true;
            }
            return {
                jsDate: prevMonth,
                queryMonth: prevMonth.getMonth() + 1 + "-" + prevMonth.getFullYear()
            };
        };

        /**
         * Determine next month, returns an object with date and
         * @param {Date} currDate - Current display date
         */
        var getNextMonth = function( currDate ){
            var current = new Date ( currDate );
            // Set the next month date object to the first day of the next month
            var nextFOM = new Date( current.setMonth(current.getMonth()+1, 1) );
            nextFOM.setDate(1);
            // Disable the next month button if the last slot is before the current month.
            var metadata = svc.getPaginationMetadata();
            if (metadata) {
                $scope.signupInfo.nextMonthDisabled = metadata.calendarview.lastCalendarMonth.getTime() < nextFOM.getTime();
            } else {
                $scope.signupInfo.nextMonthDisabled = true;
            }

            return {
                jsDate: nextFOM,
                queryMonth: nextFOM.getMonth() + 1 + "-" + nextFOM.getFullYear()
            };
        };

        /**
         * Prep data for UI presentation
         * Build an array of day objects
         * Update each with sign up info if relevant
         */
        var prepData = function(){
            util.broadCast("isProcessing", true);
            // get items user has signed up for
            setUserSignups();

            getSlotsForCurrentMonth()
            // Get the initial slots for the calendar
        };

        /** Makes a request to getSignUpInfo paginated by month to return slots for the calendar controller
         *
         * @param {object} optionalRequestParams An object with optional request details to send in the body of the getSignUpInfo request
         *
         */
        var getSlotsForCurrentMonth = function(optionalRequestParams) {

            additionalParams = optionalRequestParams || {};
            return svc.getsignup(Object.assign($scope.baseCalendarParams, additionalParams)).then(function(result){
                var r = util.lowerCaseKeys( result );


                if (util.ajaxResultInvalid(r)) {

                    // Stop loading and show the error
                    util.broadCast("isProcessing", false);
                    $scope.es.setError('error-top-level', util.getAjaxResponseMessage(r));


                } else {
                    // Replace the last month's slots with the next month's slots from the response, but don't overwrite any client state with server state
                    $scope.signupInfo.calendarSlots = Object.assign($scope.signupInfo.calendarSlots, r.data.data.slots)
                    // If we have metadata set it into the service cache. We do this check because if a given month has now slots metadata won't be sent.
                    if (r.data.data.slotmetadata) {
                        svc.setPaginationMetadata(r.data.data.slotmetadata);
                        $scope.signupInfo.slotMetadata = r.data.data.slotmetadata;
                        // If there are no slots on the sign up (accounting for hidden dates), hide the calendar
                        $scope.hasCalendarSlots = $scope.signupInfo.slotmetadata.totalslots > 0;
                    }
                    // Set the last and first month into state

                    // We have to rebuild the next month with the new slots, after each new set of data comes in.
                    prepSignUpDates();
                    // determine diplay month
                    setDisplayMonth();
                    buildCalendar();
                }
            });

        }


        /* Initialization method
         */
        var init = function(){
            prepData();
        };

        // kick it!
        init();

    }]);

    // Expired controller
    SUGApp.controller('signUpExpiredController',
        ['$scope','signupPageService','SUGUtilities',
        function( $scope,svc,util ) {

        $scope.errorMessage = '';
        $scope.disableForm = true;
        $scope.str = {

        };

        var init = function(){
            $scope.disableForm = false;
        };

        init();
    }]);

    // Calendar Sync controller
    SUGApp.controller('calendarSyncController',
        ['$scope','$modalInstance','$window','$timeout','signupPageService','SUGUtilities','calendar',
        function( $scope,$modalInstance,$window,$timeout,svc,util,calendar ) {
        $scope.calendar = calendar.calendar;
        $scope.errorMessage = '';
        $scope.disableForm = true;
        var entry = $scope.calendar.totalslots > 1 ? "entries" : "entry";

        $scope.str = {
            title: 'Sync Entire Sign Up to My Calendar',
            desc: '',
            basedesc:  ' Your calendar will be kept in sync as more people sign up. If you want to sync the items you signed up for, login to your SignUpGenius account and go to the "Invited To" page.'
        };
        if ($scope.calendar.numofsignups > 1) {
            $scope.str.title = 'Sync All Entries to My Calendar';
            $scope.str.desc = 'Clicking below will add <strong>'+ $scope.calendar.totalslots+' ' +$scope.calendar.showing+' ' +entry+'</strong> from the <strong>'+$scope.calendar.title+'</strong> sign ups into your personal calendar program.' + $scope.str.basedesc;
        } else {
            $scope.str.desc = 'Clicking below will add <strong>'+ $scope.calendar.totalslots+' ' +entry+'</strong> from this sign up page into your personal calendar program.' +  $scope.str.basedesc;
        }

        // handle dismissal of the modal
        $scope.dismiss = function () {
            $modalInstance.dismiss(false);
        };

        // sync to my calendar
        $scope.syncToMyCalendar = function() {
            $window.open($scope.calendar.calurl,"_self");
            $scope.dismiss();
        };

        // sync to google calendar
        $scope.syncToGoogle = function() {
            $window.open($scope.calendar.googleurl,"_blank");
            $scope.dismiss();
        };

        // toggle calendar help template
        $scope.toggleHelp = function () {
            $scope.displayHelp = true;
            $timeout(function(){
                $window.document.getElementById('inputWebcalLink').select();
                $window.document.getElementById('inputWebcalLink').focus();
            },10);
        };

        var init = function(){
            $scope.disableForm = false;
            $scope.displayHelp = false;

            // calendar help tabs
            $scope.activeCalTab = 1;
        };

        init();
    }]);

}());
